<!-- this is for below signup dependets payment info and subscrption -->
<!-- <div class="card-group"> -->
<main id="main" class="main">
  <section class="section dashboard">
    <div class="container-fluid" id="mainbody">
      <!-- <div class="row p-2">
          <span>Member Name:&nbsp;<b>{{userName}}</b></span>
        </div> -->
      <div class="row mb-5">
        <!-- My Plans -->
        <div class="col-md-8 px-md-0">
          <div class="card">
            <div class="card-header bg-headers d-flex justify-content-between align-items-center">
              <div class="text-white title">{{ lang?.My_Plans }}</div>
              <div class="" *ngIf="
                    fubsillstatus === 'Active' &&
                    customerType == 'GIG' &&
                    role == 'ADMINISTRATOR'">
                <!-- display only when done -->
                <button class="btn btn-sm text-white title" style="background-color: white;color:#142a49 ! important;"
                  (click)="addPlan()" data-bs-toggle="modal" data-bs-target="#addPlanFormModal">
                  {{lang?.Add}}&nbsp;<i class="fa fa-plus" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div class="card-body dependentDiv p-2">
              <div class="table-responsive">
                <table class="table text-nowrap" *ngIf="customerPlans?.length != 0; else noPlans">
                  <thead>
                    <tr>
                      <!-- <th>S.no</th> -->
                      <th>{{lang?.Name}}</th>
                      <th>{{lang?.Subscription_ID}}</th>
                      <th>{{lang?.Coverage}}</th>
                      <th style="text-align: center">{{lang?.Amount}}</th>
                      <th *ngIf="customerData?.isCorporateAccount === true">
                        {{lang?.Type}}
                      </th>
                      <th>{{lang?.Status}}</th>
                      <th>{{lang?.Created_Date}}</th>
                      <th>{{lang?.Activation_Date}}</th>
                      <th>Termination Date</th>
                      <!-- <th></th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let plan of customerPlans; let i = index"
                      [ngStyle]="{ background: plan.backdatedActivationDate ? 'gray' : '' }">
                      <td>
                        <i *ngIf="plan.isBulk" class=""
                      style="font-size:14px;color:rgb(31, 31, 29);font-family: system-ui;font-weight: 600;"
                      title="Bulk/Group Plan Member">B</i>
                        {{ plan.name }}&nbsp;<i *ngIf="plan.backdatePlan" class="bi bi-info-circle" title="Backdated Registration Date: {{
                              plan.backdatedActivationDate | date : 'MM-dd-yyyy'
                            }}
              Activation Date: {{ plan.activationDate | date : 'MM-dd-yyyy' }}
              Backdated Months: {{ plan.backdatedMonths }}"></i>
                      </td>
                      <td>{{ plan.subscriptionId }}</td>
                      <td>{{ plan.coverage1 }}</td>
                      <td style="text-align: right">
                        ${{ plan.total | number : "1.2-2" }}&nbsp;<i class="bi bi-info-circle"
                          title="Price:${{ plan.price }},Tax:${{ plan.tax }}"></i>
                      </td>

                      <td *ngIf="customerData?.isCorporateAccount">
                        {{ plan.type }}
                      </td>
                      <td>{{ plan.status }}</td>
                      <td>{{ plan.createdDate | date : "MM-dd-YYYY" }}</td>

                      <td>
                        {{
                        (plan.backdatePlan
                        ? plan.backdatedActivationDate
                        : plan.activationDate
                        ) | date : "MM-dd-yyyy"
                        }}
                      </td>
                      <td>
                        <span *ngIf="(plan?.terminationDate!=null);else normalstatus">
                          {{plan?.terminationDate
                          | date : "MM-dd-yyyy"}}<br><small>{{plan?.terminationReason}}</small></span>
                        <ng-template #normalstatus>
                          ---
                        </ng-template>
                      </td>
                      <td>
                        <!-- <a class="viewicon" title="View/Edit" data-toggle="tooltip" ><i class="fa fa-eye" (click)="viewBrokerCustomers(broker,i)"></i></a>&nbsp;&nbsp; -->
                        <a class="deleteicon text-black" *ngIf="
                              fubsillstatus === 'Active' &&
                              customerType == 'GIG' &&
                              role == 'ADMINISTRATOR'
                            " (click)="cancelPlanDate(plan, i)" data-bs-toggle="modal"
                          data-bs-target="#cancelPlanFormModal" title="Delete" style="cursor: pointer"
                          data-toggle="tooltip"><i style="color: red" class="bi bi-trash-fill"></i></a>&nbsp;&nbsp;
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <ng-template #noPlans>
              <div class="row" style="margin-left: 5px; margin-bottom: 10px">
                <span class="text-center">{{lang?.No_Active_plans}}</span>
              </div>
            </ng-template>
            <!-- <div class="row" style="margin-left:5px;margin-bottom:10px;">
                      <span>{{lang?.No_Active_plans}} </span>
                    </div> -->
          </div>
        </div>
        <!-- Member Support -->
        <div class="col-md-4 px-md-0" *ngIf="advisortype == 'CORPORATE'">
          <div class="row card dependentDiv1">
            <div class="col-md-6 px-md-0">
              <div class="card-header bg-headers d-flex justify-content-between align-items-center" id="cardheader">
                <span class="text-white title">{{ lang?.Member_Support }}</span>

                <!-- <i class="fa fa-id-card-o fa-lg" aria-hidden="true"></i> -->
              </div>
              <div class="card-body p-2">
                <!-- <div class="is-loading" *ngIf="restLoader"><p></p></div>
                  <div class="is-loading" *ngIf="restLoader"><p></p></div>
                  <div class="is-loading" *ngIf="restLoader"><p></p></div>
                  <div *ngIf="!restLoader"> -->
                <div>
                  <div class="row">
                    <div class="col-1">
                      <img src="/assets/img/planholder.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                        data-bs-placement="top" title="{{ lang?.Name }}" />
                    </div>
                    <div class="col-10 mt-auto primaryInfoLabels">
                      {{ advisor?.name }} &nbsp;
                      <!-- <i data-bs-toggle="modal"
                        data-bs-target="#changeAdvisor"
                         class="fa fa-pencil" title="Change Advisor" aria-hidden="true" style="cursor:pointer" (click)="viewadvisorData()"></i> -->
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-1">
                      <img src="/assets/img/tel.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                        data-bs-placement="top" title="{{ lang?.Telephone }}" />
                    </div>
                    <div class="col-10 mt-auto primaryInfoLabels">
                      {{ advisor?.phone }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-1">
                      <img src="/assets/img/email.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                        data-bs-placement="top" title="{{ lang?.Email }}" />
                    </div>
                    <div class="col-10 mt-auto primaryInfoLabels">
                      {{ advisor?.email }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 px-md-0" style="border-left: 2px solid #142a49">
              <div class="card-header bg-headers d-flex justify-content-between align-items-center" id="cardheader">
                <span class="text-white title">{{lang?.Corporate_Details}}</span>
                <!-- <i class="fa fa-id-card-o fa-lg" aria-hidden="true"></i> -->
              </div>
              <div class="card-body p-2">
                <div>
                  <div class="row">
                    <div class="col-1">
                      <img src="/assets/img/planholder.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                        data-bs-placement="top" title="{{ lang?.Name }}" />
                    </div>
                    <div class="col-10 mt-auto primaryInfoLabels">
                      {{ corporateDetails?.name }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-1">
                      <img src="/assets/img/tel.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                        data-bs-placement="top" title="{{ lang?.Telephone }}" />
                    </div>
                    <div class="col-10 mt-auto primaryInfoLabels">
                      {{ corporateDetails?.phone }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-1">
                      <img src="/assets/img/email.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                        data-bs-placement="top" title="{{ lang?.Email }}" />
                    </div>
                    <div class="col-10 mt-auto primaryInfoLabels">
                      {{ corporateDetails?.email }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row card">
            <div class="col-md-12 px-md-0">
              <div class="card-header bg-headers d-flex justify-content-between align-items-center" id="cardheader">
                <div class="text-white title w-100">{{lang?.Customer_Details}}</div>
                <a *ngIf="
                      (fubsillstatus == 'Active' || fubsillstatus == 'Draft') &&
                      (role === 'ADMINISTRATOR' || role === 'BROKER')
                    " class="viewicon" title="Terminate" data-toggle="tooltip" style="cursor: pointer"><i
                    class="fa fa-trash-o pe-1" style="color: red; font-size: 15px; font-weight: 700"
                    (click)="terminatemember()"></i></a>&nbsp;
                <!-- <i class="fa fa-id-card-o fa-lg" aria-hidden="true"></i> -->
              </div>
              <div class="card-body dependentDiv2 p-2">
                <div>
                  <table class="table text-nowrap" style="font-size: 12px">
                    <tbody>
                      <tr class=" ">
                        <td class="border-right">{{lang?.IGBMS_Id}}</td>
                        <!-- <td>{{ fusebillId }}</td> -->
                        <td>{{ igbmsId }}</td>
                        <!-- added for space between rows -->
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr class=" ">
                        <td class="border-right">{{lang?.Status}}</td>
                        <td>{{ fubsillstatus }}</td>
                      </tr>
                      <tr class=" ">
                        <td class="border-right">{{lang?.Customer_Type}}</td>
                        <td>{{ customerType }}</td>
                      </tr>
                      <tr class=" " *ngIf="customerType == 'CORP'">
                        <td class="border-right">{{lang?.Stax_Account_Type}}</td>
                        <td>
                          {{ customerData?.childAccount ? "Child" : "Parent" }}
                        </td>
                      </tr>
                      <tr class=" " *ngIf="!customerData?.backdatedRegistration">
                        <td class="border-right">{{lang?.Registration_Date}}</td>
                        <td>
                          {{
                          customerData?.registrationDate | date : "MM-dd-yyyy"
                          }}
                        </td>
                      </tr>
                      <tr class=" " *ngIf="customerData?.backdatedRegistration">
                        <td class="border-right">
                          {{lang?.Backdated_Registration_Date}}
                        </td>
                        <td>
                          {{
                          customerData?.enrollmentDate | date : "MM-dd-yyyy"
                          }}
                        </td>
                      </tr>
                      <tr class=" ">
                        <td class="border-right">{{lang?.Plan_Enrollment_Date}}</td>
                        <td>
                          {{
                          customerData?.enrollmentDate | date : "MM-dd-yyyy"
                          }}
                        </td>
                      </tr>
                      <ng-container *ngIf="executivePlanOptions && executivePlanOptions.length>0">
                        <tr class=" " *ngFor="let plan of executivePlanOptions; let i = index">
                          <td class="border-right"
                            *ngIf="plan.planOptions.name=='Please select your preferred Executive Assessment Clinic'">
                            Executive Assessment Clinic</td>
                          <td class="border-right"
                            *ngIf="plan.planOptions.name=='Opt In - Activate My Year-Round Family Virtual Care (included) '">
                            Year-Round Family Virtual Care Activation</td>
                          <td>
                            {{ plan.planOptionsValue }}

                            <i data-bs-toggle="modal" data-bs-target="#updateExecutiveOptions"
                              (click)="updateExecutiveoptions(plan)" class="fa fa-pencil" aria-hidden="true"
                              style="cursor:pointer"></i>

                          </td>
                        </tr>
                      </ng-container>
                      <tr *ngIf="
                            customerData?.serviceType?.greenShieldCustomer &&
                            customerData?.serviceType.status != 'PENDING'
                          " class=" ">
                        <td class="border-right">{{lang?.GreenShield_Member_Id}}</td>
                        <td>{{ customerData?.serviceType.id ?? "-" }}</td>
                      </tr>
                      <tr *ngIf="customerData?.serviceType?.greenShieldCustomer">
                        <td class="border-right">{{lang?.GreenShield_Member_Status}}</td>
                        <td>
                          {{ customerData?.serviceType.status ?? "-" }}
                        </td>
                      </tr>
                      <tr *ngIf="
                            customerData?.serviceType?.equitableCustomer &&
                            customerData?.serviceType.status != 'PENDING'
                          " class=" ">
                        <td class="border-right">{{lang?.Equitable_Member_Id}}</td>
                        <td>{{ customerData?.serviceType.id ?? "-" }}</td>
                      </tr>
                      <tr *ngIf="customerData?.serviceType?.equitableCustomer">
                        <td class="border-right">{{lang?.Equitable_Member_Status}}</td>
                        <td>
                          {{ customerData?.serviceType.status ?? "-" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <div class=" d-flex gap-5 ">
                                          <div class=" my-auto primaryInfoLabels ">
                                              Id
                                          </div>
                                          <div class=" my-auto primaryInfoLabels ">
                                              {{fusebillId}}
                                          </div>
                                      </div>
                                      <div class=" d-flex gap-5">
                                          <div class=" my-auto primaryInfoLabels">
                                              Status
                                          </div>
                                          <div class=" my-auto primaryInfoLabels">{{fubsillstatus}}</div>
                                      </div>
                                      <div class="d-flex gap-5">
                                          <div class="my-auto primaryInfoLabels">
                                              Customer Type
                                          </div>
                                          <div class="my-auto primaryInfoLabels">
                                              {{customerType}}
                                          </div>
                                      </div>
                                      <div class="d-flex gap-5">
                                          <div class="my-auto primaryInfoLabels">
                                              Account Type
                                          </div>
                                          <div class="my-auto primaryInfoLabels">
                                              {{customerData?.childAccount? 'Child':'Parent'}}
                                          </div>
                                      </div>
                                      <div class="d-flex gap-5">
                                          <div class="my-auto primaryInfoLabels">
                                              Registration Date
                                          </div>
                                          <div class="my-auto primaryInfoLabels">
                                              {{customerData?.registrationDate}}
                                          </div>
                                      </div>
                                      <div class="d-flex gap-5">
                                          <div class="my-auto primaryInfoLabels">
                                              Plan Enrollment Date
                                          </div>
                                          <div class="my-auto primaryInfoLabels">
                                              {{customerData?.enrollmentDate |date:'MM-dd-yyyy'}}
                                          </div>
                                      </div>


                                      <div *ngIf="customerData?.serviceType?.greenShieldCustomer">
                                          <div class="d-flex justify-content-between"
                                              *ngIf="customerData?.serviceType.status!='PENDING'">
                                              <div class="my-auto primaryInfoLabels">
                                                  GreenShield Member-Id
                                              </div>
                                              <div class="my-auto primaryInfoLabels">
                                                  {{customerData?.serviceType.id}}
                                              </div>
                                          </div>
                                          <div class="d-flex justify-content-between">
                                              <div class="my-auto primaryInfoLabels">
                                                  GreenShield Member-Status
                                              </div>
                                              <div class="my-auto my-auto primaryInfoLabels ">
                                                  {{customerData?.serviceType.status ?? '-'}}
                                              </div>
                                          </div>
                                      </div>
                                      <div *ngIf="customerData?.serviceType.equitableCustomer">
                                          <div class="d-flex justify-content-between">
                                              <div class="my-auto primaryInfoLabels"
                                                  *ngIf="customerData?.serviceType.status!='PENDING'">
                                                  Equitable Member-Id
                                              </div>
                                              <div class="my-auto primaryInfoLabels">
                                                  {{customerData?.serviceType.id}}
                                              </div>
                                          </div>
                                          <div class="d-flex justify-content-between">
                                              <div class="my-auto primaryInfoLabels">
                                                  Equitable Member-Status
                                              </div>
                                              <div class="my-auto my-auto primaryInfoLabels ">
                                                  {{customerData?.serviceType.status ?? '-'}}
                                              </div>
                                          </div>
                                      </div> -->
                </div>
              </div>
            </div>
            <!-- <div class="col-md-6 px-md-0" style="border-left:2px solid #142A49">
                              <div class="card-header bg-headers d-flex justify-content-between align-items-center"
                                  id="cardheader">
                                  <span class="text-white title">Other Details</span>
                              </div>
                              <div class="card-body p-2">
                                  <div>
                                      <div class="d-flex justify-content-between">
                                          <div class="my-auto primaryInfoLabels">
                                              Customer Type
                                          </div>
                                          <div class="my-auto primaryInfoLabels">
                                              {{customerType}}
                                          </div>
                                      </div>
                                      <div class="d-flex justify-content-between ">
                                          <div class="my-auto primaryInfoLabels">
                                              Status
                                          </div>
                                          <div class="my-auto primaryInfoLabels">{{fubsillstatus}}</div>
                                      </div>
                                  </div>
                              </div>
                          </div> -->
          </div>
        </div>
        <div class="col-md-4 px-md-0" *ngIf="advisortype != 'CORPORATE'">
          <div class="row card dependentDiv1">
            <div class="card-header bg-headers d-flex justify-content-between align-items-center" id="cardheader">
              <span class="text-white title w-100">{{
                lang?.Member_Support
                }}</span>
            </div>
            <div class="card-body p-2">
              <!-- <div class="is-loading" *ngIf="restLoader"><p></p></div>
                <div class="is-loading" *ngIf="restLoader"><p></p></div>
                <div class="is-loading" *ngIf="restLoader"><p></p></div>
                <div *ngIf="!restLoader"> -->
              <div>
                <div class="row">
                  <div class="col-1">
                    <img src="/assets/img/planholder.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="{{ lang?.Name }}" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ advisor?.name }}&nbsp;
                    <!-- <i data-bs-toggle="modal"
                      data-bs-target="#changeAdvisor"
                       class="fa fa-pencil" title="Change Advisor" aria-hidden="true" style="cursor:pointer" (click)="viewadvisorData()"></i> -->
                  </div>
                </div>
                <div class="row">
                  <div class="col-1">
                    <img src="/assets/img/tel.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="{{ lang?.Telephone }}" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ advisor?.phone }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-1">
                    <img src="/assets/img/email.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                      data-bs-placement="top" title="{{ lang?.Email }}" />
                  </div>
                  <div class="col-10 mt-auto primaryInfoLabels">
                    {{ advisor?.email }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row card">
            <div class="col-md-12 px-md-0">
              <div class="card-header bg-headers d-flex justify-content-between align-items-center" id="cardheader">
                <div class="text-white title w-100">{{lang?.Customer_Details}}</div>
                <a *ngIf="
                      (fubsillstatus == 'Active' || fubsillstatus == 'Draft') &&
                      (role === 'ADMINISTRATOR' || role === 'BROKER')
                    " class="viewicon" title="Terminate" data-toggle="tooltip" style="cursor: pointer"><i
                    class="fa fa-trash-o pe-1" style="color: red; font-size: 15px; font-weight: 700"
                    (click)="terminatemember()"></i></a>&nbsp;
                <!-- <i class="fa fa-id-card-o fa-lg" aria-hidden="true"></i> -->
              </div>
              <div class="card-body dependentDiv2 p-2">
                <table class="table text-nowrap" style="font-size: 12px">
                  <tbody>
                    <tr class=" ">
                      <td class="border-right">{{lang?.IGBMS_Id}}</td>
                      <!-- <td>{{ fusebillId }}</td> -->
                      <td>{{ igbmsId }}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class=" ">
                      <td class="border-right">{{lang?.Status}}</td>
                      <td>{{ fubsillstatus }}</td>
                    </tr>
                    <tr class=" ">
                      <td class="border-right">{{lang?.Customer_Type}}</td>
                      <td>{{ customerType }}</td>
                    </tr>
                    <tr class=" " *ngIf="customerType == 'CORP'">
                      <td class="border-right">{{lang?.Stax_Account_Type}}</td>
                      <td>
                        {{ customerData?.childAccount ? "Child" : "Parent" }}
                      </td>
                    </tr>
                    <tr class=" " *ngIf="!customerData?.backdatedRegistration">
                      <td class="border-right">{{lang?.Registration_Date}}</td>
                      <td>
                        {{
                        customerData?.registrationDate | date : "MM-dd-yyyy"
                        }}
                      </td>
                    </tr>
                    <tr class=" " *ngIf="customerData?.backdatedRegistration">
                      <td class="border-right">{{lang?.Backdated_Registration_Date}}</td>
                      <td>
                        {{ customerData?.enrollmentDate | date : "MM-dd-yyyy" }}
                      </td>
                    </tr>
                    <tr class=" ">
                      <td class="border-right">{{lang?.Plan_Enrollment_Date}}</td>
                      <td>
                        {{ customerData?.enrollmentDate | date : "MM-dd-yyyy" }}
                      </td>
                    </tr>
                    <ng-container *ngIf="executivePlanOptions && executivePlanOptions.length>0">
                      <tr class=" " *ngFor="let plan of executivePlanOptions; let i = index">
                        <td class="border-right"
                          *ngIf="plan.planOptions.name=='Please select your preferred Executive Assessment Clinic'">
                          Executive Assessment Clinic</td>
                        <td class="border-right"
                          *ngIf="plan.planOptions.name=='Opt In - Activate My Year-Round Family Virtual Care (included) '">
                          Year-Round Family Virtual Care Activation</td>
                        <td>
                          {{ plan.planOptionsValue }}

                          <i data-bs-toggle="modal" data-bs-target="#updateExecutiveOptions"
                            (click)="updateExecutiveoptions(plan)" class="fa fa-pencil" aria-hidden="true"
                            style="cursor:pointer"></i>

                        </td>
                      </tr>
                    </ng-container>
                    <!-- <ng-container *ngIf="addOptions==true">
                      <tr>
                        <td>Add Exccutive options</td>
                      </tr>
                    </ng-container> -->
                    <tr *ngIf="
                          customerData?.serviceType?.greenShieldCustomer &&
                          customerData?.serviceType.status != 'PENDING'
                        " class=" ">
                      <td class="border-right">{{lang?.GreenShield_Member_Id}}</td>
                      <td>{{ customerData?.serviceType.id ?? "-" }}</td>
                    </tr>
                    <tr *ngIf="customerData?.serviceType?.greenShieldCustomer">
                      <td class="border-right">{{lang?.GreenShield_Member_Status}}</td>
                      <td>
                        {{ customerData?.serviceType.status ?? "-" }}
                      </td>
                    </tr>
                    <tr *ngIf="
                          customerData?.serviceType?.equitableCustomer &&
                          customerData?.serviceType.status != 'PENDING'
                        " class=" ">
                      <td class="border-right">{{lang?.Equitable_Member_Id}}</td>
                      <td>{{ customerData?.serviceType.id ?? "-" }}</td>
                    </tr>
                    <tr *ngIf="customerData?.serviceType?.equitableCustomer">
                      <td class="border-right">{{lang?.Equitable_Member_Status}}</td>
                      <td>
                        {{ customerData?.serviceType.status ?? "-" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div>
            <div class=" d-flex justify-content-between">
              <div class=" my-auto primaryInfoLabels">
                Id
              </div>
              <div class=" my-auto primaryInfoLabels">
                {{fusebillId}}
              </div>
            </div>
            <div class=" d-flex justify-content-between">
              <div class=" my-auto primaryInfoLabels">
                Status
              </div>
              <div class=" my-auto primaryInfoLabels">{{fubsillstatus}}</div>
            </div>
            <div class="d-flex justify-content-between">
              <div class="my-auto primaryInfoLabels">
                Customer Type
              </div>
              <div class="my-auto primaryInfoLabels">
                {{customerType}}
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div class="my-auto primaryInfoLabels">
                Registration Date
              </div>
              <div class="my-auto primaryInfoLabels">
                {{customerData?.registrationDate}}
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div class="my-auto primaryInfoLabels">
                Plan Enrollment Date
              </div>
              <div class="my-auto primaryInfoLabels">
                {{customerData?.enrollmentDate |date:'MM-dd-yyyy'}}
              </div>
            </div>
            <div *ngIf="customerData?.serviceType.greenShieldCustomer">
              <div class="d-flex justify-content-between"
                *ngIf="customerData?.serviceType.status!='PENDING'">
                <div class="my-auto primaryInfoLabels">
                  GreenShield Customer-Id
                </div>
                <div class="my-auto primaryInfoLabels">
                  {{customerData?.serviceType.id}}
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <div class="my-auto primaryInfoLabels">
                  GreenShield Customer-Status
                </div>
                <div class="my-auto my-auto primaryInfoLabels">
                  {{customerData?.serviceType.status ?? '-'}}
                </div>
              </div>
            </div>
            <div *ngIf="customerData?.serviceType.equitableCustomer">
              <div class="d-flex justify-content-between">
                <div class="my-auto primaryInfoLabels"
                  *ngIf="customerData?.serviceType.status!='PENDING'">
                  Equitable Customer-Id
                </div>
                <div class="my-auto primaryInfoLabels">
                  {{customerData?.serviceType.id}}
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <div class="my-auto primaryInfoLabels">
                  Equitable Customer-Status
                </div>
                <div class="my-auto my-auto primaryInfoLabels ">
                  {{customerData?.serviceType.status ?? '-'}}
                </div>
              </div>
            </div>
          </div> -->
              </div>
            </div>
            <!-- <div class="col-md-6 px-md-0" style="border-left:2px solid #142A49">
          <div class="card-header bg-headers d-flex justify-content-between align-items-center"
            id="cardheader">
            <span class="text-white title">Other Details</span>
          </div>

          <div class="card-body p-2">
            <div>
              <div class="d-flex justify-content-between">
                <div class="my-auto primaryInfoLabels">
                  Customer Type
                </div>
                <div class="my-auto primaryInfoLabels">
                  {{customerType}}
                </div>
              </div>
              <div class="d-flex justify-content-between ">
                <div class="my-auto primaryInfoLabels">
                  Status
                </div>
                <div class="my-auto primaryInfoLabels">{{fubsillstatus}}</div>
              </div>
            </div>
          </div>
        </div> -->
          </div>
        </div>
        <!-- Downloads -->
        <div class="col-md-4 col-xxl-3 px-md-0">
          <div class="card">
            <div class="card-header bg-headers d-flex justify-content-between align-items-center">
              <span class="text-white title">{{ lang?.Downloads }}</span>
              <!-- <span class="text-white">{{currentIndex}} of 3</span> -->
              <span id="downloadall" class="title">
                <img src="/assets/img/download2.png" role="button" width="45%" data-bs-toggle="tooltip"
                  data-bs-placement="top" title="Download All" (click)="downloadAllHpBooklets()" />
              </span>
            </div>
            <div class="card-body dependentDiv p-2">
              <section id="tranding">
                <div class="container"></div>
                <div class="container">
                  <div class="swiper tranding-slider">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide tranding-slide">
                        <div class="card activecard">
                          <div class="card-header p-0">
                            <div class="imagetext">
                              <span>{{ lang?.Member_Booklets }}</span>
                            </div>
                            <img id="image" *ngIf="
                                  logo?.booklets.image != '';
                                  else backgroundImage
                                "
                              src="{{ logo?.booklets.image ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/Booklets.png' }}"
                              width="100%" />
                            <ng-template #backgroundImage>
                              <div>
                                <img id="image"
                                  src="{{ logo?.booklets.image ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/Booklets.png' }}"
                                  width="100%" />
                              </div>
                            </ng-template>
                          </div>
                          <div class="card-body py-2 px-1" id="scrollcard1">
                            <div class="is-loading" *ngIf="restLoader">
                              <p class="mb-2"></p>
                            </div>
                            <div class="is-loading" *ngIf="restLoader">
                              <p class="mb-2"></p>
                            </div>
                            <div class="is-loading" *ngIf="restLoader">
                              <p class="mb-2"></p>
                            </div>
                            <div class="planBody" *ngIf="!restLoader">
                              <div class="row mb-1" *ngFor="let booklet of bookletList">
                                <div class="col-9 carousellabels">
                                  <div>{{ booklet.name }}</div>
                                  <!-- <div>{{booklet.description}}</div> -->
                                </div>
                                <div class="col-3 d-flex ps-0">
                                  <img src="/assets/img/view2.png" id="viewing" role="button" data-bs-toggle="modal"
                                    data-bs-target="#hpbooklet" data-bs-placement="top" title="{{lang?.View}}"
                                    (click)="viewBooklet(booklet.link)" />&nbsp;
                                  <img src="/assets/img/download2.png" id="viewing" role="button"
                                    data-bs-toggle="tooltip" data-bs-placement="top" title="{{lang?.Download}}"
                                    (click)="downloadHpbooklet(booklet)" />
                                </div>
                                <!-- <div class="card-footer corosalfooter py-0" >
                      <div class="row">
                        <div class="col-12 text-right">
                          <button id="uploadData" class="btn btn-sm"
                          data-bs-toggle="modal" data-bs-target="#invoiceDraftDetails" (click)="getDraftInvoice()">Upload&nbsp;<i class="fa fa-upload" aria-hidden="true"></i></button>
                        </div>
                      </div>
                    </div> -->
                                <!-- <div class="col-1 px-2">
                      <img src="/assets/img/download2.png" id="viewing"
                        role="button" (click)="downloadHpbooklet(booklet)">
                    </div> -->
                              </div>
                              <div *ngIf="bookletList.length==0" class="text-center">
                                <small>No Booklets available.</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="swiper-slide tranding-slide">
                        <div class="card activecard">
                          <div class="card-header p-0">
                            <div class="imagetext">
                              <span>{{ lang?.Membership_Cards }}</span>
                            </div>
                            <img id="image" *ngIf="
                                  logo?.healthCards?.image != '';
                                  else backgroundImage
                                "
                              src="{{ logo?.healthCards?.image ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/MemberIDCards.png' }}"
                              width="100%" />
                            <ng-template #backgroundImage>
                              <div>
                                <img id="image"
                                  src="{{ logo?.healthCards?.image ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/MemberIDCards.png'}}"
                                  width="100%" />
                              </div>
                            </ng-template>
                          </div>
                          <div class="card-body py-2 px-1" id="scrollcard1">
                            <div class="is-loading" *ngIf="restLoader">
                              <p class="mb-2"></p>
                            </div>
                            <div class="is-loading" *ngIf="restLoader">
                              <p class="mb-2"></p>
                            </div>
                            <div class="is-loading" *ngIf="restLoader">
                              <p class="mb-2"></p>
                            </div>
                            <div class="planBody" *ngIf="!restLoader">
                              <div class="downloads">
                                <div class="row">
                                  <div *ngFor="let hic of hicList" class="d-flex">
                                    <div class="col-9 carousellabels">
                                      <div class="text-capitalize">{{ hic.name }}</div>
                                    </div>
                                    <div class="col-3 d-flex ps-0">
                                      <img src="/assets/img/view2.png" id="viewing" role="button" data-bs-toggle="modal"
                                        data-bs-target="#hicDetails" data-bs-placement="top" title="{{lang?.View}}"
                                        (click)="viewHealthCard(hic)" />&nbsp;
                                      <img src="/assets/img/download2.png" id="viewing" role="button"
                                        data-bs-toggle="tooltip" data-bs-placement="top" title="{{lang?.Download}}"
                                        (click)="downloadHic(hic)" />
                                    </div>
                                  </div>

                                  <div class="card-footer corosalfooter py-0">
                                    <div class="row">
                                      <div class="col-12 text-right">
                                        <button id="uploadData" class="btn btn-sm" data-bs-toggle="modal"
                                          data-bs-target="#healthCardDropdown" (click)="getHealthCards()">
                                          {{lang?.Upload_Membership_Card}}&nbsp;<i class="fa fa-upload"
                                            aria-hidden="true"></i>
                                        </button>
                                      </div>
                                    </div>
                                    <div *ngIf="displayCardsMessage">
                                      {{lang?.Your_card_will_be_available_from}}
                                      {{
                                      customerData?.enrollmentDate
                                      | date : "MM-dd-yyyy"
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="swiper-slide tranding-slide">
                        <div class="card activecard">
                          <div class="card-header p-0">
                            <div class="imagetext">
                              <span>{{ lang?.My_Applications }}</span>
                            </div>
                            <img id="image" *ngIf="
                                  logo?.roe.image != '';
                                  else backgroundImage
                                "
                              src="{{ logo?.roe.image ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/MyApplications.png' }}"
                              width="100%" />
                            <ng-template #backgroundImage>
                              <div>
                                <img id="image"
                                  src="{{ logo?.roe.image ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/MyApplications.png' }}"
                                  width="100%" />
                              </div>
                            </ng-template>
                          </div>
                          <div class="card-body py-2 px-1" id="scrollcard1">
                            <div class="is-loading" *ngIf="restLoader">
                              <p class="mb-2"></p>
                            </div>
                            <div class="is-loading" *ngIf="restLoader">
                              <p class="mb-2"></p>
                            </div>
                            <div class="is-loading" *ngIf="restLoader">
                              <p class="mb-2"></p>
                            </div>
                            <div class="planBody" *ngIf="!restLoader">
                              <div class="downloads">
                                <div class="row">
                                  <div *ngFor="let r of roeUrl; let i = index" class="d-flex gap-1">
                                    <div class="col-9 carousellabels">
                                      <div>
                                        {{ lang?.Record_of_Enrollment }}
                                      </div>
                                      <span>{{
                                        r.time | date : "MM-dd-yyyy"
                                        }}</span>
                                    </div>
                                    <div class="col-3 d-flex ps-0">
                                      <img src="/assets/img/view2.png" id="viewing" role="button" data-bs-toggle="modal"
                                        data-bs-target="#roe" data-bs-placement="top" title="View"
                                        (click)="getRoe(i)" />&nbsp;
                                      <img src="/assets/img/download2.png" id="viewing" role="button"
                                        data-bs-toggle="tooltip" data-bs-placement="top" title="Download"
                                        (click)="downloadRoe(i)" />
                                    </div>
                                  </div>
                                  <div class="d-flex gap-1" *ngIf="padAgreement">
                                    <div class="col-9 carousellabels">
                                      <div>
                                        Pre Authorized Debit (PAD)
                                      </div>

                                    </div>
                                    <div class="col-3 d-flex ps-0">
                                      <img src="/assets/img/view2.png" id="viewing" role="button" data-bs-toggle="modal"
                                        data-bs-target="#padagreement" data-bs-placement="top" title="View" />&nbsp;
                                      <img src="/assets/img/download2.png" id="viewing" role="button"
                                        data-bs-toggle="tooltip" data-bs-placement="top" title="Download"
                                        (click)="downloadPAD(padAgreement)" />
                                    </div>
                                  </div>
                                  <div class="card-footer corosalfooter py-0">
                                    <div class="row">
                                      <div class="col-12 d-flex justify-content-center text-right">
                                        <!-- <button id="uploadData" id="uploadButtonExcel" >
                          <label for="uploadButton" id="uploadButtonExcel">
                            <i class="bi bi-upload"></i>&nbsp;Upload ROE
                            <input type="file"  #myFileInput id="uploadRoe" style="display: none" (change)="uploadRoe($event)">                                                        </label>
                          </button> -->
                                        <!-- <label for="uploadButton" id="uploadButtonExcel">
                          <i class="bi bi-upload"></i>&nbsp;Upload ROE
                          <input id="uploadButton" #myFileInput  style="display: none" type="file" (input)="uploadRoe($event)" />
                          </label> -->
                                        <!-- <input
                                            type="file"
                                            #myFileInput
                                            id="uploadRoe12"
                                            (change)="uploadRoe($event)"
                                          /> -->
                                        <button id="uploadData" class="btn btn-sm" data-bs-toggle="modal"
                                          data-bs-target="#myApplicationsModal" (click)="myApplicationsModal()">
                                          Upload File&nbsp;<i class="fa fa-upload" aria-hidden="true"></i>
                                        </button>
                                        <!-- <div class="card-footer corosalfooter py-0">
                                              <div class="row">
                                                <div class="col-12 text-right">
                                                  <button id="uploadData" class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#healthCardDropdown"
                                                    (click)="getHealthCards()">
                                                    Uplaod My Applications&nbsp;<i class="fa fa-upload" aria-hidden="true"></i>
                                                  </button>
                                                </div>
                                              </div>

                                            </div> -->
                                      </div>
                                    </div>
                                  </div>
                                  <!-- <div class="col-2 px-0">
                      <img src="/assets/img/download2.png" id="viewing"
                        role="button" data-bs-toggle="tooltip"
                        data-bs-placement="top" title="Download" (click)="downloadRoe()">&nbsp;
                      </div> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="tranding-slider-control">
                      <div class="swiper-button-prev slider-arrow">
                        <i class="fa fa-angle-left" style="font-size: 20px"></i>
                      </div>
                      <div class="swiper-button-next slider-arrow">
                        <i class="fa fa-angle-right" style="font-size: 20px"></i>
                      </div>
                      <div class="swiper-pagination"></div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <!-- Invoices -->
        <div class="col-md-4 col-xxl-3 px-md-0">
          <div class="card">
            <div class="card-header bg-headers d-flex justify-content-between align-items-center">
              <span class="text-white title">{{ lang?.Invoices }}</span>
              <div class="dropdown">
                <!-- Custom dropdown toggle -->
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                  data-bs-toggle="dropdown" aria-expanded="false">
                  {{ filterInvoice === 'Custom' ? 'Custom' : filterInvoice || 'Select Year' }}
                </button>

                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <li><a class="dropdown-item" (click)="filterInvoice = 'All'; filterInvoices()">All</a></li>
                  <li><a class="dropdown-item"
                      (click)="filterInvoice = currentYear-1; filterInvoices()">{{currentYear-1}}</a></li>
                  <li><a class="dropdown-item"
                      (click)="filterInvoice = currentYear; filterInvoices()">{{currentYear}}</a></li>
                  <li><a class="dropdown-item"
                      (click)="filterInvoice = currentYear+1; filterInvoices()">{{currentYear+1}}</a></li>
                  <li><a class="dropdown-item" (click)="onCustomClick($event)">Custom</a></li>

                  <!-- Custom date input -->
                  <li class="dropdown-item">
                    <div *ngIf="filterInvoice === 'Custom'">
                      <input type="text" id="filterDateSelection" [(ngModel)]="filterDateSelection" class="form-control"
                        placeholder="Select Month" bsDaterangepicker
                        [bsConfig]="{ dateInputFormat: 'MMM YYYY', minMode: 'month', showWeekNumbers: false }"
                        [maxDate]="maxDateForPicker" (ngModelChange)="CustomInvoiceFilter()" />
                    </div>
                  </li>
                </ul>
              </div>

              <!-- <i class="fa fa-id-card-o fa-lg" aria-hidden="true"></i> -->
            </div>
            <div class="card-body dependentDiv p-2">
              <!-- <div class="row ">
              <div class="form-group col-4 pe-0">
                <div class="text-nowrap"><label class="primaryInfoLabels"><b>Invoice #</b></label></div>
                <div class="text-nowrap primaryInfoLabels">{{customerData?.invoices.invoice}}</div>
              </div>
              <div class="form-group col-4 px-0">
                <div class="text-nowrap "><label class="primaryInfoLabels"><b>Due Date</b></label></div>
                <div class="text-nowrap primaryInfoLabels">{{customerData?.invoices.dueDate}}</div>
              </div>
              <div class="form-group col-4 px-0">
                <div class="text-nowrap"><label class="primaryInfoLabels"><b>Amount</b></label></div>
                <div class="text-nowrap primaryInfoLabels">{{customerData?.invoices.amount }}</div>
              </div>
            </div> -->
              <!-- <div class="row">
              <div class="col-md-12 text-center py-3">
                <div *ngIf="(upcomingInvoice | json)=='{}'">No Upcoming Details</div>
              </div>
            </div> -->
              <div class="card subcardheight shadow" id="invoicecard">
                <div class="card-header p-0">
                  <!-- <span class="imagetext2">
                    <p>Configuration</p>
                    <p>Send emails to (default email address)</p>
                  </span> -->
                  <img id="singlecardimage"
                    src="{{ logo?.invoice?.image ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/Invoices.png' }}"
                    width="100%" />
                </div>
                <div class="card-body" style="overflow-y: scroll">
                  <div class="is-loading" *ngIf="restLoader">
                    <p class="mb-2 mx-0"></p>
                  </div>
                  <div class="is-loading" *ngIf="restLoader">
                    <p class="mb-2 mx-0"></p>
                  </div>
                  <div *ngIf="
                        showinvoiceMessage &&
                        customerType == 'CORP' &&
                        ischildAccount &&
                        !restLoader
                      ">
                    <small>{{lang?.Invoices_available_at_the_company_level}}</small>
                  </div>
                  <div *ngIf="!showinvoiceMessage && !restLoader" class="row">
                    <div class="d-flex flex-wrap mt-1" *ngIf="
                          customerFinalInvoices &&
                            customerFinalInvoices.length > 0;
                          else showdraftinvoice
                        ">
                      <!-- <div class="my-auto col-7 primaryInfoLabels row">
                  <span class="col-9" style="padding-left: 22px;">
                    {{getCustomerDraftDate}}<br>(Draft)</span>
                  <span class="col-1 justify-content-end p-draft "><img role="button"
                    src="/assets/img/view.png" alt="" width="20px" height="20px"
                    id="viewing" role="button" data-bs-toggle="modal"
                    data-bs-target="#viewinvoiceDraftIGBMS" data-bs-placement="top"
                    title="View"></span>
                </div> -->
                      <div class="col-12" *ngFor="let invoice of customerFinalInvoices; let i = index">
                        <div class="row primaryInfoLabels my-1">

                            <div 
                              class="col-9" 
                              style="margin-left: 0px" 
                              [ngStyle]="{
                                color: invoice.status == 'PAID' ? 'green' : 
                                (invoice.status == 'OVERDUE' ? 'red' : 
                                (invoice.status == 'POST' ? 'orange' : 
                                (invoice.status == 'VOID' ? 'rgb(93, 124, 155)':
                                (invoice.status == 'DRAFT' ? '#07a3d4' : 'black')))) }">
                              {{ invoice.dueDate | date : "MMM yyyy" }} ({{ invoice.status | titlecase }})

                            </div>
                          <div class="col-3 d-flex flex-nowrap">
                            <img role="button" src="/assets/img/view.png" alt="" width="22" height="20px" id="viewing"
                              role="button"  data-bs-placement="top" data-bs-toggle="modal" data-bs-target="#viewinvoice"
                              title="View" (click)="viewInvoiceDetails(invoice)" />&nbsp;&nbsp;

                            <img role="button" src="/assets/img/download.png" alt="" width="20px" id="viewing"
                              role="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Download"
                              (click)="downloadinvoices(invoice, i)" height="20px" />
                          </div>
                        </div>
                        <!-- <div class="my-auto primaryInfoLabels"> -->
                        <!-- <span><img role="button" src="/assets/img/view.png" alt="" width="20px"
                    height="20px" id="viewing" role="button" data-bs-toggle="modal"
                    data-bs-target="#viewinvoice" data-bs-placement="top" title="View"
                    (click)="viewinvoices(invoice.file)"></span>&nbsp;&nbsp;
                <span><img role="button" src="/assets/img/download.png" alt="" width="20px"
                    id="viewing" role="button" data-bs-toggle="tooltip"
                    data-bs-placement="top" title="Download"
                    (click)="downloadinvoices(invoice)" height="20px"></span> -->
                        <!-- </div> -->
                      </div>
                    </div>
                    <!-- <ng-template #showdraftinvoice>
                      <div class="d-flex flex-wrap mt-1" *ngIf="
                            getCustomerDraftDate &&
                            getCustomerDraftDate.length > 0
                          ">
                        <div class="my-auto col-7 primaryInfoLabels row">
                          <span class="col-9" style="padding-left: 22px; color: lightblue">
                            {{ getCustomerDraftDate }}<br />({{lang?.Draft}})</span>
                          <span class="col-1 justify-content-end p-draft"><img role="button" src="/assets/img/view.png"
                              alt="" width="20px" height="20px" id="viewing" role="button" data-bs-toggle="modal"
                              data-bs-target="#viewinvoiceDraft" data-bs-placement="top" title="View" />

                          </span>
                        </div>
                      </div>
                    </ng-template>
                    <ng-container *ngIf="
                          customerFinalInvoicesIGBMS &&
                          customerFinalInvoicesIGBMS?.length > 0
                        ">
                      <div class="col-12" *ngFor="let invoice of customerFinalInvoicesIGBMS">
                        <div class="my-auto row primaryInfoLabels">
                          <div class="col-8" style="margin-left: 0px" [ngStyle]="{
                                color: invoice.status === 'Paid' ? 'green' : (invoice.status === 'Overdue' ? 'orange' : 'black')
                              }">
                            {{
                            invoice.dueDate | date : "MMM yyyy"
                            }}
                          </div>
                          <div class="col-4">
                            <img role="button" src="/assets/img/view.png" alt="" width="22" height="20px" id="viewing"
                              role="button" data-bs-toggle="modal" data-bs-target="#viewinvoice" data-bs-placement="top"
                              title="View" (click)="viewinvoices(invoice.file)" />&nbsp;&nbsp;

                            <img role="button" src="/assets/img/download.png" alt="" width="20px" id="viewing"
                              role="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Download"
                              (click)="downloadinvoices(invoice)" height="20px" />
                          </div>
                        </div>

                      </div>
                    </ng-container> -->
                  </div>
                  <div
                    *ngIf="
                        !restLoader && !showinvoiceMessage &&
                        customerFinalInvoices.length == 0 ">
                    <span style="font-size: 12px;">No invoices available</span>
                  </div>
                </div>
                <div class="row mx-0 invoice-footer px-2" style="justify-content: center;">
                  <!-- Top row: 3 columns -->
                  <!-- <div class="col-4 d-flex align-items-center">
                    <div class="draft-invoice me-1"></div>
                    <div style="font-size: 9px;">Draft</div>
                  </div> -->
                  <!-- <div class="col-4 d-flex align-items-center">
                    <div class="paid-invoice me-1"></div>
                    <div style="font-size: 9px;">Paid</div>
                  </div> -->
                  <!-- <div class="col-4 d-flex align-items-center">
                    <div class="post-invoice me-1"></div>
                    <div style="font-size: 9px;">Post</div>
                  </div> -->
                
                  <!-- Bottom row: 2 centered columns -->
                  <!-- <div class="col-4 d-flex align-items-center">
                    <div class="void-invoice me-1"></div>
                    <div style="font-size: 9px;">Void</div>
                  </div> -->
                  <!-- <div class="col-4 d-flex align-items-center">
                    <div class="overdue-invoice me-1"></div>
                    <div style="font-size: 9px;">Overdue</div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Payment Info -->
        <div class="col-md-4 col-xxl-3 px-md-0">
          <div class="card">
            <div class="card-header bg-headers justify-content-between align-items-center" id="cardheader">
              <div class="text-white title">{{ lang?.Payment_Method }}</div>
              <!-- <div class="text-white subheader" *ngIf="paymentMethod === 'CREDIT_CARD'">Payment Type: Credit Card</div>
                      <div class="text-white subheader" *ngIf="paymentMethod === 'ACH'">Payment Type: PAD</div> -->
              <!-- <i class="fa fa-id-card-o fa-lg" aria-hidden="true"></i> -->
            </div>

            <div class="card-body dependentDiv p-2" *ngIf="showinvoiceMessage">
              <div class="card subcardheight shadow" id="planheader">
                <div class="card-header p-0">
                  <span class="imagetext1" *ngIf="!showinvoiceMessage">{{
                    lang?.Credit_Card
                    }}</span>
                  <img id="singlecardimage"
                    src="{{ logo?.paymentMethod?.image ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/payment-method.png' }}"
                    width="100%" />
                </div>
                <div class="card-body py-2" id="scrollcard" *ngIf="
                      showinvoiceMessage &&
                      customerType == 'CORP' &&
                      ischildAccount
                    ">
                  <small>{{lang?.Member_premium_paid_by_company}}</small>
                </div>
              </div>
            </div>
            <div *ngIf="!showinvoiceMessage">
              <div class="card-body p-2" *ngIf="paymentMethod === 'CREDIT_CARD'">
                <div class="card subcardheight shadow" id="planheader" *ngIf="
                      paymentMethodId != 0 ||
                      paymentMethodId != null ||
                      paymentMethodId != ''
                    ">
                  <div class="card-header p-0">
                    <span class="imagetext1">{{ lang?.Credit_Card }}</span>
                    <img id="singlecardimage"
                      src="{{ logo?.paymentMethod?.image ??'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/payment-method.png' }}"
                      width="100%" />
                  </div>
                  <div class="card-body py-2" id="scrollcard" *ngIf="ccDetails !=null || ccDetails?.length != 0">
                    <!-- <div>{{lang?.Credit_Card}}</div> -->
                    <div class="is-loading" *ngIf="restLoader">
                      <p class="mb-2 mx-0 w-50"></p>
                    </div>
                    <div class="is-loading" *ngIf="restLoader">
                      <p class="mb-2 mx-0"></p>
                    </div>
                    <div class="is-loading" *ngIf="restLoader">
                      <p class="mb-2 mx-0"></p>
                    </div>
                    <div class="row" *ngIf="(ccDetails !=null && ccDetails !=undefined) && !restLoader">
                      <div class="form-group col-6 col-md-12 col-xl-6">
                        <div>
                          <label class="primaryInfoLabels">{{
                            lang?.Card_holder_name
                            }}</label>
                        </div>
                        <div class="primaryInfoLabels">
                          {{ fullName | titlecase }}
                        </div>
                      </div>
                      <div class="form-group col-6 col-md-12 col-xl-6">
                        <div>
                          <label class="primaryInfoLabels">{{
                            lang?.Card_Number
                            }}</label>
                        </div>
                        <div class="primaryInfoLabels">{{ creditCardNo }}</div>
                      </div>
                      <div class="form-group col-6 col-md-12 col-xl-6">
                        <label class="primaryInfoLabels">{{lang?.Expires}}</label>
                      </div>
                      <div class="form-group col-6 col-md-12 col-xl-6">
                        <!-- <i class="fa fa-pencil-square-o icon pt-2" role="button" data-bs-toggle="modal" data-bs-target="#updatePaymentInfo" (click)="ccUpdate()"></i> -->
                        <div class="primaryInfoLabels" [style.color]="ccExpiryColor" data-bs-toggle="tooltip"
                          title="{{ ccExpiryTitle }}" data-bs-placement="top">
                          <span *ngIf="ccExpiryColor == 'red'" class="blinker"></span>
                          {{ expire }}
                        </div>
                      </div>
                    </div>
                    <div *ngIf="(ccDetails ==null||ccDetails ==undefined) && !restLoader">
                      <!-- <p>No Details found</p> -->
                      <small>{{lang?.No_Details_found}}</small>
                    </div>
                  </div>
                  <div style="display: flex;justify-content: end;padding-right: 10px;" class="mb-1">
                    <button
                      id="viewButton"
                      *ngIf="isReauth===true"
                      class="btn btn-sm btn-light px-3"
                      style="border: 1px solid rgb(20, 42, 73);"
                      (click)="reAuthorize()"
                    >
                      Re-authorize
                    </button>
                    <button
                      id="viewButton"
                      *ngIf="isRetryPayment===true"
                      class="btn btn-sm btn-light px-3"
                      style="border: 1px solid rgb(20, 42, 73);"
                      (click)="retryPayment()"
                    >
                      Retry Payment
                    </button>
                  </div>
                  <div class="card-footer" id="paymentfooter" *ngIf="fubsillstatus?.toLowerCase() != 'draft'">
                    <div class="row ps-2">
                      <p class="col-1" style="margin: 0px; padding: 0px">
                        &nbsp;<i class="fa fa-send-o" style="color: balck; cursor: pointer" data-bs-toggle="modal"
                          data-bs-target="#emailConfirmationModal" (click)="getInviteEmails()">
                        </i>&nbsp;
                      </p>
                      <p class="col-11 ps-1" style="font-size: 12px; margin: 0px; padding: 0px">
                        *{{lang?.Invite}}
                        <b>
                          {{ customerData?.firstName | titlecase }}
                          {{ customerData?.lastName | titlecase }}</b>
                        {{lang?.to_update_payment_method}}
                      </p>

                      <!-- <button id="viewButton" class="btn btn-sm btn-light col-4 mt-2 text-nowrap"
                  data-bs-toggle="modal" data-bs-target="#updatePaymentMethodPAD"
                  (click)="openpad()">{{lang1.change_to_pad_cp}}</button> -->
                      <!-- <button id="viewButton" *ngIf="paymentMethodId !='0'"
                  class="btn btn-sm btn-light col-6 mt-2 ms-auto ms-md-0 ms-xl-auto text-nowrap"
                  data-bs-toggle="modal" data-bs-target="#updatePaymentInfo" (click)="ccUpdate()">{{lang1.update_cc}}</button> -->
                      <!-- <button id="viewButton" class="btn btn-sm btn-light col-6 mt-2" *ngIf="paymentMethodId =='0'"
                                  data-bs-toggle="modal" data-bs-target="#changeToCC" (click)="changeToCC()">{{lang?.Change_to_Credit_Card}}</button> -->
                    </div>
                  </div>
                </div>
                <!-- <div *ngIf="paymentMethodId !=0 || paymentMethodId !=null || paymentMethodId !=''">
              <h6 class="title"></h6>
            </div> -->
              </div>
              <div class="card-body p-2" *ngIf="paymentMethod === 'ACH'">
                <div class="card subcardheight shadow" id="planheader">
                  <div class="card-header p-0">
                    <span class="imagetext1">{{ lang?.Pre_Authorized_Debit_PAD }}</span>
                    <img id="singlecardimage"
                      src="{{ logo?.paymentMethod?.image ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/payment-method.png' }}"
                      width="100%" />
                  </div>
                  <div class="card-body py-2" id="scrollcard" *ngIf="PADdetails != null">
                    <div>{{ lang?.Pre_Authorized_Debit_PAD }}</div>
                    <div class="row">
                      <div class="form-group col-4 col-md-12 col-xl-3 pe-0">
                        <div class="d-flex justify-content-between">
                          <label class="primaryInfoLabels">{{
                            lang?.Bank_Id
                            }}</label>
                        </div>
                        <div class="primaryInfoLabels is-loading" *ngIf="restLoader">
                          <p class="mx-0"></p>
                        </div>
                        <div class="primaryInfoLabels" *ngIf="!restLoader">{{ bankCode }}</div>
                      </div>
                      <div class="form-group col-4 col-md-12 col-xl-4 paddingStart">
                        <div class="d-flex justify-content-between">
                          <label class="primaryInfoLabels">{{
                            lang?.Transit
                            }}</label>
                        </div>
                        <div class="primaryInfoLabels is-loading" *ngIf="restLoader">
                          <p class="mx-0"></p>
                        </div>
                        <div class="primaryInfoLabels" *ngIf="!restLoader">{{ transitNumber }}</div>
                      </div>
                      <div class="form-group col-4 col-md-12 col-xl-5 paddingStart">
                        <div class="d-flex justify-content-between">
                          <label class="primaryInfoLabels">{{
                            lang?.Account
                            }}</label>
                          <!-- <i class="fa fa-pencil-square-o icon pt-2 ps-2" role="button" data-bs-toggle="modal" data-bs-target="#updatePADinfo" (click)="padUpdate()"></i> -->
                        </div>
                        <div class="primaryInfoLabels is-loading" *ngIf="restLoader">
                          <p class="mx-0"></p>
                        </div>
                        <div class="primaryInfoLabels" *ngIf="!restLoader">{{ accountNumber }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12">
                        <div class="d-flex justify-content-between">
                          <label class="primaryInfoLabels">{{
                            lang?.Bank_Details
                            }}</label>
                        </div>
                        <div class="primaryInfoLabels is-loading" *ngIf="restLoader">
                          <p class="mx-0"></p>
                        </div>
                        <div class="primaryInfoLabels is-loading" *ngIf="restLoader">
                          <p class="mx-0"></p>
                        </div>
                        <div class="primaryInfoLabels" *ngIf="!restLoader">
                          {{ bankinformation }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer" id="paymentfooter" *ngIf="fubsillstatus?.toLowerCase() != 'draft'">
                    <div class="row ps-2" id="paymentbuttons">
                      <p class="col-1" style="margin: 0px; padding: 0px">
                        &nbsp;<i class="fa fa-send-o" style="color: balck; cursor: pointer" data-bs-toggle="modal"
                          data-bs-target="#emailConfirmationModal" (click)="getInviteEmails()">
                        </i>&nbsp;
                      </p>
                      <p class="col-11 ps-1" style="font-size: 12px; margin: 0px; padding: 0px">
                        *{{lang?.Invite}}
                        <b>
                          {{ customerData?.firstName | titlecase }}
                          {{ customerData?.lastName | titlecase }}</b>
                        {{lang?.to_update_payment_method}}
                      </p>
                      <!-- <button id="viewButton" class="btn btn-sm btn-light col-6 mt-2"
                                  data-bs-toggle="modal" data-bs-target="#changeToCC" (click)="changeToCC()">{{lang?.Change_to_Credit_Card}}</button> -->
                      <!-- <button id="viewButton"
                  class="btn btn-sm btn-light col-4 mt-2 ms-auto ms-md-0 ms-xl-auto text-nowrap updatepad"
                  data-bs-toggle="modal" data-bs-target="#updatePADinfo"
                  (click)="padUpdate()">{{lang1.updatePad}}</button> -->
                      <!-- <small>*Send member to change payment method</small> -->

                      <!-- <button id="viewButton" *ngIf="paymentMethodId.length !='0'"
                  class="btn btn-sm btn-light col-6 mt-2 ms-auto ms-md-0 ms-xl-auto text-nowrap"
                  data-bs-toggle="modal" data-bs-target="#updatePaymentInfo" (click)="ccUpdate()">{{lang1.update_cc}}</button> -->
                      <!-- <button id="viewButton" class="btn btn-sm btn-light col-4 mt-2 ms-auto ms-md-0 ms-xl-auto text-nowrap updatepad"
                                  data-bs-toggle="modal" data-bs-target="#changeToCC" (click)="changeToCC()">{{lang?.Change_to_Credit_Card}}</button> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body p-2" *ngIf="paymentMethod != 'ACH' && paymentMethod != 'CREDIT_CARD'">
                <div class="card subcardheight shadow" id="planheader">
                  <div class="card-header p-0">
                    <img id="singlecardimage"
                      src="{{ logo?.paymentMethod?.image ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/payment-method.png' }}"
                      width="100%" />
                  </div>

                  <div class="mt-3 mx-2" style="font-size: 12px" *ngIf="
                        showinvoiceMessage &&
                        customerType == 'CORP' &&
                        ischildAccount
                      ">
                    {{lang?.Paid_by_Company}}
                  </div>

                  <div class="mt-3 mx-2" style="font-size: 12px" *ngIf="
                        customerType == 'GIG'
                      ">
                    Missing Payment Method
                  </div>
                  <div class="card-footer" id="paymentfooter" *ngIf="fubsillstatus?.toLowerCase() != 'draft'">
                    <div class="row align-items-end mt-auto" id="paymentbuttons">
                      <p class="col-1" style="margin: 0px; padding: 0px">
                        &nbsp;<i class="fa fa-send-o" style="color: balck; cursor: pointer" data-bs-toggle="modal"
                          data-bs-target="#emailConfirmationModal" (click)="getInviteEmails()">
                        </i>&nbsp;
                      </p>
                      <p class="col-11 ps-1" style="font-size: 12px; margin: 0px; padding: 0px">
                        *{{lang?.Invite}}
                        <b>
                          {{ customerData?.firstName | titlecase }}
                          {{ customerData?.lastName | titlecase }}</b>
                        {{lang?.to_update_payment_method}}
                      </p>
                      <!-- <button id="viewButton" class="btn btn-sm btn-light col-6 mt-2"
                                  data-bs-toggle="modal" data-bs-target="#changeToCC" (click)="changeToCC()">{{lang?.Change_to_Credit_Card}}</button> -->
                      <!-- <button id="viewButton" class="btn btn-sm btn-light col-4 mt-2 text-nowrap"
                  data-bs-toggle="modal" data-bs-target="#updatePaymentMethodPAD"
                  (click)="openpad()">{{lang1.change_to_pad_cp}}{{fubsillstatus}}</button> -->

                      <!-- <button id="viewButton" *ngIf="paymentMethodId.length !='0'"
                  class="btn btn-sm btn-light col-6 mt-2 ms-auto ms-md-0 ms-xl-auto text-nowrap"
                  data-bs-toggle="modal" data-bs-target="#updatePaymentInfo" (click)="ccUpdate()">{{lang1.update_cc}}</button> -->
                      <!-- <button id="viewButton" class="btn btn-sm btn-light col-4 mt-2 ms-auto ms-md-0 ms-xl-auto text-nowrap updatepad"
                                  data-bs-toggle="modal" data-bs-target="#changeToCC" (click)="changeToCC()">Change to CC</button> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Member Information -->

        <div class="col-md-4 px-md-0 col-xxl-3 ">
          <div class="card">
            <div class="card-header bg-headers d-flex justify-content-between align-items-center" id="cardheader">
              <span class="text-white title">{{
                lang?.Member_Information
                }}</span>
              <!-- <i class="fa fa-id-card-o fa-lg" aria-hidden="true"></i> -->
            </div>
            <div class="card-body dependentDiv p-2">
              <div class="card subcardheight shadow" id="planheader">
                <div class="card-header p-0">
                  <!-- <span class="imagetext1">{{
                                lang?.Member_Information
                              }}</span> -->
                  <img id="singlecardimage"
                    src="{{ logo?.personalInfo?.image ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/PersonalInfo.png'}}"
                    width="100%" />
                </div>
                <div class="card-body py-2" id="scrollcard">
                  <div>
                    <i class="fa fa-pencil-square-o icon" style="float: right" role="button" data-bs-toggle="modal"
                      data-bs-target="#updateAddress" (click)="updateAddressForm()"></i>
                  </div>
                  <!-- <div>
              <div class="row">
                <span class="primaryInfoLabels"><img src="/assets/img/planholder.svg" width="16px" height="16px" data-bs-toggle="tooltip" data-bs-placement="top" title="Name">&nbsp;&nbsp;{{customerData?.firstName |titlecase}} {{customerData?.lastName |titlecase}}, {{gender}}</span>
              </div>
              <div class="row">
                <span class="primaryInfoLabels"><img src="/assets/img/email.svg" width="16px" height="16px" data-bs-toggle="tooltip" data-bs-placement="top" title="Email">&nbsp;&nbsp;{{customerData?.email}}</span>
              </div>
              <div class="row">
                <span class="primaryInfoLabels"><img src="/assets/img/mobile.svg" width="16px" height="16px" data-bs-toggle="tooltip" data-bs-placement="top" title="Mobile">&nbsp;&nbsp;{{customerData?.primaryPhone}}</span>
              </div>
              <div class="row">
                <span class="primaryInfoLabels"><img src="/assets/img/tel.svg" width="16px" height="16px" data-bs-toggle="tooltip" data-bs-placement="top" title="Telephone">&nbsp;&nbsp;{{customerData?.secondaryPhone}}</span>
              </div>
              <div class="row">
                <span class="primaryInfoLabels"><img src="/assets/img/location.svg" width="16px" height="16px" data-bs-toggle="tooltip" data-bs-placement="top" title="Address">&nbsp;&nbsp;{{customerData?.line1}}, {{customerData?.line2}}, {{customerData?.city}}, {{customerData?.province}}, {{customerData?.postalCode}}
                </span>
              </div>
            </div> -->

                  <div>
                    <div class="row">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/planholder.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="Name" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{ customerData?.firstName | titlecase }}
                        {{ customerData?.lastName | titlecase }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/gender.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="Gender" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{ gender }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/calender.svg" width="16px" height="16px" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Date of Birth" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{ dob }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/email.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="{{ lang?.Email }}" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{ customerData?.email }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/mobile.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="{{ lang?.Mobile }}" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{
                        customerData?.primaryPhone ||
                        "No phone number available"
                        }}
                      </div>
                    </div>
                    <div class="row" *ngIf="customerData?.secondaryPhone">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/tel.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="{{ lang?.Telephone }}" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{ customerData?.secondaryPhone }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/location.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="{{ lang?.Address }}" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels mt-1">
                        <div class="row">
                          <!-- <div class="col-3 primaryInfoLabels">Line 1</div> -->
                          <div class="col-12">
                            <span class="primaryInfoLabels">
                              {{ customerData?.line1 }}
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <!-- <div class="col-3 primaryInfoLabels">Line 2</div> -->
                          <div class="ms-auto col-12">
                            <span class="primaryInfoLabels">
                              {{ customerData?.line2 }}
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 primaryInfoLabels">
                            {{ customerData?.city }},&nbsp;{{
                            customerData?.province
                            }},&nbsp;{{ customerData?.postalCode }}
                          </div>

                          <!-- <div class="col-12 primaryInfoLabels">City: {{customerData?.city}},Province: {{customerData?.province}},Postal Code: {{customerData?.postalCode}}</div> -->
                          <!-- <div class="col-6 primaryInfoLabels">Province: {{customerData?.province}}</div> -->
                          <!-- <div class="ms-auto col-9"><span class="primaryInfoLabels"> {{customerData?.city}} </span></div> -->
                        </div>
                        <div class="row">
                          <!-- <div class="col-12 primaryInfoLabels">Postal Code: {{customerData?.postalCode}}</div> -->
                          <!-- <div class="ms-auto col-9"><span class="primaryInfoLabels"> {{customerData?.city}} </span></div> -->
                        </div>
                        <!-- <div class="row">
                  <div class="col-4 primaryInfoLabels">Province</div>
                  <div class="ms-auto col-8"><span class="primaryInfoLabels"> {{customerData?.province}}, {{customerData?.postalCode}} </span></div>
                </div> -->
                        <!-- {{customerData?.line1}}&nbsp; <span
                  *ngIf="customerData?.line2 && customerData?.line2!=' '">{{customerData?.line2}}&nbsp;
                </span>{{customerData?.city}}&nbsp;
                <div>{{customerData?.province}}&nbsp; {{customerData?.postalCode}}</div> -->
                      </div>
                    </div>
                    <div class="row" *ngIf="customerType=='CORP'">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/tier.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="Tier Name" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{ customerData?.tierInfo?.name }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/planholder.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="Company Name" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{ customerData?.companyName }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/other_coverage.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="Job Title" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{ customerData?.jobTitle }}
                      </div>
                    </div>
                    <div class="row" *ngIf="customerData?.employerNameApplicable==true">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/planholder.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="Employer Name" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{ customerData?.employerName }}
                      </div>
                    </div>
                    <div class="row" *ngIf="customerType=='CORP'">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/location.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="Working Province" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{ customerData?.workingProvince }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/calender.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="Working Hours" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{ customerData?.workingHours }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1 ps-1">
                        <img src="/assets/img/date.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                          data-bs-placement="top" title="Hiring Date" />
                      </div>
                      <div class="col-10 mt-auto primaryInfoLabels">
                        {{ customerData?.hiringDate }}
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row">
              <div class="col-4 primaryInfoLabels">Line 1</div>
              <div class="col-8"><span class="primaryInfoLabels"> {{customerData?.line1}} </span></div>
            </div> -->
                  <!-- <div class="row">
              <div class="col-4 primaryInfoLabels">Line 2</div>
              <div class="ms-auto col-8"><span class="primaryInfoLabels"> {{customerData?.line2}} </span></div>
            </div>
            <div class="row">
              <div class="col-4 primaryInfoLabels">City</div>
              <div class="ms-auto col-8"><span class="primaryInfoLabels"> {{customerData?.city}} </span></div>
            </div>
            <div class="row">
              <div class="col-4 primaryInfoLabels">Province</div>
              <div class="ms-auto col-8"><span class="primaryInfoLabels"> {{customerData?.province}}, {{customerData?.postalCode}} </span></div>
            </div> -->
                  <!-- <div class="row">
              <div class="col-4 primaryInfoLabels">Postal Code</div>
              <div class="col-8"><span class="primaryInfoLabels"> {{customerData?.postalCode}} </span></div>
            </div> -->
                  <!-- <span class="primaryInfoLabels"> {{customerData?.line1}}, {{customerData?.line2}}, {{customerData?.city |titlecase}}, {{customerData?.province}}, {{customerData?.postalCode}}, {{customerData?.country |titlecase}}</span> -->
                  <!-- <span class="primaryInfoLabels"> </span>
                <span class="primaryInfoLabels"> </span>
                <span class="primaryInfoLabels"> </span> -->
                  <!-- <div class="row">
              <div class="form-group col-6">
                <div><label class="primaryInfoLabels"><b>Gender</b></label></div>
                <div class="primaryInfoLabels"> {{customerData?.gender}} </div>
              </div>
                <div class="form-group col-6">
                <div><label class="primaryInfoLabels"><b>Coverage</b></label></div>
                <div class="primaryInfoLabels"> {{customerData?.maritalStatus}} </div>
              </div>
            </div> -->
                </div>
                <!-- <div class="card-footer" id="planholderfooter"></div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- Dependents Information -->
        <div class="col-md-4 px-md-0 col-xxl-3">
          <div class="card">
            <div class="card-header bg-headers d-flex justify-content-between align-items-center">
              <span class="text-white title">{{
                lang?.Dependent_Info
                }}</span>
              <!-- <span class="text-white">{{currentIndex}} of {{childrenInfo.length}}</span> -->
              <!-- <span>
            <i class="fa fa-pencil-square-o icon text-white" *ngIf="editSpouse" style="float: right;" role="button" data-bs-toggle="modal"
            data-bs-target="#updateSpousePlan" (click)="updateSpousePlan()"></i>
            <i class="fa fa-pencil-square-o icon text-white" *ngIf="editChild" style="float: right;" role="button" data-bs-toggle="modal"
            data-bs-target="#updateDependent" (click)="updateDependentForm()"></i>
          </span> -->
            </div>
            <div class="card-body dependentDiv p-2">
              <section id="tranding" *ngIf="childrenInfo && childrenInfo.length > 1">
                <div class="container"></div>
                <div class="container">
                  <div class="swiper tranding-slider">
                    <div class="swiper-wrapper">
                      <!-- Slide-start -->
                      <div class="swiper-slide tranding-slide" *ngFor="let children of childrenInfo; let i = index">
                        <div class="card activecard">
                          <div class="card-header p-0">
                            <div *ngIf="children.relationType == 'spouse'">
                              <img id="image"
                                src="{{ logo?.dependents.SPOUSE.images.MALE ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/Spouse.png' }}"
                                width="100%" />
                            </div>
                            <div *ngIf="children.relationType == 'child'">
                              <img id="image" *ngIf="children.gender == 'Male'" src="{{
                                    logo?.dependents?.CHILDREN?.images?.MALE ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/ChildrenMale.png'
                                  }}" width="100%" />
                              <img id="image" *ngIf="children.gender == 'Female'" src="{{
                                    logo?.dependents?.CHILDREN?.images?.FEMALE ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/ChildrenFemale.png'
                                  }}" width="100%" />
                              <img id="image" *ngIf="
                                    children.gender == 'Non-Binary' ||
                                    children.gender == 'Undisclosed'
                                  " src="{{
                                    logo?.dependents?.CHILDREN?.images
                                      ?.UNDISCLOSED ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/ChildrenOtherGender.png'
                                  }}" width="100%" />
                            </div>
                          </div>

                          <div class="card-body py-2 px-1" [style.background-color]="
                                dependentBackgroundColor[i]
                              ">
                            <div class="planBody">
                              <div *ngIf="children.relationType == 'spouse'">
                                <i class="fa fa-pencil-square-o icon" style="float: right" role="button"
                                  data-bs-toggle="modal" data-bs-target="#updateSpousePlan"
                                  (click)="updateSpousePlan()"></i>
                              </div>
                              <div *ngIf="children.relationType == 'child'">
                                <i class="fa fa-pencil-square-o icon" style="float: right" role="button"
                                  data-bs-toggle="modal" data-bs-target="#updateDependent"
                                  (click)="updateDependentForm(i)"></i>
                              </div>
                              <div class="row mx-0">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="{{ lang?.Dependent_Name }}" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    <span
                                      class="status-dot"
                                      [class.dot-green]="children.addedToPolicy"
                                      [class.dot-red]="!children.addedToPolicy"
                                    ></span>
                                    {{ children.firstName | titlecase }}
                                    {{ children.lastName | titlecase }}
                                  </span>
                                </div>

                                <!-- <div class="row mx-0 align-items-center" *ngFor="let children of childrens">
                                  <div class="col-1 px-1">
                                    <img
                                      src="/assets/img/user.svg"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Dependent Name"
                                    />
                                  </div>
                                  <div class="col-11 ps-2 d-flex align-items-center">
                                    <span
                                      class="status-dot"
                                      [class.dot-green]="children.addedToPolicy"
                                      [class.dot-red]="!children.addedToPolicy"
                                    ></span>

                                    <span class="ms-2">
                                      {{ children.firstName | titlecase }} {{ children.lastName | titlecase }}
                                    </span>
                                  </div>
                                </div> -->

                              </div>
                              <div class="row mx-0">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/dob2.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="{{ lang?.Date_of_Birth }}" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ children.dob }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0">
                                <div class="col-1 ps-1">
                                  <img src="/assets/img/gender.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                                    data-bs-placement="top" title="Gender" />
                                </div>
                                <div class="col-10 mt-auto primaryInfoLabels">
                                  {{ children.gender }}
                                </div>
                              </div>
                              <div class="row mx-0" *ngIf="children?.email">
                                <div class="col-1 ps-1">
                                  <img src="/assets/img/email.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                                    data-bs-placement="top" title="{{ lang?.Email }}" />
                                </div>
                                <div class="col-10 mt-auto primaryInfoLabels">
                                  {{ children?.email }}
                                </div>
                              </div>
                              <div class="row mx-0" *ngIf="
                                    children.relationType == 'child' &&
                                    children.specialNeeds == 'true' &&
                                    children.specialNeeds
                                  ">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/special_needs.svg" data-bs-toggle="tooltip"
                                    data-bs-placement="top" title="{{
                                        lang?.Dependent_with_Special_Needs
                                      }}" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ children.specialNeeds }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0" *ngIf="
                                    children.relationType == 'child' &&
                                    children.graduationDate
                                  ">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/graduation_date.svg" data-bs-toggle="tooltip"
                                    data-bs-placement="top" title="{{ lang?.Graduation_Date }}" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ children.graduationDate }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0" *ngIf="
                                    children.relationType == 'spouse' &&
                                    children.insurer
                                  ">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip"
                                    data-bs-placement="top" title="{{ lang?.Name_Of_The_Carrier }}"
                                    id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ children.insurer | titlecase }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0" *ngIf="
                                    children.relationType == 'child' &&
                                    children.carrierName
                                  ">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip"
                                    data-bs-placement="top" title="{{ lang?.Name_Of_The_Carrier }}"
                                    id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ children.carrierName | titlecase }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0" *ngIf="
                                    children.relationType == 'spouse' &&
                                    children.healthPlan
                                  ">
                                <div class="col-1 px-1">
                                  <img src="/assets/img/coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="{{ lang?.COB }}" id="carousellogos" />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ children.healthPlan }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="tranding-slider-control">
                      <div class="swiper-button-prev slider-arrow" (change)="onSlideChangeDependents($event)">
                        <i class="fa fa-angle-left" style="font-size: 20px"></i>
                      </div>
                      <div class="swiper-button-next slider-arrow" (click)="onSlideChangeDependents($event)">
                        <i class="fa fa-angle-right" style="font-size: 20px"></i>
                      </div>
                      <div class="swiper-pagination"></div>
                    </div>
                  </div>
                </div>
              </section>
              <div *ngIf="childrenInfo && childrenInfo.length == 1">
                <div class="card shadow singledependentcard subcardheight"
                  *ngFor="let children of childrenInfo; let i = index">
                  <div class="card-header p-0">
                    <div *ngIf="children.relationType == 'spouse'">
                      <img id="singlecardimage"
                        src="{{ logo?.dependents?.SPOUSE?.images?.MALE ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/Spouse.png' }}"
                        width="100%" />
                    </div>
                    <div *ngIf="children.relationType == 'child'">
                      <img id="image" *ngIf="children.gender == 'Male'"
                        src="{{ logo?.dependents.CHILDREN.images.MALE ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/ChildrenMale.png' }}"
                        width="100%" />
                      <img id="image" *ngIf="children.gender == 'Female'"
                        src="{{ logo?.dependents.CHILDREN.images.FEMALE ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/ChildrenFemale.png' }}"
                        width="100%" />
                      <img id="image" *ngIf="
                            children.gender == 'Non-Binary' ||
                            children.gender == 'Undisclosed'
                          " src="{{
                            logo?.dependents?.CHILDREN?.images?.UNDISCLOSED ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/ChildrenOtherGender.png'
                          }}" width="100%" />
                    </div>
                  </div>

                  <div class="card-body py-2 px-1" [style.background-color]="dependentBackgroundColor[i]"
                    id="singledependent">
                    <div class="planBody">
                      <div *ngIf="children.relationType == 'spouse'">
                        <i class="fa fa-pencil-square-o icon" style="float: right" role="button" data-bs-toggle="modal"
                          data-bs-target="#updateSpousePlan" (click)="updateSpousePlan()"></i>
                      </div>
                      <div *ngIf="children.relationType == 'child'">
                        <i class="fa fa-pencil-square-o icon" style="float: right" role="button" data-bs-toggle="modal"
                          data-bs-target="#updateDependent" (click)="updateDependentForm(i)"></i>
                      </div>
                      <div class="row mx-0">
                        <div class="col-1 px-1">
                          <img src="/assets/img/user.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="{{ lang?.Dependent_Name }}" id="carousellogos" />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ children.firstName | titlecase }}
                            {{ children.lastName | titlecase }}
                          </span>
                        </div>
                      </div>
                      <div class="row mx-0">
                        <div class="col-1 px-1">
                          <img src="/assets/img/dob2.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="{{ lang?.Date_of_Birth }}" id="carousellogos" />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ children.dob }}
                          </span>
                        </div>
                      </div>
                      <div class="row mx-0">
                        <div class="col-1 ps-1">
                          <img src="/assets/img/gender.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                            data-bs-placement="top" title="Gender" />
                        </div>
                        <div class="col-10 mt-auto primaryInfoLabels">
                          {{ children.gender }}
                        </div>
                      </div>
                      <div class="row mx-0" *ngIf="children?.email">
                        <div class="col-1 ps-1">
                          <img src="/assets/img/email.svg" width="16px" height="16px" data-bs-toggle="tooltip"
                            data-bs-placement="top" title="{{ lang?.Email }}" />
                        </div>
                        <div class="col-10 mt-auto primaryInfoLabels">
                          {{ children?.email }}
                        </div>
                      </div>
                      <div class="row mx-0" *ngIf="
                            children.relationType == 'child' &&
                            children.specialNeeds == 'true' &&
                            children.specialNeeds
                          ">
                        <div class="col-1 px-1">
                          <img src="/assets/img/special_needs.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="{{ lang?.Dependent_with_Special_Needs }}" id="carousellogos" />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ children.specialNeeds }}
                          </span>
                        </div>
                      </div>
                      <div class="row mx-0" *ngIf="
                            children.relationType == 'child' &&
                            children.graduationDate
                          ">
                        <div class="col-1 px-1">
                          <img src="/assets/img/graduation_date.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="{{ lang?.Graduation_Date }}" id="carousellogos" />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ children.graduationDate }}
                          </span>
                        </div>
                      </div>
                      <div class="row mx-0" *ngIf="
                            children.relationType == 'spouse' && children.insurer
                          ">
                        <div class="col-1 px-1">
                          <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="{{ lang?.Name_Of_The_Carrier }}" id="carousellogos" />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ children.insurer | titlecase }}
                          </span>
                        </div>
                      </div>
                      <div class="row mx-0" *ngIf="
                            children.relationType == 'child' &&
                            children.carrierName
                          ">
                        <div class="col-1 px-1">
                          <img src="/assets/img/other_coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="{{ lang?.Name_Of_The_Carrier }}" id="carousellogos" />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ children.carrierName | titlecase }}
                          </span>
                        </div>
                      </div>
                      <div class="row mx-0" *ngIf="
                            children.relationType == 'spouse' &&
                            children.healthPlan
                          ">
                        <div class="col-1 px-1">
                          <img src="/assets/img/coverage.svg" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="{{ lang?.COB }}" id="carousellogos" />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ children.healthPlan }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="childrenInfo.length <= 0">
                <div class="card shadow singledependentcard subcardheight">
                  <div class="card-header p-0">
                    <div>
                      <img id="singlecardimage"
                        src="{{ logo?.dependents?.SPOUSE?.images?.MALE ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/Spouse.png'}}"
                        width="100%" />
                    </div>
                    <!-- <div *ngIf="children.relationType=='child'">
                <img id="image" *ngIf="children.gender=='Male'"
                  src="{{logo?.dependents.CHILDREN.images.MALE}}" width="100%">
                <img id="image" *ngIf="children.gender=='Female'"
                  src="{{logo?.dependents.CHILDREN.images.FEMALE}}" width="100%">
                <img id="image"
                  *ngIf="children.gender=='Non-Binary' || children.gender=='Undisclosed'"
                  src="{{logo?.dependents?.CHILDREN?.images?.UNDISCLOSED}}" width="100%">
              </div> -->
                  </div>

                  <div class="card-body py-2 px-1" [style.background-color]="dependentBackgroundColor[i]"
                    id="singledependent">
                    <div class="planBody text-center">
                      <small>{{lang?.Member_has_no_dependents}}</small>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div *ngIf="childrenInfo.length<=0">
                                              </div> -->
            </div>
          </div>
        </div>
        <!-- Life Event change -->
        <div class="col-md-4 px-md-0 col-xxl-3 ">
          <div class="card">
            <div class="card-header bg-headers d-flex justify-content-between align-items-center" id="cardheader">
              <span class="text-white title">{{
                lang?.Life_Event_Change
                }}</span>
                <!-- <app-add-dependent [formConfig]="formConfiguration" [customerDataInput] = "customerData"></app-add-dependent> -->
              <!-- <i class="fa fa-id-card-o fa-lg" aria-hidden="true"></i> -->
            </div>
            <div class="card-body dependentDiv p-2">
              <div class="card subcardheight shadow" id="planheader">
                <div class="card-header p-0">
                  <span class="imagetext1">{{
                    lang?.Life_Event_Change
                    }}</span>
                  <img id="singlecardimage"
                    src="{{ logo?.lifeChnageEvent?.image ?? 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/dashboard/life-change-event.png'}}"
                    width="100%" />
                </div>
                <div class="card-body py-2" id="scrollcard text-center">
                  <!-- <small>{{lang?.Feature_is_pending}}</small> -->

                  <div style="display: flex; align-items: center;">
                    <div style="font-size: 12px;">
                      Add or Remove your spouse and child(ren)
                    </div>
                    <div>
                      <app-add-dependent [formConfig]="formConfiguration" [customerDataInput] = "customerData"></app-add-dependent>
  
                    </div>
  
                  </div>
                  <span style="font-size: 12px; margin-top: 10px;"><b>Note:</b> All life event changes must be reported in the portal within <b>30 days</b> of occurrence. Failing to do so may result in delay or subject to medical review to qualify for coverage.</span>
  

                  <!-- <div class="row d-flex justify-content-between align-items-center">
              <div class="form-group col-8">
                <label
                  class="primaryInfoLabels">{{lang1.spouseLifeChangeEvent}}&nbsp;</label>
              </div>
              <div class="form-group col-4 updateButton d-flex justify-content-end pt-2">
                <button class="form-group btn btn-sm btn-light" id="viewButton"
                  data-bs-toggle="modal" data-bs-target="#updateSpousePlan"
                  (click)="addSpouse()">{{lang?.Update}}</button>
                <button class="form-group btn btn-sm btn-light"
                  id="viewButton">{{lang?.Update}}</button>
                <button class="form-group btn btn-sm" id="viewButton">Update</button>
                  (click)="lifeEventChanges()"
              </div>
            </div>
            <div class="row d-flex justify-content-between align-items-center">
              <div class="form-group col-8">
                <label class="primaryInfoLabels">{{lang1.childLifeChangeEvent}}</label>
              </div>
              <div class="form-group col-4 updateButton d-flex justify-content-end pt-2">
                <button class="form-group btn btn-sm btn-light" id="viewButton"
                  data-bs-toggle="modal" data-bs-target="#updateDependent"
                  (click)="addDependent()">{{lang?.Update}}</button>
                <button class="form-group btn btn-sm btn-light"
                  id="viewButton">{{lang?.Update}}</button>
                <button class="form-group btn btn-sm" id="viewButton">Update</button>
                (click)="lifeEventChanges()"
              </div>
            </div>
            <div class="row d-flex justify-content-between align-items-center">
              <div class="form-group col-6">
                <label class="primaryInfoLabels"><b>Beneficiary Info</b></label>
              </div>
              <div class="form-group col-6 updateButton d-flex justify-content-end pt-2">
                <button class="form-group btn btn-sm" id="viewButton">Update</button>
                  (click)="lifeEventChanges()"
              </div>
            </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 px-md-0 col-xxl-3 mb-5" *ngIf="showIAFG && additionalDetails?.length>0">
          <div class="card" *ngIf="showIAFG && additionalDetails?.length > 1">
            <div class="card-header bg-headers d-flex justify-content-between align-items-center">
              <span class="text-white title">{{
                lang?.Life_and_Critical_Illness_Insurance
                }}

                Life and Critical Illness Insurance</span>
            </div>
            <div class="card-body dependentDiv p-2">
              <section id="tranding">
                <div class="container"></div>
                <div class="container">
                  <div class="swiper tranding-slider">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide tranding-slide" style="width: 520px"
                        *ngFor="let plan of additionalDetails; let i = index">
                        <div class="card activecard">
                          <div class="card-header p-0">
                            <span class="imagetext1">{{
                              plan.name
                              }}</span>
                            <img *ngIf="i % 2 == 0" id="image" src="../../assets/img/life.png" width="100%" />
                            <img *ngIf="i % 2 == 1" id="image" src="../../assets/img/critical1.png" width="100%" />
                          </div>
                          <div class="card-body py-2 px-1">
                            <div class="planBody">
                              <div class="row mb-1">
                                <div class="col-12 carousellabels">
                                  <div [ngClass]="
                                      hasSpouseData(plan.spouse)
                                        ? 'member-spouse'
                                        : 'member'
                                    ">
                                    <p class="mb-0">{{ plan.name }}</p>
                                    <div class="row">
                                      <div class="col-4"></div>
                                      <div class="col-4">
                                        <!-- <b>{{ lang?.Member }}</b> -->
                                        <b>Member</b>
                                      </div>
                                      <div class="col-4" *ngIf="hasSpouseData(plan.spouse)">
                                        <!-- <b>{{ lang?.Spouse }}</b> -->
                                        <b>Spouse</b>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-4"></div>
                                      <div class="col-4 text-nowrap">
                                        <img src="../../assets/img/smoker.png" width="20px"
                                          *ngIf="plan.member.smoker" />
                                        <img src="../../assets/img/non-smoker.png" width="20px"
                                          *ngIf="!plan.member.smoker" />
                                        {{
                                        plan.member.gender == "male"
                                        ? "(M)"
                                        : "(F)"
                                        }}
                                        {{ plan.member.age }}
                                      </div>
                                      <div class="col-4 text-nowrap" *ngIf="hasSpouseData(plan.spouse)">
                                        <img src="../../assets/img/smoker.png" width="20px"
                                          *ngIf="plan.spouse.smoker" />
                                        <img src="../../assets/img/non-smoker.png" width="20px"
                                          *ngIf="!plan.spouse.smoker" />
                                        {{
                                        plan.spouse.gender == "male"
                                        ? "(M)"
                                        : "(F)"
                                        }}
                                        {{ plan.spouse.age }}
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-4">Coverage</div>
                                      <div class="col-4 text-nowrap">
                                        ${{
                                        formatNumber(plan.member.coverageValue)
                                        }}
                                      </div>
                                      <div class="col-4 text-nowrap" *ngIf="hasSpouseData(plan.spouse)">
                                        ${{
                                        formatNumber(plan.spouse.coverageValue)
                                        }}
                                      </div>
                                    </div>

                                    <div class="row">
                                      <div class="col-4 text-nowrap">
                                        <!-- {{ lang?.Guaranteed }} -->
                                        Guranteed
                                      </div>
                                      <div class="col-4 text-nowrap">
                                        ${{
                                        formatNumber(plan.member.defaultRange)
                                        }}
                                      </div>
                                      <div class="col-4 text-nowrap" *ngIf="hasSpouseData(plan.spouse)">
                                        ${{
                                        formatNumber(plan.spouse.defaultRange)
                                        }}
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-4"></div>
                                      <div class="col-8">
                                        <div *ngIf="
                                            plan.member.coverageValue >
                                            plan.member.defaultRange
                                          ">
                                          {{
                                          lang?.Coverage_exceeds_guaranteed_amount
                                          }}
                                          Coverage exceeds guranteed amount
                                        </div>
                                      </div>
                                      <div class="col-8">
                                        <div *ngIf="
                                            plan.spouse.coverageValue >
                                            plan.spouse.defaultRange
                                          ">
                                          {{
                                          lang?.Coverage_exceeds_guaranteed_amount
                                          }}
                                          Coverage exceeds guranteed amount
                                        </div>
                                      </div>
                                    </div>

                                    <div class="row">
                                      <div class="col-4 d-flex align-items-center">
                                        Max Coverage:
                                      </div>
                                      <div class="col-4 text-nowrap">
                                        ${{
                                        plan.member.maximumCoverageWithEvidence
                                        ? formatNumber(
                                        plan.member
                                        .maximumCoverageWithEvidence
                                        )
                                        : formatNumber(
                                        plan.spouse
                                        .maximumCoverageWithEvidence
                                        )
                                        }}
                                      </div>

                                    </div>
                                  </div>
                                </div>
                                <div class="col-3 d-flex ps-0"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tranding-slider-control">
                      <div class="swiper-button-prev slider-arrow">
                        <i class="fa fa-angle-left" style="font-size: 20px"></i>
                      </div>
                      <div class="swiper-button-next slider-arrow">
                        <i class="fa fa-angle-right" style="font-size: 20px"></i>
                      </div>
                      <div class="swiper-pagination"></div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

          </div>

          <!-- without slider -->
          <div class="card" *ngIf="showIAFG && additionalDetails?.length == 1">
            <div class="card-header text-white bg-headers d-flex justify-content-between align-items-center">
              <span class="title">{{
                lang?.Life_and_Critical_Illness_Insurance
                }}
                Life and Critical Illness Insurance
              </span>
            </div>
            <div class="card-body dependentDiv p-2">
              <div class="card subcardheight shadow" id="planheader" *ngFor="let plan of additionalDetails">
                <div class="card-header p-0">
                  <span class="imagetext1">{{
                    plan.name
                    }}</span>
                  <img id="singlecardimage" src="../../assets/img/life.png" width="100%" />

                </div>
                <div class="card-body py-2 px-1">
                  <div class="planBody">
                    <div class="row mb-1">
                      <div class="col-12 carousellabels">
                        <div [ngClass]="
                            hasSpouseData(plan.spouse) ? 'member-spouse' : 'member'
                          ">
                          <p class="mb-0">{{ plan.name }}</p>
                          <div class="row">
                            <div class="col-4"></div>
                            <div class="col-4">
                              <!-- <b>{{ lang?.Member }}</b> -->
                              <b>Member</b>
                            </div>
                            <div class="col-4" *ngIf="hasSpouseData(plan.spouse)">
                              <!-- <b>{{ lang?.Spouse }}</b> -->
                              <b>Spouse</b>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-4"></div>
                            <div class="col-4 text-nowrap">
                              <img src="../../assets/img/smoker.png" width="20px" *ngIf="plan.member.smoker" />
                              <img src="../../assets/img/non-smoker.png" width="20px" *ngIf="!plan.member.smoker" />
                              {{ plan.member.gender == "male" ? "(M)" : "(F)" }}
                              {{ plan.member.age }}
                            </div>
                            <div class="col-4 text-nowrap" *ngIf="hasSpouseData(plan.spouse)">
                              <img src="../../assets/img/smoker.png" width="20px" *ngIf="plan.spouse.smoker" />
                              <img src="../../assets/img/non-smoker.png" width="20px" *ngIf="!plan.spouse.smoker" />
                              {{ plan.spouse.gender == "male" ? "(M)" : "(F)" }}
                              {{ plan.spouse.age }}
                            </div>
                          </div>
                          <div class="row">
                            <!-- <div class="col-4">{{ lang?.Coverage }}</div> -->
                            <div class="col-4">Coverage</div>

                            <div class="col-4 text-nowrap">
                              ${{ formatNumber(plan.member.coverageValue) }}
                            </div>
                            <div class="col-4 text-nowrap" *ngIf="hasSpouseData(plan.spouse)">
                              ${{ formatNumber(plan.spouse.coverageValue) }}
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-4 text-nowrap">
                              <!-- {{ lang?.Guaranteed }} -->
                              Guranteed
                            </div>
                            <div class="col-4 text-nowrap">
                              ${{ formatNumber(plan.member.defaultRange) }}
                            </div>
                            <div class="col-4 text-nowrap" *ngIf="hasSpouseData(plan.spouse)">
                              ${{ formatNumber(plan.spouse.defaultRange) }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-4"></div>
                            <div class="col-8">
                              <div *ngIf="
                                  plan.member.coverageValue >
                                  plan.member.defaultRange
                                ">
                                <!-- {{ lang?.Coverage_exceeds_guaranteed_amount }} -->
                                Coverage exceeds guranteed amount
                              </div>
                            </div>
                            <div class="col-8">
                              <div *ngIf="
                                  plan.spouse.coverageValue >
                                  plan.spouse.defaultRange
                                ">
                                <!-- {{ lang?.Coverage_exceeds_guaranteed_amount }} -->
                                Coverage exceeds guranteed amount
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-4 d-flex align-items-center">
                              Max Coverage:
                            </div>
                            <div class="col-4 text-nowrap">
                              ${{
                              plan.member.maximumCoverageWithEvidence
                              ? formatNumber(
                              plan.member
                              .maximumCoverageWithEvidence
                              )
                              : formatNumber(
                              plan.spouse
                              .maximumCoverageWithEvidence
                              )
                              }}
                            </div>

                          </div>
                        </div>
                      </div>
                      <div class="col-3 d-flex ps-0"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Beneficiaries -->
        <div class="col-md-4 px-md-0 col-xxl-3" *ngIf="beneficiaries?.length > 0">
          <div class="card">
            <div class="card-header bg-headers d-flex justify-content-between align-items-center">
              <span class="text-white title">Beneficiaries</span>
            </div>
            <div class="card-body dependentDiv p-2">
              <section id="tranding" *ngIf="beneficiaries?.length > 1">
                <div class="container"></div>
                <div class="container">
                  <div class="swiper tranding-slider">
                    <div class="swiper-wrapper">
                      <!-- Slide-start -->
                      <div class="swiper-slide tranding-slide" *ngFor="let beneficiary of beneficiaries; let i = index">
                        <div class="card activecard">
                          <div class="card-header p-0">
                            <div>
                              <img id="image" style="height:70px; object-fit:cover; object-position:right;"
                                src="assets/img/Beneficiaries1.png"
                                width="100%" *ngIf="i%4 == 0" />
                              <img id="image" style="height:70px; object-fit:cover; object-position:right;"
                                src="assets/img/Beneficiaries2.png"
                                width="100%" *ngIf="i%4 == 1" />
                              <img id="image" style="height:70px; object-fit:cover; object-position:right;"
                                src="assets/img/Beneficiaries3.png"
                                width="100%" *ngIf="i%4 == 2" />
                              <img id="image" style="height:70px; object-fit:cover; object-position:right;"
                                src="assets/img/Beneficiaries4.png"
                                width="100%" *ngIf="i%4 == 3" />
                            </div>
                          </div>

                          <div class="card-body py-2 px-1">
                            <div class="planBody">
                              <div class="row mx-0">
                                <div class="col-1 px-1">
                                  <img
                                    src="/assets/img/user.svg"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Beneficiary Name"
                                    id="carousellogos"
                                  />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ beneficiary?.firstName | titlecase }}
                                    {{ beneficiary?.lastName | titlecase }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0" *ngIf="!!beneficiary?.dob">
                                <div class="col-1 px-1">
                                  <img
                                    src="/assets/img/dob2.svg"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="{{ lang?.Date_of_Birth }}"
                                    id="carousellogos"
                                  />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ beneficiary?.dob | date : "MM-dd-yyy" }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0" *ngIf="beneficiary?.gender != null && beneficiary?.gender != undefined && beneficiary?.gender != ''">
                                <div class="col-1 px-1">
                                  <img
                                    src="/assets/img/gender.svg"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Gender"
                                    id="carousellogos"
                                  />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ beneficiary?.gender || "" }}
                                  </span>
                                </div>
                              </div>
                              <div
                                class="row mx-0"
                                *ngIf="beneficiary?.customerType != null && beneficiary?.customerType != undefined && beneficiary?.customerType != ''">
                                <div class="col-1 px-1">
                                  <img
                                    src="/assets/img/planholder.svg"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Customer Type"
                                    id="carousellogos"
                                  />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ capitalizeFirstLetter(beneficiary?.customerType || "") }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0">
                                <div class="col-1 px-1">
                                  <img
                                    src="/assets/img/other_coverage.svg"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Relationship"
                                    id="carousellogos"
                                  />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels text-capitalize">
                                    {{ removeUnderscores(beneficiary?.relationship) || "" }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0">
                                <div class="col-1 px-0">
                                  <img
                                    src="/assets/img/percentage.png"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Percentage"
                                    id="carousellogos"
                                    class="w-100"
                                  />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels text-capitalize">
                                    {{ beneficiary?.percentage || "" }}
                                  </span>
                                </div>
                              </div>
                              <div
                                class="row mx-0"
                                *ngIf="beneficiary?.trusteeDetails?.firstName != '' && beneficiary?.trusteeDetails?.firstName != undefined">
                                <p class="mb-0 mt-1 p-0" style="font-weight: bold; font-size: 14px;">
                                  Trustee Details
                                </p>
                                <div class="col-1 px-1">
                                  <img
                                    src="/assets/img/user.svg"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Trustee Name"
                                    id="carousellogos"
                                  />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ beneficiary?.trusteeDetails?.firstName | titlecase }}
                                    {{ beneficiary?.trusteeDetails?.lastName | titlecase }}
                                  </span>
                                </div>
                              </div>
                              <div class="row mx-0" *ngIf="
                                beneficiary?.contactDetails?.contingentBeneficiary?.firstName !='' &&
                                beneficiary?.contactDetails?.contingentBeneficiary?.firstName != undefined">
                                <p class="mb-0 mt-1 p-0" style="font-weight: bold; font-size: 14px;">
                                  Contingent Details
                                </p>
                                <div class="col-1 px-1">
                                  <img
                                    src="/assets/img/user.svg"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Contingent Name"
                                    id="carousellogos"
                                  />
                                </div>
                                <div class="col-11 ps-2">
                                  <span class="carousellabels">
                                    {{ beneficiary?.contactDetails?.contingentBeneficiary?.firstName | titlecase }}
                                    {{ beneficiary?.contactDetails?.contingentBeneficiary?.lastName | titlecase }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="tranding-slider-control">
                      <div class="swiper-button-prev slider-arrow" (change)="onSlideChangeDependents($event)">
                        <i class="fa fa-angle-left" style="font-size: 20px"></i>
                      </div>
                      <div class="swiper-button-next slider-arrow" (click)="onSlideChangeDependents($event)">
                        <i class="fa fa-angle-right" style="font-size: 20px"></i>
                      </div>
                      <div class="swiper-pagination"></div>
                    </div>
                  </div>
                </div>
              </section>
              <div *ngIf="beneficiaries?.length == 1">
                <div class="card shadow singledependentcard subcardheight"
                  *ngFor="let beneficiary of beneficiaries; let i = index">
                  <div class="card-header p-0">
                    <div>
                      <img id="image"
                        src="assets/img/Beneficiaries1.png"
                        width="100%" />
                    </div>
                  </div>

                  <div class="card-body py-2 px-1"
                    id="singledependent">
                    <div class="planBody">
                      <div class="row mx-0">
                        <div class="col-1 px-1">
                          <img
                            src="/assets/img/user.svg"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Beneficiary Name"
                            id="carousellogos"
                          />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ beneficiary?.firstName | titlecase }}
                            {{ beneficiary?.lastName | titlecase }}
                          </span>
                        </div>
                      </div>
                      <div class="row mx-0" *ngIf="!!beneficiary?.dob">
                        <div class="col-1 px-1">
                          <img
                            src="/assets/img/dob2.svg"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="{{ lang?.Date_of_Birth }}"
                            id="carousellogos"
                          />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ beneficiary?.dob | date : "MM-dd-yyy" }}
                          </span>
                        </div>
                      </div>
                      <div class="row mx-0" *ngIf="beneficiary?.gender != null && beneficiary?.gender != undefined && beneficiary?.gender != ''">
                        <div class="col-1 px-1">
                          <img
                            src="/assets/img/gender.svg"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Gender"
                            id="carousellogos"
                          />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ beneficiary?.gender || "" }}
                          </span>
                        </div>
                      </div>
                      <div
                        class="row mx-0"
                        *ngIf="beneficiary?.customerType != null && beneficiary?.customerType != undefined && beneficiary?.customerType != ''">
                        <div class="col-1 px-1">
                          <img
                            src="/assets/img/planholder.svg"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Customer Type"
                            id="carousellogos"
                          />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ capitalizeFirstLetter(beneficiary?.customerType || "") }}
                          </span>
                        </div>
                      </div>
                      <div class="row mx-0">
                        <div class="col-1 px-1">
                          <img
                            src="/assets/img/other_coverage.svg"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Relationship"
                            id="carousellogos"
                          />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels text-capitalize">
                            {{ removeUnderscores(beneficiary?.relationship) || "" }}
                          </span>
                        </div>
                      </div>
                      <div class="row mx-0">
                        <div class="col-1 px-0">
                          <img
                            src="/assets/img/percentage.png"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Percentage"
                            id="carousellogos"
                            class="w-100"
                          />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels text-capitalize">
                            {{ beneficiary?.percentage || "" }}
                          </span>
                        </div>
                      </div>
                      <div
                        class="row mx-0"
                        *ngIf="beneficiary?.trusteeDetails?.firstName != '' && beneficiary?.trusteeDetails?.firstName != undefined">
                        <p class="mb-0 mt-1 p-0" style="font-weight: bold; font-size: 14px;">
                          Trustee Details
                        </p>
                        <div class="col-1 px-1">
                          <img
                            src="/assets/img/user.svg"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Trustee Name"
                            id="carousellogos"
                          />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ beneficiary?.trusteeDetails?.firstName | titlecase }}
                            {{ beneficiary?.trusteeDetails?.lastName | titlecase }}
                          </span>
                        </div>
                      </div>
                      <div class="row mx-0" *ngIf="
                        beneficiary?.contactDetails?.contingentBeneficiary?.firstName !='' &&
                        beneficiary?.contactDetails?.contingentBeneficiary?.firstName != undefined">
                        <p class="mb-0 mt-1 p-0" style="font-weight: bold; font-size: 14px;">
                          Contingent Details
                        </p>
                        <div class="col-1 px-1">
                          <img
                            src="/assets/img/user.svg"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Contingent Name"
                            id="carousellogos"
                          />
                        </div>
                        <div class="col-11 ps-2">
                          <span class="carousellabels">
                            {{ beneficiary?.contactDetails?.contingentBeneficiary?.firstName | titlecase }}
                            {{ beneficiary?.contactDetails?.contingentBeneficiary?.lastName | titlecase }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>

      <div class="row"></div>

      <div class="row"></div>

      <div class="row">
        <!-- Drug 2U Pharmacy -->
        <!-- <div class="col-md-4 col-xl-4 px-md-0">
              <div class="card dependentDiv">
                  <div class="card-header bg-headers d-flex justify-content-between align-items-center">
                      <span class="text-white title">{{formConfiguration.directPharmacy.title}}</span>
                  </div>
                  <div class="card-body p-2">
                      <div class="card subcardheight shadow" id="invoicecard">
                          <div class="card-header p-0">
                              <img id="pharmaimg" [src]="formConfiguration.directPharmacy.logo" width="100%">
                          </div>
                          <div class="card-body">
                              <div class="primaryInfoLabels ulpadding" [innerHTML]="formConfiguration.directPharmacy.content"></div>
                          </div>
                          <div class="card-footer" id="pharmafooter">
                              <div class="text-center primaryInfoLabels" [innerHTML]="formConfiguration.directPharmacy.footer"></div>
                          </div>
                      </div>
                  </div>
              </div>
          </div> -->
      </div>
    </div>
  </section>

  <!-- </div> -->

  <!-- <app-update-address id="updateAddress" class="modal fade mt-5 modal-lg" data-bs-backdrop="static"  [addressform]="addressform" [formConfiguration]="formConfiguration"></app-update-address>
  <app-update-phoneno id="updatePhoneNo" class="modal fade mt-5" data-bs-backdrop="static" [phoneform]="phoneform"></app-update-phoneno>
  <app-update-spouseplan *ngIf="UpdateSpousePlanComponent" id="updateSpousePlan" class="modal fade mt-5 modal-lg" data-bs-backdrop="static" [spouseform]="spouseform" [formConfiguration]="formConfiguration"></app-update-spouseplan>
  <app-update-dependent id="updateDependent" class="modal fade modal-lg" data-bs-backdrop="static" [dependentform]="dependentform" [childrenId]="childrenId" [formConfiguration]="formConfiguration"></app-update-dependent>
  <app-invoice-details id="invoiceDetails" class="modal fade mt-3 modal-lg" data-bs-backdrop="static" [invoices]="invoicesList"></app-invoice-details>
  <app-health-card id="hicDetails" class="modal fade mt-3 modal-lg" data-bs-backdrop="static" [hicList]="hicList"></app-health-card>
  <app-health-plan id="hpbooklet" class="modal fade mt-3 modal-lg" data-bs-backdrop="static"></app-health-plan>
  <app-record-enrollment id="roe" class="modal fade mt-3 modal-lg" data-bs-backdrop="static" [roelink]="roe"></app-record-enrollment>
  <app-update-payment-method id="updatePaymentMethod" class="modal fade mt-3" data-bs-backdrop="static"></app-update-payment-method>
  <app-update-payment-info id="updatePaymentInfo" class="modal fade mt-3" data-bs-backdrop="static"></app-update-payment-info> -->

  <!-- Email Update Modal -->
  <!-- <div id="updateEmail" class="modal fade modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header" id="backgroundColor">
                  <h6 class="modal-title">{{lang1.emailUpdate}}</h6>
                  <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
              </div>
              <div class="modal-body">
                  <form>
                      <div class="row">
                          <div class="col-md-12 form-group">
                              <label id="modal-labels">{{lang?.Email}}<span style="color: red">*</span></label>
                              <input type="text" id="email" formControlName="email" class="form-control"
                                  (keypress)="(($event.charCode >= 65 && $event.charCode < 91)||($event.charCode >= 97 && $event.charCode < 123))">
                          </div>
                      </div>
                  </form>
              </div>
              <div class="modal-footer py-2">
                  <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
                      id="cancelButton"><b>{{lang?.Cancel}}</b></button>&nbsp;&nbsp;
                  <button type="button" class="btn btn-sm btn-light" id="updateButton">{{lang?.Update}}</button>
              </div>
          </div>
      </div>
  </div> -->

  <!-- Phone Update Modal -->
  <div id="updatePhoneNo" class="modal fade modalposition" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{ lang?.Update_Phone_No }}</span>
          <i #closePhonemodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          <form [formGroup]="phoneform">
            <div class="row">
              <div class="col-12 form-group">
                <label id="modal-labels">{{ lang?.Primary
                  }}<span style="color: red">*</span></label>
                <input type="tel" id="primaryPhone" placeholder="{{lang?.Primary}}" formControlName="primaryPhone"
                  class="form-control" (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
                  (keypress)="phoneFormat($event)" />
                <div *ngIf="
                      phoneForm['primaryPhone'].touched &&
                      phoneForm['primaryPhone'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        phoneForm['primaryPhone'].errors &&
                        phoneForm['primaryPhone'].errors['required']
                      ">
                    {{ lang?.Please_enter_Primary_Number }}
                  </div>
                  <div *ngIf="
                        phoneForm['primaryPhone'].errors &&
                        phoneForm['primaryPhone'].errors['minlength']
                      ">
                    {{ lang?.Phone_number_must_be_equal_to_10_digits }}
                  </div>
                  <div *ngIf="
                        phoneForm['primaryPhone'].errors &&
                        phoneForm['primaryPhone'].errors['maxlength']
                      ">
                    {{ lang?.Phone_number_maximum_of_10_digits }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 form-group">
                <label id="modal-labels">{{ lang?.Secondary }}</label>
                <input type="tel" id="secondaryPhone" placeholder="{{ lang?.Secondary }}"
                  formControlName="secondaryPhone" class="form-control"
                  (keypress)="($event.charCode >= 48 && $event.charCode < 58)" (keypress)="phoneFormat($event)" />
                <div *ngIf="
                      phoneForm['secondaryPhone'].touched &&
                      phoneForm['secondaryPhone'].invalid
                    " class="help-block text-danger">
                  <!-- <div *ngIf="phoneForm['secondaryPhone'].errors && phoneForm['secondaryPhone'].errors['required']">{{lang1.please_enter_secondary_number_cp}}</div> -->
                  <div *ngIf="
                        phoneForm['secondaryPhone'].errors &&
                        phoneForm['secondaryPhone'].errors['minlength']
                      ">
                    {{ lang?.Phone_number_must_be_equal_to_10_digits }}
                  </div>
                  <div *ngIf="
                        phoneForm['secondaryPhone'].errors &&
                        phoneForm['secondaryPhone'].errors['maxlength']
                      ">
                    {{ lang?.Phone_number_maximum_of_10_digits }}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
            (click)="closePhoneModal()">
            <b>{{ lang?.Cancel }}</b></button>&nbsp;&nbsp;
          <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="updatePhoneNo('updatePhoneNo')">
            {{ lang?.Update }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Address Update Modal -->
  <div id="updateAddress" class="modal modal-md fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true" style="max-width: 100%">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{lang?.Update_Member_Info}}</span>
          <i #closeAddressmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          <form [formGroup]="addressform">
            <div class="row">
              <div class="col-6 form-group">
                <label id="modal-labels">{{lang?.First_Name}}<span style="color: red">*</span></label>
                <input type="text" id="primaryPhone" placeholder="{{lang?.First_Name}}" formControlName="firstName"
                  class="form-control" />
                <div *ngIf="
                      addressForm['firstName'].touched &&
                      addressForm['firstName'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        addressForm['firstName'].errors &&
                        addressForm['firstName'].errors['required']
                      ">
                    {{lang?.Please_enter_first_name}}
                  </div>
                </div>
              </div>
              <div class="col-6 form-group">
                <label id="modal-labels">{{lang?.Last_Name}}<span style="color: red">*</span></label>
                <input type="text" id="primaryPhone" placeholder="{{lang?.Last_Name}}" formControlName="lastName"
                  class="form-control" />
                <div *ngIf="
                      addressForm['lastName'].touched &&
                      addressForm['lastName'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        addressForm['lastName'].errors &&
                        addressForm['lastName'].errors['required']
                      ">
                    {{lang?.Please_enter_last_name}}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 form-group">
                <label id="modal-labels">{{ lang?.Primary_Phone_Number }}<span style="color: red">*</span></label>
                <input type="tel" id="primaryPhone" placeholder="Primary Phone Number" formControlName="primaryPhone"
                  class="form-control" (change)="phoneFormat($event)" />
                <div *ngIf="
                      addressForm['primaryPhone'].touched &&
                      addressForm['primaryPhone'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        addressForm['primaryPhone'].errors &&
                        addressForm['primaryPhone'].errors['required']
                      ">
                    {{ lang?.Please_enter_Primary_Number }}
                  </div>
                  <div *ngIf="
                        addressForm['primaryPhone'].errors &&
                        addressForm['primaryPhone'].errors['minlength']
                      ">
                    {{ lang?.Phone_number_must_be_equal_to_10_digits }}
                  </div>
                  <div *ngIf="
                        addressForm['primaryPhone'].errors &&
                        addressForm['primaryPhone'].errors['maxlength']
                      ">
                    {{ lang?.Phone_number_maximum_of_10_digits }}
                  </div>
                </div>
              </div>
              <div class="col-6 form-group">
                <label id="modal-labels">{{ lang?.Secondary_Phone_Number }}</label>
                <input type="tel" id="secondaryPhone" placeholder="{{ lang?.Secondary_Phone_Number }}"
                  formControlName="secondaryPhone" class="form-control" (keypress)="
                      (($event.charCode >= 48 && $event.charCode < 58) ||
                        $event.charCode == 32)
                    " (keypress)="phoneFormat($event)" />
                <div *ngIf="
                      addressForm['secondaryPhone'].touched &&
                      addressForm['secondaryPhone'].invalid
                    " class="help-block text-danger">
                  <!-- <div *ngIf="addressForm['secondaryPhone'].errors && addressForm['secondaryPhone'].errors['required']">{{lang1.please_enter_secondary_number_cp}}</div> -->
                  <div *ngIf="
                        addressForm['secondaryPhone'].errors &&
                        addressForm['secondaryPhone'].errors['minlength']
                      ">
                    {{ lang?.Phone_number_must_be_equal_to_10_digits }}
                  </div>
                  <div *ngIf="
                        addressForm['secondaryPhone'].errors &&
                        addressForm['secondaryPhone'].errors['maxlength']
                      ">
                    {{ lang?.Phone_number_maximum_of_10_digits }}
                  </div>
                </div>
                <div class="help-block text-danger" *ngIf="secondaryphonecheck">
                  {{lang?.Phone_number_already_exists}}
                </div>

                <!-- <div class="help-block text-danger" *ngIf="addressform.hasError('phoneNumbersMatch')">Phone number already exists</div> -->
              </div>
              <div class="col-6 form-group">
                <label id="modal-labels">{{lang?.Email}}<span style="color: red">*</span></label>
                <input type="text" id="email" placeholder="Email" formControlName="email" class="form-control" />
                <div *ngIf="
                      addressForm['email'].touched && addressForm['email'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        addressForm['email'].errors &&
                        addressForm['email'].errors['required']
                      ">Please enter email
                  </div>
                    <div *ngIf="
                                            addressForm['email'].errors &&
                                            addressForm['email'].errors['pattern']
                                          ">{{ lang?.Please_enter_valid_email }}
                    </div>
                </div>
                <!-- <div class="help-block text-danger" *ngIf="secondaryphonecheck">
                    {{lang?.Phone_number_already_exists}}
                  </div> -->

                <!-- <div class="help-block text-danger" *ngIf="addressform.hasError('phoneNumbersMatch')">Phone number already exists</div> -->
              </div>
              <div class="col-6 form-group">
                <label id="modal-labels">{{ lang?.Country
                  }}<span style="color: red">*</span></label>
                <select class="form-select" formControlName="country">
                  <option value="" disabled>{{ lang?.Select }}</option>
                  <option value="Canada">Canada</option>
                </select>
                <div *ngIf="
                      addressForm['country'].touched &&
                      addressForm['country'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        addressForm['country'].errors &&
                        addressForm['country'].errors['required']
                      ">
                    {{ lang?.Please_select_country }}
                  </div>
                </div>
              </div>
            </div>
             <div class="row">
            <div class="col-6 form-group">
              <label id="modal-labels">{{lang?.Gender}}<span style="color: red">*</span></label>

                <select class="form-select" formControlName="gender">
                    <option value="">{{ lang.Select }}</option>
                    <option value="Male">{{ lang.Male }}</option>
                    <option value="Female">{{ lang.Female }}</option>
                    <option value="Non-Binary">{{ lang.Non_Binary }}</option>
                    <option value="Undisclosed">{{ lang.Undisclosed }}</option>
                </select>
              <div *ngIf="
                                  addressForm['gender'].touched && addressForm['gender'].invalid
                                " class="help-block text-danger">
                <div *ngIf="
                                    addressForm['gender'].errors &&
                                    addressForm['gender'].errors['required']
                                  ">Please select gender
                </div>
              </div>
              <!-- <div class="help-block text-danger" *ngIf="secondaryphonecheck">
                                {{lang?.Phone_number_already_exists}}
                              </div> -->

              <!-- <div class="help-block text-danger" *ngIf="addressform.hasError('phoneNumbersMatch')">Phone number already exists</div> -->
            </div>
            <div class="col-6 form-group">
              <label id="modal-labels">{{ lang?.Date_of_Birth
                }}<span style="color: red">*</span></label>
              <input type="text" (paste)="(false)" class="form-control" formControlName="dob" [minDate]="minDate"
                [maxDate]="maxDate" #dp [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" placeholder="MM-DD-YYYY"
                bsDatepicker (blur)="checkDateOfBirth1($event)" (input)="checkDateOfBirth1($event)" (keypress)="numbersOnly($event)" />

              <div *ngIf="
                                  addressForm['dob'].touched &&
                                  addressForm['dob'].invalid
                                " class="help-block text-danger">
                <div *ngIf="
                                    addressForm['dob'].errors &&
                                    addressForm['dob'].errors['required']
                                  ">
                  Please Select Date of Birth
                </div>
              </div>
            </div>
          </div>
            <div class="row">
              <div class="col-md-6 form-group mt-2">
                <label id="modal-labels">{{ lang?.Street_Address }}<span style="color: red">*</span></label>
                <input type="text" id="line1" placeholder="Street Address" formControlName="line1" class="form-control"
                  (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        ($event.charCode >= 48 && $event.charCode < 58) ||
                        $event.charCode == 32)
                    " (input)="checkFirstCharacter($event, addressform)" />
                <div *ngIf="
                      addressForm['line1'].touched && addressForm['line1'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        addressForm['line1'].errors &&
                        addressForm['line1'].errors['required']
                      ">
                    {{ lang?.Please_enter_street_address }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 form-group mt-2">
                <label id="modal-labels">{{
                  lang?.Street_Address_Line_2
                  }}</label>
                <input type="text" id="line2" placeholder="Street Address Line 2" formControlName="line2"
                  class="form-control" (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        ($event.charCode >= 48 && $event.charCode < 58) ||
                        $event.charCode == 32)
                    " (input)="checkFirstCharacter($event, addressform)" />
                <!-- <div *ngIf="addressForm['line2'].touched && addressForm['line2'].invalid"
                                  class="help-block text-danger">
                                  <div *ngIf="addressForm['line2'].errors && addressForm['line2'].errors['required']">
                                      Please enter Street Address line 2</div>
                              </div> -->
              </div>
            </div>
            <div class="row">
              <!-- <div class="col-md-3 form-group mt-2">
                              <label>Apt./Suite Number</label>
                              <input type="text" class="form-control">
                              <div *ngIf="addressForm['secondaryPhone'].touched && addressForm['secondaryPhone'].invalid" class="help-block text-danger">
                                  <div *ngIf="addressForm['secondaryPhone'].errors && addressForm['secondaryPhone'].errors['required']">Please enter Secondary Number</div>
                              </div>
                          </div> -->

              <div class="col-md-4 col-6 form-group mt-2">
                <label id="modal-labels">{{ lang?.City }}<span style="color: red">*</span></label>
                <input type="text" id="city" placeholder="City" formControlName="city" class="form-control" (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        $event.charCode == 32)
                    " (input)="checkFirstCharacter($event, addressform)" />
                <div *ngIf="
                      addressForm['city'].touched && addressForm['city'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        addressForm['city'].errors &&
                        addressForm['city'].errors['required']
                      ">
                    {{ lang?.Please_enter_city }}
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-6 form-group mt-2">
                <label id="modal-labels">{{ lang?.Province
                  }}<span style="color: red">*</span></label>
                <select class="form-select" formControlName="province" (change)="provincelist($event)">
                  <option value="" disabled>{{ lang?.Select }}</option>
                  <option *ngFor="let states of provianceList" [value]="states.shortName">
                    {{ states.shortName }}
                  </option>
                </select>
                <div *ngIf="
                      addressForm['province'].touched &&
                      addressForm['province'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        addressForm['province'].errors &&
                        addressForm['province'].errors['required']
                      ">
                    {{ lang?.Please_select_province }}
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-6 form-group mt-2">
                <label id="modal-labels">{{ lang?.Postal_Code
                  }}<span style="color: red">*</span></label>
                <input type="text" id="postalCode" placeholder="Postal Code" formControlName="postalCode"
                  class="form-control" (input)="changeTextToUppercase($event)" />
                <div *ngIf="
                      addressForm['postalCode'].touched &&
                      addressForm['postalCode'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        addressForm['postalCode'].errors &&
                        addressForm['postalCode'].errors['required']
                      ">
                    {{ lang?.Please_enter_postal_code }}
                  </div>
                </div>
                <div class="help-block text-danger" *ngIf="
                      (addressForm['postalCode'].touched &&
                        addressForm['postalCode'].hasError(
                          'invalidPostalCode'
                        )) ||
                      addressForm['postalCode'].invalid ||
                      (invalidpostalcodeprivince &&
                        !addressForm['province'].hasError('required'))
                    ">
                  {{ lang?.Please_enter_valid_postal_code }}
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
            <b>{{ lang?.Close }}</b></button>&nbsp;
          <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="updateAddress()">
            {{ lang?.Update }}
          </button>
          <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" data-bs-toggle="modal" data-bs-target="#valesign" data-bs-dismiss="modal" [disabled]="addressform.invalid" (click)="valisignModal()">{{lang?.Update}}</button> -->
        </div>
      </div>
    </div>
  </div>

  <!-- Executive options -->
  <div id="updateExecutiveOptions" class="modal modal-md fade" data-bs-backdrop="static" data-bs-keyboard="false"
    tabindex="-1" aria-hidden="true" style="max-width: 100%">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{lang?.Update_Member_Info}}</span>
          <i #closeExecutivesmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">


          <div class="row" *ngFor="let option of executivePlanOptionsValuesArray">
            <span><b>{{option.name}}</b><span style="color: red; margin-left:0px;">*</span></span>

            <div class="row" *ngFor="let optionvalue of option.planOptionsValues">
              <div class="col-md-12" style="border: 1px solid black;border-bottom:1px !important;font-size:14px">
                <input type="radio" value="{{optionvalue.json}}" name="planoptions"
                  id="planselectionvalue-{{optionvalue.id}}-{{option.id}}" #optionUnseelct
                  class="optionselectionmethod-{{option.id}}"
                  (change)="planoptionselection($event,optionvalue,option?.id,optionvalue?.id,i,'optionselectionmethod-')">&nbsp;{{optionvalue?.name}}

              </div>
            </div>

            <br>
          </div>

        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
            <b>{{ lang?.Close }}</b></button>&nbsp;
          <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="updateExecutiveOptionsValues()">
            {{ lang?.Update }}
          </button>
          <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" data-bs-toggle="modal" data-bs-target="#valesign" data-bs-dismiss="modal" [disabled]="addressform.invalid" (click)="valisignModal()">{{lang?.Update}}</button> -->
        </div>
      </div>
    </div>
  </div>
  <div id="hpbooklet" class="modal fade modal-lg modalposition" tabindex="-1" role="dialog"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{ lang?.View_Plan_Booklets }}</span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="closeBooklet()"></i>
        </div>
        <div class="modal-body">
          <!-- <div class="table-responsive" *ngIf="!hidebooklet">
                    <table class="table-striped" id="table">
                        <thead id="thead">
                            <tr>
                                <th class="fw-normal">&nbsp;S.No</th>
                                <th class="fw-normal">Name</th>
                                <th class="fw-normal">Description</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let booklet of bookletList; let i=index">
                                <td>&nbsp;{{i+1}}</td>
                                <td>{{booklet.name}}</td>
                                <td>{{booklet.description}}</td>
                                <td id="booklet-td">
                                    <img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" class="m-1" (click)="viewBooklet(booklet.link)">
                                    <img role="button" src="/assets/img/download.png" alt="" id="img" (click)="downloadHpbooklet(booklet)">&nbsp;
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->
          <!-- <div *ngIf="hidebooklet">
                    <pdf-viewer [src]="bookletLink" style="width: 100%; height: 400px;"></pdf-viewer>
                </div> -->
          <span *ngIf="showViewPlansLoading">
            <img src="../../../assets/img/tenor.gif" width="100" style="
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                  width: 25%;
                " />
          </span>
          <div>
            <pdf-viewer *ngIf="true" [src]="bookletLink" id="pdf-viewer"
              (after-load-complete)="viewPlansLoading($event)"></pdf-viewer>
          </div>
        </div>
        <div class="modal-footer py-2">
          <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeBooklet()" *ngIf="hidebooklet"><b>Back</b></button>&nbsp;&nbsp; -->
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
            (click)="closeBooklet()">
            <b>{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div id="hicDetails" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <!-- {{lang1.health_insurance_card_details_cp}} -->
          <span class="modal-title">{{lang?.Member_Cards}}</span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="closeHealthCard()"></i>
        </div>
        <div class="modal-body">
          <!-- <div class="table-responsive" *ngIf="!healthCard">
                    <table class=" table-striped" id="table">
                        <thead>
                            <tr>
                                <th class="fw-normal text-nowrap">Full Name</th>
                                <th class="fw-normal">Email</th>
                                <th class="fw-normal text-nowrap">Date of Birth</th>
                                <th class="fw-normal">Gender</th>
                                <th class="fw-normal">Relation</th>
                                <th class="fw-normal text-nowrap">Phone No.</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let hic of hicList">
                                <td class="text-nowrap">{{hic.name | titlecase}}</td>
                                <td>{{hic.email}}</td>
                                <td>{{hic.dob | date : "MM-dd-YYYY"}}</td>
                                <td>{{hic.gender}}</td>
                                <td>{{hic.relation}}</td>
                                <td class="text-nowrap">{{hic.phoneNum | phoneNoFormat}}</td>
                                <td><img role="button" src="/assets/img/view.png" alt="" width="20px"
                                        height="20px" (click)="viewHealthCard(hic)"></td>
                                <td><img role="button" src="/assets/img/download.png" alt="" id="img"
                                        (click)="downloadHic(hic)"></td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->
          <div *ngIf="card">
            <h6>{{ lang?.Please_check_back_later_or_contact_your_Advisor }}</h6>
          </div>
          <span *ngIf="showFifh">
            <img src="../../../assets/img/tenor.gif" width="100" style="
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                  width: 25%;
                " />
          </span>
          <div *ngIf="healthCard">
            <pdf-viewer [src]="src" id="pdf-viewer" style="zoom: 0.85" view:fitH
              (after-load-complete)="showLoaderfith($event)"></pdf-viewer>
          </div>
        </div>
        <div class="modal-footer py-2">
          <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeHealthCard()"
                    *ngIf="healthCard"><b>Back</b></button>&nbsp;&nbsp; -->
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
            (click)="closeHealthCard()">
            <b>{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--  ROE Modal -->
  <div id="roe" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{ lang?.Record_of_Enrollment }}</span>
          <i #openRoe class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="closeRoe()"></i>
        </div>
        <div class="modal-body">
          <div *ngIf="viewRoe">
            <pdf-viewer [src]="roe" style="zoom: 0.85" id="pdf-viewer" view:fitH></pdf-viewer>
          </div>
          <div *ngIf="!viewRoe">
            <span>{{ lang?.Currently_ROE_is_not_available }}</span>
          </div>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
            (click)="closeRoe()">
            <b>{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div id="padagreement" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">Pre Authorized Debit (PAD)</span>
          <i #openRoe class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="closeRoe()"></i>
        </div>
        <div class="modal-body">
          <div *ngIf="padAgreement">
            <pdf-viewer [src]="padAgreement" style="zoom: 0.85" id="pdf-viewer" view:fitH></pdf-viewer>
          </div>
          <div *ngIf="!padAgreement">
            <span>Cureently PAD is not available.</span>
          </div>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
            <b>{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Spouse Plan Update Modal -->
  <div id="updateSpousePlan" class="modal fade modalposition modal-md" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" id="backgroundColor">
          <span *ngIf="spouseUpdate" class="modal-title">{{
            lang?.Update_Spouse_s_Details
            }}</span>
          <span *ngIf="!spouseUpdate" class="modal-title">{{
            lang?.Marital_Status
            }}</span>
          <i #closeSpousemodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          <form [formGroup]="spouseform" *ngIf="spouseStatus">
            <div class="row">
              <div class="col-md-6 form-group">
                <label id="modal-labels">{{ lang?.First_Name
                  }}<span style="color: red">*</span></label>
                <input type="text" placeholder="First Name" class="form-control" id="firstName"
                  formControlName="firstName" (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        $event.charCode == 32)
                    " (input)="checkFirstCharacter($event, spouseform)" />
                <div *ngIf="
                      spouseForm['firstName'].touched &&
                      spouseForm['firstName'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        spouseForm['firstName'].errors &&
                        spouseForm['firstName'].errors['required']
                      ">
                    {{ lang?.Please_enter_first_name }}
                  </div>
                  <div *ngIf="
                        spouseForm['firstName'].errors &&
                        spouseForm['firstName'].errors['minlength']
                      ">
                    {{ lang?.First_Name_minimum_of_2_Characters_and_without_numbers }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 form-group">
                <label id="modal-labels">{{ lang?.Last_Name
                  }}<span style="color: red">*</span></label>
                <input type="text" placeholder="Last Name" class="form-control" id="lastName" formControlName="lastName"
                  (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        $event.charCode == 32)
                    " (input)="checkFirstCharacter($event, spouseform)" />
                <div *ngIf="
                      spouseForm['lastName'].touched &&
                      spouseForm['lastName'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        spouseForm['lastName'].errors &&
                        spouseForm['lastName'].errors['required']
                      ">
                    {{ lang?.Please_enter_last_name }}
                  </div>
                  <div *ngIf="
                        spouseForm['lastName'].errors &&
                        spouseForm['lastName'].errors['minlength']
                      ">
                    {{ lang?.Last_Name_minimum_of_2_Characters_and_without_numbers }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 form-group">
                <label id="modal-labels">{{ lang?.Date_of_Birth
                  }}<span style="color: red">*</span></label>
                <!-- <input type="text" class="form-control date" formControlName="dob" placeholder="mm-dd-yyyy"> -->
                <!-- <input type="text" placeholder="mm-dd-yyyy" class="form-control date" formControlName="dob" bsDatepicker [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }"> -->
                <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field" formControlName="dob"
                  [minDate]="minDate" [maxDate]="maxDate" bsDatepicker
                  [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
                <div *ngIf="spouseForm['dob'].touched && spouseForm['dob'].invalid" class="help-block text-danger">
                  <div *ngIf="
                        spouseForm['dob'].errors &&
                        spouseForm['dob'].errors['required']
                      ">
                    {{ lang?.Please_choose_date_of_birth }}
                  </div>
                </div>
              </div>
              <div class="col-6 form-group">
                <label id="modal-labels">{{ lang?.Email }}</label>
                <input type="email" placeholder="Email" class="form-control" formControlName="email" />
                <div *ngIf="
                      spouseForm['email'].touched && spouseForm['email'].invalid
                    " class="help-block text-danger">
                  <!-- <div *ngIf="spouseForm['email'].errors && spouseForm['email'].errors['required']">Please enter email</div> -->
                  <div *ngIf="
                        spouseForm['email'].errors &&
                        spouseForm['email'].errors['pattern']
                      ">
                    {{ lang?.Please_enter_valid_email }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 form-group">
                <label id="modal-labels">{{ lang?.Gender }}<span style="color: red">*</span></label>
                <select class="form-select" formControlName="gender">
                  <option value="" disabled>{{ lang?.Select }}</option>
                  <option *ngFor="let gender of formConfiguration.gender" value="{{ gender }}">
                    {{ gender }}
                  </option>
                </select>
                <div *ngIf="
                      spouseForm['gender'].touched && spouseForm['gender'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        spouseForm['gender'].errors &&
                        spouseForm['gender'].errors['required']
                      ">
                    {{ lang?.Please_select_gender }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 form-group">
                <label id="modal-labels"><b>{{
                    lang?.Is_your_spouse_covered_by_another_Health_and_or_Dental_insurance_plan_through_their_employer
                    }}<span style="color: red">*</span></b></label>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <input type="radio" [value]="true" name="coveredByAnotherPlan" formControlName="coveredByAnotherPlan"
                  [(ngModel)]="spouseCoverage" [checked]="spouseCoverage == true"
                  (click)="openCoverage('open')" />&nbsp;<label id="radio-labels" class="align-text-top">{{
                  lang?.Yes
                  }}</label>
              </div>
              <div class="col-3">
                <input type="radio" [value]="false" name="coveredByAnotherPlan" formControlName="coveredByAnotherPlan"
                  [(ngModel)]="spouseCoverage" [checked]="spouseCoverage == false"
                  (click)="openCoverage('close')" />&nbsp;<label id="radio-labels" class="align-text-top">{{
                  lang?.No
                  }}</label>
              </div>
              <div *ngIf="
                    spouseForm['coveredByAnotherPlan'].touched &&
                    spouseForm['coveredByAnotherPlan'].invalid
                  " class="help-block text-danger">
                <div *ngIf="
                      spouseForm['coveredByAnotherPlan'].errors &&
                      spouseForm['coveredByAnotherPlan'].errors['required']
                    ">
                  {{ lang?.Please_choose_spouse_insurance_status }}
                </div>
              </div>
            </div>
            <div class="row" *ngIf="spouseCoverage && coverage === 'open'">
              <div class="col-6 form-group">
                <label id="modal-labels">{{ lang?.Name_Of_The_Carrier
                  }}<span style="color: red">*</span></label>
                <input type="text" placeholder="Name of the Carrier" class="form-control" id="insurer"
                  formControlName="insurer" (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        $event.charCode == 32)
                    " (input)="checkFirstCharacter($event, spouseform)" />
                <div *ngIf="
                      spouseForm['insurer'].touched &&
                      spouseForm['insurer'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        spouseForm['insurer'].errors &&
                        spouseForm['insurer'].errors['required']
                      ">
                    {{ lang?.Please_enter_name_of_carrier }}
                  </div>
                </div>
              </div>
              <div class="col-6 form-group">
                <label id="modal-labels">{{ lang?.Coverage
                  }}<span style="color: red">*</span></label>
                <select class="form-select" formControlName="healthPlan">
                  <option value="" disabled>{{ lang?.Select }}</option>
                  <option *ngFor="let cobCoverage of formConfiguration.cobCoverage" value="{{ cobCoverage.key }}">
                    {{ cobCoverage.display }}
                  </option>
                </select>
                <div *ngIf="
                      spouseForm['healthPlan'].touched &&
                      spouseForm['healthPlan'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        spouseForm['healthPlan'].errors &&
                        spouseForm['healthPlan'].errors['required']
                      ">
                    {{ lang?.Please_enter_COB_coverage }}
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div *ngIf="!spouseStatus">
            <form [formGroup]="spouseform">
              <div class="row">
                <div class="col-md-6 form-group">
                  <label id="modal-labels">{{ lang?.Marital_Status
                    }}<span style="color: red">*</span></label>
                  <select class="form-select" formControlName="martialStatus">
                    <option value="" disabled>{{ lang?.Select }}</option>
                    <option value="Common-Law">{{lang?.Common_Law}}</option>
                    <option value="Divorced">{{lang?.Divorced}}</option>
                    <option value="Married">{{lang?.Married}}</option>
                    <option value="Seperated">{{lang?.Separated}}</option>
                    <option value="Single">{{lang?.Single}}</option>
                    <option value="Widowed">{{lang?.Widowed}}</option>
                  </select>
                  <div *ngIf="
                        spouseForm['martialStatus'].touched &&
                        spouseForm['martialStatus'].invalid
                      " class="help-block text-danger">
                    <div *ngIf="
                          spouseForm['martialStatus'].errors &&
                          spouseForm['martialStatus'].errors['required']
                        ">
                      {{ lang?.Please_select_marital_status }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 form-group">
                  <label id="modal-labels">{{ lang?.Effective_Date
                    }}<span style="color: red">*</span></label>
                  <!-- <input type="text" class="form-control date" formControlName="effectiveDate" placeholder="mm-dd-yyyy"> -->
                  <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field"
                    formControlName="effectiveDate" placement="top" bsDatepicker
                    [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
                  <div *ngIf="
                        spouseForm['effectiveDate'].touched &&
                        spouseForm['effectiveDate'].invalid
                      " class="help-block text-danger">
                    <div *ngIf="
                          spouseForm['effectiveDate'].errors &&
                          spouseForm['effectiveDate'].errors['required']
                        ">
                      {{ lang?.Please_choose_effective_date }}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
            (click)="closeSpouseForm()">
            <b>{{ lang?.Cancel }}</b></button>&nbsp;
          <button type="button" class="btn btn-sm btn-light" *ngIf="spouseUpdate" id="updateButton"
            (click)="updateSpouseDetails()">
            {{ lang?.Update }}
          </button>
          <button type="button" class="btn btn-sm btn-light" *ngIf="!spouseUpdate" id="updateButton"
            (click)="addSpouseData()">
            {{ lang?.Update }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--  Dependent Update Modal -->
  <div id="updateDependent" class="modal fade modalposition modal-md" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content" id="dependent-content">
        <div class="modal-header" id="backgroundColor">
          <span *ngIf="dependentUpdate" class="modal-title">{{
            lang?.Update_Dependent_Info
            }}</span>
          <span *ngIf="!dependentUpdate" class="modal-title">{{
            lang?.Dependents
            }}</span>
          <i #closeDependentmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          <form [formGroup]="dependentform" *ngIf="dependentStatus">
            <div class="row">
              <div class="col-md-6 form-group">
                <label id="modal-labels">{{ lang?.First_Name
                  }}<span style="color: red">*</span></label>
                <input type="text" placeholder="{{lang?.First_Name}}" id="firstName" formControlName="firstName"
                  class="form-control" (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        $event.charCode == 32)
                    " (input)="checkFirstCharacter($event, dependentform)" />
                <div *ngIf="
                      dependentForm['firstName'].touched &&
                      dependentForm['firstName'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        dependentForm['firstName'].errors &&
                        dependentForm['firstName'].errors['required']
                      ">
                    {{ lang?.Please_enter_first_name }}
                  </div>
                  <div *ngIf="
                        dependentForm['firstName'].errors &&
                        dependentForm['firstName'].errors['minlength']
                      ">
                    {{ lang?.First_Name_minimum_of_2_Characters_and_without_numbers }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 form-group">
                <label id="modal-labels">{{ lang?.Last_Name
                  }}<span style="color: red">*</span></label>
                <input type="text" placeholder="{{lang?.Last_Name}}" id="lastName" formControlName="lastName"
                  class="form-control" (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        $event.charCode == 32)
                    " (input)="checkFirstCharacter($event, dependentform)" />
                <div *ngIf="
                      dependentForm['lastName'].touched &&
                      dependentForm['lastName'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        dependentForm['lastName'].errors &&
                        dependentForm['lastName'].errors['required']
                      ">
                    {{ lang?.Please_enter_last_name }}
                  </div>
                  <div *ngIf="
                        dependentForm['lastName'].errors &&
                        dependentForm['lastName'].errors['minlength']
                      ">
                    {{ lang?.Last_Name_minimum_of_2_Characters_and_without_numbers }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 form-group">
                <label id="modal-labels">{{ lang?.Gender }}<span style="color: red">*</span></label>
                <select class="form-select" formControlName="gender">
                  <option value="" disabled>{{ lang?.Select }}</option>
                  <option *ngFor="let gender of formConfiguration.gender" value="{{ gender }}">
                    {{ gender }}
                  </option>
                </select>
                <div *ngIf="
                      dependentForm['gender'].touched &&
                      dependentForm['gender'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        dependentForm['gender'].errors &&
                        dependentForm['gender'].errors['required']
                      ">
                    {{ lang?.Please_select_gender }}
                  </div>
                </div>
              </div>
              <div class="col-6 form-group">
                <label id="modal-labels">{{ lang?.Date_of_Birth
                  }}<span style="color: red">*</span></label>
                <!-- <input type="text" id="dob" formControlName="dob" placeholder="mm-dd-yyyy" class="form-control date"> -->
                <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field" id="dob"
                  formControlName="dob" [minDate]="minDatechild" [maxDate]="maxDatechild" bsDatepicker
                  [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
                <div *ngIf="
                      dependentForm['dob'].touched && dependentForm['dob'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        dependentForm['dob'].errors &&
                        dependentForm['dob'].errors['required']
                      ">
                    {{ lang?.Please_choose_date_of_birth }}
                  </div>
                  <!-- <div *ngIf="dependentForm['dob'].errors && dependentForm['dob'].errors['childrenminimumAge']">

                      Age must be below 21 years
                    </div> -->
                  <div class="help-block text-danger"
                    *ngIf="dependentForm['dob'].touched && dependentForm['dob'].hasError('childrenminimumAge')">
                    Age must be below 21 years
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-3 form-group mt-3">
                              <label id="modal-labels">Age<span style="color: red">*</span></label>
                              <input type="text" id="age" formControlName="age" class="form-control">
                              <div *ngIf="dependentForm['age'].touched && dependentForm['age'].invalid" class="help-block text-danger">
                                  <div *ngIf="dependentForm['age'].errors && dependentForm['age'].errors['required']">Please enter age</div>
                              </div>
                          </div>
                          <div class="col-md-3 form-group mt-3">
                              <label id="modal-labels">Phone No<span style="color: red">*</span></label>
                              <input type="text" id="phoneNum" formControlName="phoneNum" class="form-control">
                              <div *ngIf="dependentForm['phoneNum'].touched && dependentForm['phoneNum'].invalid" class="help-block text-danger">
                                  <div *ngIf="dependentForm['phoneNum'].errors && dependentForm['phoneNum'].errors['required']">Please enter phone number</div>
                              </div>
                          </div> -->
            </div>
            <div class="row">
              <div class="col-md-12 form-group">
                <label id="modal-labels"><b>{{
                    lang?.Is_your_dependent_covered_by_another_Health_and_or_Dental_Insurance_plan
                    }}<span style="color: red">*</span></b></label>
              </div>
            </div>
            <div class="row">
              <div class="col-3 mt-1">
                <input type="radio" [value]="true" name="coveredByAnotherPlan" formControlName="coveredByAnotherPlan"
                  [checked]="childCoverage === true" (click)="openDependentCoverage('open')" />&nbsp;<label
                  id="radio-labels" class="align-text-top">{{
                  lang?.Yes
                  }}</label>
              </div>
              <div class="col-3 mt-1">
                <input type="radio" [value]="false" name="coveredByAnotherPlan" formControlName="coveredByAnotherPlan"
                  [checked]="childCoverage === false" (click)="openDependentCoverage('close')" />&nbsp;<label
                  id="radio-labels" class="align-text-top">{{
                  lang?.No
                  }}</label>
              </div>
              <div *ngIf="
                    dependentForm['coveredByAnotherPlan'].touched &&
                    dependentForm['coveredByAnotherPlan'].invalid
                  " class="help-block text-danger">
                <div *ngIf="
                      dependentForm['coveredByAnotherPlan'].errors &&
                      dependentForm['coveredByAnotherPlan'].errors['required']
                    ">
                  {{ lang?.Please_choose_dependent_insurance_status }}
                </div>
              </div>
            </div>
            <div class="row" *ngIf="childCoverage && dependentCoverage === 'open'">
              <div class="col-6 form-group">
                <label id="modal-labels">{{ lang?.Name_Of_The_Carrier
                  }}<span style="color: red">*</span></label>
                <input type="text" placeholder="Name of the Carrier" class="form-control" formControlName="carrierName"
                  id="carrierName" (keypress)="
                      (($event.charCode >= 65 && $event.charCode < 91) ||
                        ($event.charCode >= 97 && $event.charCode < 123) ||
                        $event.charCode == 32)
                    " (input)="checkFirstCharacter($event, dependentform)" />
                <div *ngIf="
                      dependentForm['carrierName'].touched &&
                      dependentForm['carrierName'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        dependentForm['carrierName'].errors &&
                        dependentForm['carrierName'].errors['required']
                      ">
                    {{ lang?.Please_enter_name_of_carrier }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-8 align-items-center">
                <div class="row">
                  <div class="col-1" id="checkbox">
                    <input type="checkbox" value="true" formControlName="specialNeeds"
                      [checked]="specialNeeds === 'true'" />
                  </div>
                  <div class="col-11">
                    <b id="modal-labels">{{
                      lang?.Dependent_with_Special_Needs
                      }}</b>&nbsp;<i class="bi bi-info-circle"></i>
                  </div>
                </div>
              </div>
              <!-- <div *ngIf="dependentForm['specialNeeds'].touched && dependentForm['specialNeeds'].invalid" class="help-block text-danger">
                              <div *ngIf="dependentForm['specialNeeds'].errors && dependentForm['specialNeeds'].errors['required']">Please enter</div>
                          </div> -->
            </div>
            <div class="row mt-2">
              <div class="col-md-8 align-items-center">
                <div class="row">
                  <div class="col-1" id="checkbox">
                    <input type="checkbox" value="true" formControlName="postSecondaryStudent"
                      [checked]="postSecondaryStudent === true" (change)="openGraduationDate($event)" />
                  </div>
                  <div class="col-11">
                    <b id="modal-labels">{{
                      lang?.Post_Secondary_Student
                      }}</b>&nbsp;<i class="bi bi-info-circle"></i>
                  </div>
                </div>
              </div>
              <!-- <div *ngIf="dependentForm['postSecondaryStudent'].touched && dependentForm['postSecondaryStudent'].invalid" class="help-block text-danger">
                              <div *ngIf="dependentForm['postSecondaryStudent'].errors && dependentForm['postSecondaryStudent'].errors['required']">Please enter first name</div>
                          </div> -->
            </div>
            <div class="row" *ngIf="postSecondaryStudent && graduationDate">
              <form [formGroup]="dependentform">
                <div class="row">
                  <div class="col-md-6 col-6 form-group">
                    <label id="modal-labels">{{ lang?.Graduation_Day
                      }}<span style="color: red">*</span></label>
                    <!-- <input type="text" placeholder="mm-dd-yyyy" class="form-control date" name="graduationDate" formControlName="graduationDate"> -->
                    <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field"
                      name="graduationDate" formControlName="graduationDate" placement="top" bsDatepicker
                      [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
                  </div>
                  <div *ngIf="
                        dependentForm['graduationDate'].touched &&
                        dependentForm['graduationDate'].invalid
                      " class="help-block text-danger">
                    <div *ngIf="
                          dependentForm['graduationDate'].errors &&
                          dependentForm['graduationDate'].errors['required']
                        ">
                      {{ lang?.Please_choose_graduation_date }}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </form>
          <div *ngIf="!dependentUpdate">
            <form [formGroup]="dependentform">
              <div class="row">
                <div class="col-md-6 form-group">
                  <label id="modal-labels">{{ lang?.Effective_Date
                    }}<span style="color: red">*</span></label>
                  <!-- <input type="text" class="form-control date" formControlName="effectiveDate" placeholder="mm-dd-yyyy"> -->
                  <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field" name="effectiveDate"
                    formControlName="effectiveDate" placement="top" bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }" />
                  <div *ngIf="
                        dependentForm['effectiveDate'].touched &&
                        dependentForm['effectiveDate'].invalid
                      " class="help-block text-danger">
                    <div *ngIf="
                          dependentForm['effectiveDate'].errors &&
                          dependentForm['effectiveDate'].errors['required']
                        ">
                      {{ lang?.Please_choose_effective_date }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mt-2">
                  <button type="button" *ngIf="dependentStatus" class="btn btn-sm btn-light" id="updateButton"
                    (click)="addAnotherDependent()">
                    {{ lang?.Add_another_dependent }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
            (click)="closeDependentForm()">
            <b>{{ lang?.Cancel }}</b></button>&nbsp;&nbsp;
          <button type="button" *ngIf="dependentUpdate" class="btn btn-sm btn-light" id="updateButton"
            (click)="updateDependent()">
            {{ lang?.Update }}
          </button>
          <button type="button" *ngIf="!dependentUpdate" class="btn btn-sm btn-light" id="updateButton"
            (click)="addDependentData()">
            {{lang?.Add}}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--  Invoice Details Modal -->
  <div id="invoiceDetails" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{ lang?.Invoice_Details }}</span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" (click)="tabData()"></i>
        </div>
        <div class="modal-body">
          <div class="tabs1">
            <div class="tab1" [ngClass]="{ active: selectedTab === 'tab1' }" (click)="selectTab('tab1')">
              {{ lang?.Upcoming }}
            </div>
            <div class="tab1" [ngClass]="{ active: selectedTab === 'tab2' }" (click)="selectTab('tab2')">
              {{ lang?.History }}
            </div>
          </div>
          <br />
          <div class="tab-content">
            <div *ngIf="selectedTab === 'tab1'">
              <div *ngIf="(upcomingInvoice | json) == '{}'">
                <small class="title">{{ lang?.No_Upcoming_Details }}</small>
              </div>
            </div>
            <div *ngIf="selectedTab === 'tab2'">
              <div class="table-responsive" *ngIf="invoiceResponse.length > 0">
                <table id="table">
                  <thead>
                    <tr>
                      <th class="ps-2">{{ lang?.Date }}</th>
                      <th class="fw-normal">{{ lang?.Invoice }}</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let invoice of invoiceResponse">
                      <td class="ps-2">
                        {{ invoice.dueDate | date : "MM-dd-yyy" }}
                      </td>
                      <td>{{ invoice.invoiceId }}</td>
<div class="d-flex align-items-center gap-2">
  <td>
                        <img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" id="viewing"
                          role="button" data-bs-toggle="modal" data-bs-target="#viewinvoice" data-bs-placement="top"
                          title="View" (click)="viewinvoices(invoice.file)" />
                      </td>
                      <td>
                        <img role="button" src="/assets/img/download.png" alt="" width="20px" id="viewing" role="button"
                          data-bs-toggle="tooltip" data-bs-placement="top" title="Download"
                          (click)="downloadinvoices(invoice)" height="20px" />
                      </td>
</div>

                      <!-- <td>
                        <img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" id="viewing"
                          role="button" data-bs-toggle="modal" data-bs-target="#viewinvoice" data-bs-placement="top"
                          title="View" (click)="viewinvoices(invoice.file)" />
                      </td>
                      <td>
                        <img role="button" src="/assets/img/download.png" alt="" width="20px" id="viewing" role="button"
                          data-bs-toggle="tooltip" data-bs-placement="top" title="Download"
                          (click)="downloadinvoices(invoice)" height="20px" />
                      </td> -->
                      
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="invoiceResponse.length <= 0">
                <small class="title">{{ lang?.No_Data_Found }}</small>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
            (click)="tabData()">
            <b>{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--  Invoice Draft Details Modal -->
  <div id="invoiceDraftDetails" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{ lang?.Draft_Invoices_Details }}</span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" (click)="tabData()"></i>
        </div>
        <div class="modal-body">
          <div [innerHTML]="invoicedraftData"></div>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
            (click)="tabData()">
            <b>{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal modal-md fade" id="emailConfirmationModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-11 text-white text-center">{{lang?.Info}}</div>
          <i class="bi bi-x-circle text-light" style="cursor: pointer" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          {{lang?.Send_a_link_to_update_payment_details_for}}
          <b>{{ customerData?.firstName }} {{ customerData?.lastName }}?</b>
          <br/>
          <div class="d-flex gap-1 row" *ngFor="let checkbox of inviteEmails ;  let i = index">
            <div class="col-5 d-flex gap-1">
                <input type="checkbox" [(ngModel)]="checkbox.checked" />
                <span>{{ checkbox.label }}</span>
            </div>
          </div>

          <div class="col-12 gap-1">
            <!-- Form Control Binding -->
            <form [formGroup]="emailForm" style="align-items: baseline;" class="d-flex" (ngSubmit)="addEmail()">
              <div class="w-100">
                <input
                class="form-control"
                type="text"
                id="email"
                formControlName="newEmail"
                placeholder="Enter email" />
              <!-- Validation Errors -->
              <div *ngIf="emailForm.controls['newEmail'].invalid && emailForm.controls['newEmail'].touched">
                <small *ngIf="emailForm.controls['newEmail'].hasError('pattern')" class="text-danger">
                  Please enter a valid email address.
                </small>
              </div>
            </div>
              <!-- Add button -->
              <button
                type="submit"
                class="btn confirm text-nowrap"
                style="margin-left:5px;"
                [disabled]="emailForm.invalid || emailForm.get('newEmail')?.value ==''">
                  Add Email
                </button>
            </form>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary cancel-button" data-bs-dismiss="modal">
            {{lang?.Close}}
          </button>
          <button
            type="button"
            class="btn confirm"
            (click)="paymentUpdationInvitationMail()"
            [disabled]="getSelectedEmails().length==0"
            >
            {{lang?.Confirm}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- <div id="healthCardDropdown" class="modal fade modal-lg" data-bs-backdrop="static">
    <div class="modal-dialog" id="modal-dialog">
        <div class="modal-content" id="modal-content1">
            <div class="modal-header" id="backgroundColor">
                <span class="modal-title">Upload HealthCard</span>

            </div>
            <div class="modal-body">
              <select class="form-select border border-dark"
              name="uploadhealthCard"           >
             <option value="null" selected>Select</option>
               <option value="STUDENT">Student</option>
               <option value="GIG">GIG</option>

             </select>
            </div>
            <div class="modal-footer py-2">
                <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
                    (click)="tabData()"><b>{{lang?.Close}}</b></button>
            </div>
        </div>
    </div>
  </div> -->

  <div class="modal fade" id="healthCardDropdown" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title text-center" style="color:#fff">{{lang?.Upload_HealthCard}}</span>
          <i class="bi bi-x-circle" style="color:#fff" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          <div class="modal-body">



            <div>
              <div class="row" *ngIf="!noService ;else serviceAvailable">
                <!-- <span>{{lang?.No_services_to_upload_Membership_Cards}}</span> -->
                <span>Member has no plans that require membership cards</span>
              </div>
              <ng-template #serviceAvailable>
                <div [formGroup]="uploadService">
                  <div class="row">
                    <div class="col-6 form-group">
                      <label for="memberType">{{lang?.Select_Card_Type}}<span class="text-danger">*</span></label>
                      <select class="form-select border border-dark" name="uploadhealthCard"
                        formControlName="uploadhealthCard" (change)="showProviders($event)">
                        <option value="null" selected>{{lang?.Select}}</option>
                        <option *ngFor="let item of servicesDetails | keyvalue:pipeFunction;" [value]="item.key">
                          {{servicesDetails[item.key].service}}
                        </option>

                      </select>
                      <div class="help-block text-danger"
                        *ngIf="uploadService.get('uploadhealthCard').touched && uploadService.get('uploadhealthCard').invalid">
                        <div
                          *ngIf="uploadService.get('uploadhealthCard').errors && uploadService.get('uploadhealthCard').errors['required']">
                          {{lang?.Please_select_service}}</div>
                      </div>

                    </div>
                    <div class="col-6 form-group" *ngIf="showProvider">
                      <label> {{lang?.Providers}}</label>
                      <select class="form-select border border-dark" name="uploadhealthCardProvider"
                        formControlName="uploadhealthCardProvider" (change)="showType($event)">

                        <option value="" selected disabled>{{lang?.Select}}</option>
                        <option *ngFor="let provider of providersArray" [value]="provider">
                          {{provider}}</option>
                      </select>
                      <div class="help-block text-danger"
                        *ngIf="uploadService.get('uploadhealthCardProvider').touched && uploadService.get('uploadhealthCardProvider').invalid">
                        <div
                          *ngIf="uploadService.get('uploadhealthCardProvider').errors && uploadService.get('uploadhealthCardProvider').errors['required']">
                          {{lang?.Please_select_Provider}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="multiUpload">
                    <div *ngIf="types && types.length>0">
                      <div *ngFor="let type of types;let i=index">
                        <div class="mt-2 row align-items-center">
                          <label class="col-2 ms-1"
                            style="font-size:13px;margin-bottom: 8px;font-weight: 600;">{{type}}</label>
                          <input class="col-4 " id="type-{{i}}" type="file" formControlName="uploadhealthCardFile"
                            #myFileInputService (change)="uploadServiceType_($event,i,type)">
                        </div>
                      </div>

                    </div>

                    <div *ngIf="multiUploadArray && multiUploadArray.length>0 && types.length<=0">
                      <div class="mt-2 d-flex gap-5" *ngFor="let mul of multiUploadArray;let i=index">

                        <input id="mul-{{i}}" type="file" formControlName="uploadhealthCardFile" #myFileInputService
                          (change)="uploadServiceType($event,i)">
                        <button *ngIf="i==0 && !showProvider" class="btn btn-sm" id="uploadData"
                          style="background-color:rgb(93,124,155);font-size:12px;color:white"
                          (click)="addCard()">{{lang?.Add_More}}&nbsp;<i class="fa fa-plus"
                            style="font-size:12px;font-weight: 500" aria-hidden="true"></i></button>
                      </div>
                    </div>

                  </div>

                  <div class="row" *ngIf="!multiUpload && types.length<=0 ">
                    <div class="mt-2">
                      <input id="fileservice" type="file" formControlName="uploadhealthCardFile" #myFileInputService
                        (change)="uploadServiceType($event)">
                      <div class="help-block text-danger"
                        *ngIf="uploadService.get('uploadhealthCardFile').touched && uploadService.get('uploadhealthCardFile').invalid">
                        <div
                          *ngIf="uploadService.get('uploadhealthCardFile').errors && uploadService.get('uploadhealthCardFile').errors['required']">
                          {{lang?.Please_select_health_card}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>

            </div>

          </div>
          <div class="modal-footer">
            <div class="help-block text-danger" *ngIf="uploadError">{{lang?.Upload_atleast_one_Card}}</div>
            <div class="help-block text-danger" *ngIf="typesError">
              {{lang?.Please_upload_all_required_health_cards}}</div>

            <!-- <button type="button" *ngIf="noService" class="btn saveAndNext"
            (click)="UploadHealthCard()">Save</button> -->
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
              (click)="closeUploadHealthCard()">{{lang?.Close}}</button>
            <button type="button" *ngIf="noService" style="padding-top: 7px;padding-bottom: 20px;"
              (click)="UploadHealthCard()" class="btn btn-sm btn-light" id="updateButton">{{lang?.Save}}</button>

          </div>
        </div>
      </div>
    </div>

    <!--  ROE Modal -->
    <div id="roe1" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
        <div class="modal-content" id="modal-content1">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{ lang?.Record_of_Enrollment }}</span>
            <i #openRoe class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closeRoe()"></i>
          </div>
          <div class="modal-body">
            <div *ngIf="viewRoe">
              <pdf-viewer [src]="roe" style="zoom: 0.85" id="pdf-viewer" view:fitH></pdf-viewer>
            </div>
            <div *ngIf="!viewRoe">
              <span>{{ lang?.Currently_ROE_is_not_available }}</span>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closeRoe()">
              <b>{{ lang?.Close }}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--  HIC Details Modal -->
    <div id="hicDetails1" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
        <div class="modal-content" id="modal-content1">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{
              lang?.Health_Insurance_Cards_Details
              }}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closeHealthCard()"></i>
          </div>
          <div class="modal-body">
            <!-- <div class="table-responsive" *ngIf="!healthCard">
                      <table class=" table-striped" id="table">
                          <thead>
                              <tr>
                                  <th class="fw-normal text-nowrap">Full Name</th>
                                  <th class="fw-normal">Email</th>
                                  <th class="fw-normal text-nowrap">Date of Birth</th>
                                  <th class="fw-normal">Gender</th>
                                  <th class="fw-normal">Relation</th>
                                  <th class="fw-normal text-nowrap">Phone No.</th>
                                  <th></th>
                                  <th></th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let hic of hicList">
                                  <td class="text-nowrap">{{hic.name | titlecase}}</td>
                                  <td>{{hic.email}}</td>
                                  <td>{{hic.dob | date : "MM-dd-YYYY"}}</td>
                                  <td>{{hic.gender}}</td>
                                  <td>{{hic.relation}}</td>
                                  <td class="text-nowrap">{{hic.phoneNum | phoneNoFormat}}</td>
                                  <td><img role="button" src="/assets/img/view.png" alt="" width="20px"
                                          height="20px" (click)="viewHealthCard(hic)"></td>
                                  <td><img role="button" src="/assets/img/download.png" alt="" id="img"
                                          (click)="downloadHic(hic)"></td>
                              </tr>
                          </tbody>
                      </table>
                  </div> -->
            <div *ngIf="card">
              <h6>{{ lang?.Please_check_back_later_or_contact_your_Advisor }}</h6>
            </div>
            <span *ngIf="showFifh">
              <img src="../../../assets/img/tenor.gif" width="100" style="
                    display: block;
                    margin-left: auto;
                    margin-right: auto;
                    width: 25%;
                  " />
            </span>
            <div *ngIf="healthCard">
              <pdf-viewer [src]="src" id="pdf-viewer" style="zoom: 0.85" view:fitH
                (after-load-complete)="showLoaderfith($event)"></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeHealthCard()"
                      *ngIf="healthCard"><b>Back</b></button>&nbsp;&nbsp; -->
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closeHealthCard()">
              <b>{{ lang?.Close }}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Download All HIC Modal-->
    <!-- <div class="modal modal-lg" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle}">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header" id="backgroundColor">
                  <h6 class="modal-title">Health Insurance Cards details</h6>
                  <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" (click)="closeHealthCard()"></i>
              </div>
              <div class="modal-body">
                  <div class="table-responsive" *ngIf="!healthCard">
                      <table class=" table-striped" id="table">
                          <thead>
                              <tr>
                                  <th><input type="checkbox" [checked]="isAllCheckBoxChecked()" (change)="checkAllCheckBox($event)"></th>
                                  <th class="fw-normal text-nowrap">Full Name</th>
                                  <th class="fw-normal">Email</th>
                                  <th class="fw-normal text-nowrap">Date of Birth</th>
                                  <th class="fw-normal">Gender</th>
                                  <th class="fw-normal">Relation</th>
                                  <th class="fw-normal text-nowrap">Phone No.</th>
                                  <th></th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let hic of hicList">
                                  <td><input type="checkbox" [checked]="hic.checked" (change)="hic.checked = !hic.checked"></td>
                                  <td class="text-nowrap">{{hic.name}}</td>
                                  <td>{{hic.email}}</td>
                                  <td>{{hic.dob | date : "MM-dd-YYYY"}}</td>
                                  <td>{{hic.gender}}</td>
                                  <td>{{hic.relation}}</td>
                                  <td class="text-nowrap">{{hic.phoneNum | phoneNoFormat}}</td>
                                  <td><img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" (click)="viewHealthCard(hic.healthCard)"></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <div *ngIf="healthCard">
                      <pdf-viewer [src]="src" style="width: 100%; height: 500px;"></pdf-viewer>
                  </div>
              </div>
              <div class="modal-footer py-2">
                  <button type="button" class="btn btn-sm btn-light" id="updateButton" [disabled]="disabledDownload()" (click)="downloadSelected()" *ngIf="!healthCard"><b>Download</b></button>&nbsp;&nbsp;
                  <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeDownloadHealthCard()" *ngIf="healthCard"><b>Back</b></button>&nbsp;&nbsp;
                  <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton" (click)="closeHealthCard()"><b>{{lang?.Cancel}}</b></button>
              </div>
          </div>
      </div>
  </div> -->

    <!--  Booklet Details Modal -->
    <div id="hpbooklet1" class="modal fade modal-lg modalposition" tabindex="-1" role="dialog"
      aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
        <div class="modal-content" id="modal-content1">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{ lang?.View_Plan_Booklets }}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closeBooklet()"></i>
          </div>
          <div class="modal-body">
            <!-- <div class="table-responsive" *ngIf="!hidebooklet">
                      <table class="table-striped" id="table">
                          <thead id="thead">
                              <tr>
                                  <th class="fw-normal">&nbsp;S.No</th>
                                  <th class="fw-normal">Name</th>
                                  <th class="fw-normal">Description</th>
                                  <th></th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let booklet of bookletList; let i=index">
                                  <td>&nbsp;{{i+1}}</td>
                                  <td>{{booklet.name}}</td>
                                  <td>{{booklet.description}}</td>
                                  <td id="booklet-td">
                                      <img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" class="m-1" (click)="viewBooklet(booklet.link)">
                                      <img role="button" src="/assets/img/download.png" alt="" id="img" (click)="downloadHpbooklet(booklet)">&nbsp;
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div> -->
            <!-- <div *ngIf="hidebooklet">
                      <pdf-viewer [src]="bookletLink" style="width: 100%; height: 400px;"></pdf-viewer>
                  </div> -->
            <span *ngIf="showViewPlansLoading">
              <img src="../../../assets/img/tenor.gif" width="100" style="
                    display: block;
                    margin-left: auto;
                    margin-right: auto;
                    width: 25%;
                  " />
            </span>
            <div>
              <pdf-viewer *ngIf="true" [src]="bookletLink" id="pdf-viewer"
                (after-load-complete)="viewPlansLoading($event)"></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeBooklet()" *ngIf="hidebooklet"><b>Back</b></button>&nbsp;&nbsp; -->
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closeBooklet()">
              <b>{{ lang?.Close }}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Download All Booklets -->
    <div class="modal modal-lg" tabindex="-1" role="dialog" [ngStyle]="{ display: displayBooklet }">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{
              lang?.Health_Plan_Booklets_Download
              }}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closeBooklet()"></i>
          </div>
          <div class="modal-body">
            <div class="table-responsive" *ngIf="!hidebooklet">
              <table class="table-striped" id="table">
                <thead id="thead">
                  <tr>
                    <th>
                      <input type="checkbox" [checked]="isAllBookletsChecked()" (change)="checkAllBooklets($event)" />
                    </th>
                    <!-- <th class="fw-normal">&nbsp;S.No</th> -->
                    <th class="fw-normal">{{ lang?.Name }}</th>
                    <th class="fw-normal">{{ lang?.Description }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let booklet of bookletList; let i = index">
                    <td>
                      <input type="checkbox" [checked]="booklet.checked"
                        (change)="booklet.checked = !booklet.checked" />
                    </td>
                    <!-- <td>&nbsp;{{i+1}}</td> -->
                    <td>{{ booklet.name }}</td>
                    <td>{{ booklet.description }}</td>
                    <td id="booklet-td">
                      <!-- <img role="button" src="/assets/img/download.png" alt="" (click)="downloadHpbooklet(booklet)"> -->
                      <img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" class="m-2"
                        (click)="viewBooklet(booklet.link)" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="hidebooklet">
              <span *ngIf="showLoadrForDownloadBookLets">
                <img src="../../../assets/img/tenor.gif" width="100" style="
                      display: block;
                      margin-left: auto;
                      margin-right: auto;
                      width: 25%;
                    " />
              </span>
              <pdf-viewer [src]="bookletLink" style="width: 100%; height: 400px; zoom: 0.85" view:fitH
                (after-load-complete)="LoadrForDownloadBookLets($event)"></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="downloadSelected()"
              *ngIf="!hidebooklet">
              <b>{{ lang?.Download }}</b></button>&nbsp;&nbsp;
            <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeDownloadBooklet()"
              *ngIf="hidebooklet">
              <b>{{ lang?.Back }}</b></button>&nbsp;&nbsp;
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closeBooklet()">
              <b>{{ lang?.Close }}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit CC Modal -->
    <div id="updatePaymentInfo" class="modal fade modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{ lang?.Update_Credit_Card_Info }}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closePaymentInfo()"></i>
          </div>
          <div class="modal-body">
            <form [formGroup]="ccform" #paymentform2 action="https://payments.subscriptionplatform.com/v2/payments/edit"
              method="post">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" autofocus="autofocus" id="CustomerID" formcontrolname="cutomerId"
                    name="CustomerID" type="hidden" value="{{ fusebillId }}" />
                </div>
                <div class="form-group col-md-12">
                  <!-- paymentMethodId -->
                  <input class="form-control" autofocus="autofocus" id="Id" formcontrolname="Id" name="Id" type="hidden"
                    value="{{ paymentMethodId }}" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="PublicApiKey" formcontrolname="PublicApiKey" name="PublicApiKey"
                    type="hidden" value="{{ fuseBillKey }}" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="SuccessUri" formcontrolname="SuccessUri" name="SuccessUri"
                    type="hidden" value="{{ paymentsuccessuri }}" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="FailUri" formcontrolname="FailUri" name="FailUri" type="hidden"
                    value="{{ paymentUri }}" />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 form-group mt-1">
                  <label id="modal-labels">{{ lang?.First_Name
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="First Name" class="form-control" id="FirstName" name="FirstName"
                    formControlName="FirstName" (keypress)="
                        (($event.charCode >= 65 && $event.charCode < 91) ||
                          ($event.charCode >= 97 && $event.charCode < 123) ||
                          $event.charCode == 32)
                      " (input)="checkFirstCharacter($event, ccform)" />
                  <div *ngIf="
                        ccForm['FirstName'].touched && ccForm['FirstName'].invalid
                      " class="help-block text-danger">
                    <div *ngIf="
                          ccForm['FirstName'].errors &&
                          ccForm['FirstName'].errors['required']
                        ">
                      {{ lang?.Please_enter_first_name }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 form-group mt-1">
                  <label id="modal-labels">{{ lang?.Last_Name
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Last Name" class="form-control" id="LastName" name="LastName"
                    formControlName="LastName" (keypress)="
                        (($event.charCode >= 65 && $event.charCode < 91) ||
                          ($event.charCode >= 97 && $event.charCode < 123) ||
                          $event.charCode == 32)
                      " (input)="checkFirstCharacter($event, ccform)" />
                  <div *ngIf="
                        ccForm['LastName'].touched && ccForm['LastName'].invalid
                      " class="help-block text-danger">
                    <div *ngIf="
                          ccForm['LastName'].errors &&
                          ccForm['LastName'].errors['required']
                        ">
                      {{ lang?.Please_enter_last_name }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 form-group mt-1">
                  <!-- <label id="modal-labels">{{lang1.email}}<span style="color: red">*</span></label> -->
                  <input type="text" placeholder="Last Name" class="form-control" id="email" type="hidden" name="email"
                    formControlName="email" value="test@aitetspro.com" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group mt-1">
                  <label id="modal-labels">{{ lang?.Credit_Card_Number }}<span style="color: red">*</span></label>
                  <div class="input-group">
                    <input type="text" placeholder="Credit Card Number" class="form-control" id="CardNumber"
                      name="CardNumber" formControlName="CardNumber" (keypress)="
                          ($event.charCode >= 48 && $event.charCode < 58)
                        " (input)="creditcardlblurmethod($event)" />
                    <span class="input-group-text text-muted">
                      <i class="fa fa-cc-visa mx-1"></i>
                      <i class="fa fa-cc-amex mx-1"></i>
                      <i class="fa fa-cc-mastercard mx-1"></i>
                    </span>
                  </div>
                  <!-- <div *ngIf="ccForm['CardNumber'].touched && ccForm['CardNumber'].invalid"
                class="help-block text-danger">
                <div
                  *ngIf="ccForm['CardNumber'].errors && ccForm['CardNumber'].errors['required']">
                  {{lang?.Please_enter_card_number}}</div>
                <div
                  *ngIf="ccForm['CardNumber'].errors && ccForm['CardNumber'].errors['minlength']">
                  {{lang?.Card_number_must_be_equal_to_16_digits}}</div>
                <div
                  *ngIf="ccForm['CardNumber'].errors && ccForm['CardNumber'].errors['maxlength']">
                  {{lang?.Card_number_must_be_equal_to_16_digits}}</div>
              </div> -->
                  <div class="help-block text-danger" *ngIf="
                        ccForm['CardNumber'].touched &&
                        ccForm['CardNumber'].errors &&
                        ccForm['CardNumber'].errors['required']
                      ">
                    {{ lang?.Please_enter_card_number }}
                  </div>
                  <div class="help-block text-danger" *ngIf="
                        (ccForm['CardNumber'].touched &&
                          ccForm['CardNumber'].hasError(
                            'invalidcreditcarddetails'
                          )) ||
                        invalidcreditcard
                      ">
                    {{lang?.Please_enter_valid_Card_number}}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-8 form-group mt-1">
                  <label id="modal-labels">{{ lang?.Expiration
                    }}<span style="color: red">*</span></label>
                  <div class="input-group">
                    <div id="yearselect">
                      <select class="form-select" id="ExpirationMonth" name="ExpirationMonth"
                        formControlName="ExpirationMonth" (change)="getMonth($event)">
                        <!-- <option value="" selected disabled>MM</option> -->
                        <option value="" disabled selected>
                          {{ lang?.Select }}
                        </option>
                        <option value="01">Jan</option>
                        <option value="02">Feb</option>
                        <option value="03">Mar</option>
                        <option value="04">April</option>
                        <option value="05">May</option>
                        <option value="06">June</option>
                        <option value="07">July</option>
                        <option value="08">Aug</option>
                        <option value="09">Sept</option>
                        <option value="10">Oct</option>
                        <option value="11">Nov</option>
                        <option value="12">Dec</option>
                      </select>
                    </div>
                    <select class="form-select" id="ExpirationYear" name="ExpirationYear"
                      formControlName="ExpirationYear" (change)="getYear($event)">
                      <option value="" disabled>YYYY</option>
                      <option *ngFor="let item of [].constructor(10); let i = index" value="{{ i + 25 }}">
                        {{ i + 2025 }}
                      </option>
                    </select>
                  </div>
                  <div *ngIf="ccForm['ExpirationMonth'].touched" class="help-block text-danger">
                    <div *ngIf="
                          ccForm['ExpirationMonth'].errors &&
                          ccForm['ExpirationMonth'].errors['required']
                        ">
                      {{ lang?.Please_select_expiration_month }}
                    </div>
                  </div>
                  <div *ngIf="ccForm['ExpirationYear'].touched" class="help-block text-danger">
                    <div *ngIf="
                          ccForm['ExpirationYear'].errors &&
                          ccForm['ExpirationYear'].errors['required']
                        ">
                      {{ lang?.Please_select_expiration_year }}
                    </div>
                    <div *ngIf="invalidExpiration">
                      {{lang?.Please_enter_valid_expiration}}
                    </div>
                  </div>
                </div>
                <div class="col-4 form-group mt-1">
                  <label id="modal-labels">{{lang?.CVV}}<span style="color: red">*</span>&nbsp;<span
                      (mouseover)="showImage = true" (mouseout)="showImage = false" style="cursor: pointer"><i
                        class="bi bi-question-circle-fill"></i></span></label>
                  <img *ngIf="showImage" src="/assets/img/cvv-number.jpg" width="140px" height="80px" />
                  <input type="text" placeholder="CVV" class="form-control" id="Cvv" name="Cvv" formControlName="Cvv"
                    (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="ccForm['Cvv'].touched && ccForm['Cvv'].invalid" class="help-block text-danger">
                    <div *ngIf="
                          ccForm['Cvv'].errors && ccForm['Cvv'].errors['required']
                        ">
                      {{ lang?.Please_enter_CVV }}
                    </div>
                    <div *ngIf="
                          ccForm['Cvv'].errors &&
                          ccForm['Cvv'].errors['minlength']
                        ">
                      {{ lang?.CVV_number_minimum_3_digits }}
                    </div>
                    <div *ngIf="
                          ccForm['Cvv'].errors &&
                          ccForm['Cvv'].errors['maxlength']
                        ">
                      {{ lang?.CVV_number_maximum_4_digits }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="MakeDefault" placeholder="Name on the card" value="true" type="hidden"
                    name="MakeDefault" />
                </div>
              </div>
              <div class="form-row captchavalidation mt-2">
                <re-captcha (resolved)="resolved($event)" formControlName="recaptchaReactive"
                  siteKey="6LfVtGwUAAAAALHn9Ycaig9801f6lrPmouzuKF11">
                </re-captcha>
                <input id="recaptcha_token" type="hidden" name="recaptcha_token" [value]="recaptchaResponse" />
              </div>
            </form>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closeCcInfo()">
              <b>{{ lang?.Cancel }}</b></button>&nbsp;
            <button type="submit" class="btn btn-sm btn-light" id="updateButton"
              (click)="updateCcInfo(ccform.value, paymentform2)">
              {{ lang?.Update }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- PAD Update Modal -->
    <div id="updatePADinfo" class="modal fade modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered" id="updatePadModal">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{ lang?.Update_PAD_Details }}</span>
            <i #closePaymentmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closepadinfo()"></i>
          </div>
          <div class="modal-body">
            <form [formGroup]="padform">
              <div class="row">
                <div class="col-md-4 form-group">
                  <label id="modal-labels">{{ lang?.Bank_Id
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Bank Number" formControlName="bankcode" class="form-control"
                    (input)="padformValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="
                        padForm['bankcode'].touched && padForm['bankcode'].invalid
                      " class="help-block text-danger">
                    <div *ngIf="
                          padForm['bankcode'].errors &&
                          padForm['bankcode'].errors['required']
                        ">
                      {{ lang?.Please_enter_bank_number }}
                    </div>
                    <div *ngIf="
                          padForm['bankcode'].errors &&
                          padForm['bankcode'].errors['minlength']
                        ">
                      {{ lang?.Bank_number_must_be_equal_to_3_digits }}
                    </div>
                    <div *ngIf="
                          padForm['bankcode'].errors &&
                          padForm['bankcode'].errors['maxlength']
                        ">
                      {{ lang?.Bank_number_must_be_equal_to_3_digits }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label id="modal-labels">{{ lang?.Transit
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Transit Number" formControlName="transitNumber" class="form-control"
                    (input)="padformValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="
                        padForm['transitNumber'].touched &&
                        padForm['transitNumber'].invalid
                      " class="help-block text-danger">
                    <div *ngIf="
                          padForm['transitNumber'].errors &&
                          padForm['transitNumber'].errors['required']
                        ">
                      {{ lang?.Please_enter_transit_number }}
                    </div>
                    <div *ngIf="
                          padForm['transitNumber'].errors &&
                          padForm['transitNumber'].errors['minlength']
                        ">
                      {{ lang?.Transit_number_must_be_equal_to_5_digits }}
                    </div>
                    <div *ngIf="
                          padForm['transitNumber'].errors &&
                          padForm['transitNumber'].errors['maxlength']
                        ">
                      {{ lang?.Transit_number_must_be_equal_to_5_digits }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label id="modal-labels">{{ lang?.Account
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Account Number" formControlName="accountNo" class="form-control"
                    (input)="padformValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="
                        padForm['accountNo'].touched &&
                        padForm['accountNo'].invalid
                      " class="help-block text-danger">
                    <div *ngIf="
                          padForm['accountNo'].errors &&
                          padForm['accountNo'].errors['required']
                        ">
                      {{ lang?.Please_enter_account_number }}
                    </div>
                    <div *ngIf="
                          padForm['accountNo'].errors &&
                          padForm['accountNo'].errors['minlength']
                        ">
                      {{ lang?.Account_number_minimum_5_digits }}
                    </div>
                    <div *ngIf="
                          padForm['accountNo'].errors &&
                          padForm['accountNo'].errors['maxlength']
                        ">
                      {{ lang?.Account_number_maximum_12_digits }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="bankinfo">
                <div class="col-md-12 form-group">
                  <label id="modal-labels">{{ lang?.Bank_Details }}</label>
                  <!-- <div id="bankInfo"> -->
                  <!-- <textarea id="bankDetails" formControlName="bankdetails">
                <div>{{bank.name}}</div>
                <div *ngFor="let bankAddress of bankAddress">{{bankAddress}}</div>
              </textarea> -->
                  <!-- </div> -->
                  <textarea class="form-control checking-field" id="bankname" placeholder="" name="bankname"
                    formControlName="bankdetails" style="color: rgba(85, 85, 85, 0.9)" [ngModel]="banknameres"
                    rows="6"></textarea>
                </div>
              </div>
              <div class="mt-2">
                <button type="button" class="btn btn-sm btn-light" id="updateButton" *ngIf="resetbutton"
                  (click)="resetPadForm()">
                  {{ lang?.Clear }}
                </button>
                <button type="button" class="btn btn-sm btn-light" id="updateButton" *ngIf="padform.valid && !bankinfo"
                  (click)="updateBankInfo()">
                  {{ lang?.Verify }}
                </button>
              </div>
              <div class="mt-2">
                <button type="button" class="btn btn-sm btn-light" id="updateButton" *ngIf="existVoid && bankinfo"
                  data-bs-toggle="modal" data-bs-target="#updatepreviewAgreement" (click)="existingVoidCheque()">
                  {{ lang?.Click_here_to_view_Void_Cheque }}
                </button>
              </div>
              <div class="form-group" *ngIf="cheque && !existVoid">
                <label id="modal-labels">{{lang?.Upload_Void_Cheque}}<span style="color: red">*</span></label>
                <div class="row">
                  <div class="col-8 pt-1">
                    <input type="file" formControlName="file" (change)="fileSelect($event)" />
                  </div>
                  <div class="col-4" *ngIf="updatepreviewbutton">
                    <button class="btn btn-sm btn-dark" data-bs-toggle="modal" data-bs-target="#updatepreviewAgreement"
                      (click)="updatePadpreview()">
                      {{lang?.Preview}}
                    </button>
                  </div>
                </div>
                <div *ngIf="padForm['file'].touched && padForm['file'].invalid" class="help-block text-danger">
                  <div *ngIf="
                        padForm['file'].errors &&
                        padForm['file'].errors['required']
                      ">
                    {{lang?.Please_upload_void_cheque}}
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <button class="btn btn-sm btn-success primaryInfoLabels" data-bs-dismiss="modal" data-bs-toggle="modal"
                  data-bs-target="#padAgreement" *ngIf="cheque && !existVoid" [disabled]="
                      padform.get('file')?.value == null ||
                      padform.get('file')?.value == ''
                    " (click)="updateCorporatePAD()">
                  {{lang?.Review_and_Sign_the_PAD_Agreement}}
                </button>
              </div>
            </form>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closepadinfo()">
              <b>{{ lang?.Cancel }}</b></button>&nbsp;
          </div>
        </div>
      </div>
    </div>

    <!--  Change to PAD Modal -->
    <div id="updatePaymentMethodPAD" class="modal fade modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{
              lang?.Update_Payment_Method
              }}</span>
            <i #closePaymentmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closeChangeToPad()"></i>
          </div>
          <div class="modal-body">
            <form [formGroup]="paymentMethodForm">
              <div class="row">
                <div class="col-md-12 form-group">
                  <label id="modal-labels"><b>{{
                      lang?.Do_you_want_to_change_payment_method_to_Pre_Authorized_Debit
                      }}<span style="color: red">*</span></b></label>
                </div>
              </div>
              <div class="row">
                <div class="col-3">
                  <input type="radio" value="yes" formControlName="paymentmethod" id="paymentmethod"
                    name="paymentmethod" (click)="openPaymentDetails('open')" />&nbsp;<label id="radio-labels"
                    class="align-text-top">{{
                    lang?.Yes
                    }}</label>
                </div>
                <div class="col-3">
                  <input type="radio" value="no" formControlName="paymentmethod" id="paymentmethod" name="paymentmethod"
                    (click)="openPaymentDetails('close')" />&nbsp;<label id="radio-labels" class="align-text-top">{{
                    lang?.No
                    }}</label>
                </div>
              </div>
              <div class="row" *ngIf="openUpdatePaymentForm === 'open'">
                <div class="col-md-4 form-group">
                  <label id="modal-labels">{{ lang?.Bank_Id
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Bank Number" formControlName="bankCode" class="form-control"
                    (input)="paymentMethodFormValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="
                        paymentMethodControls['bankCode'].touched &&
                        paymentMethodControls['bankCode'].invalid
                      " class="help-block text-danger">
                    <div *ngIf="
                          paymentMethodControls['bankCode'].errors &&
                          paymentMethodControls['bankCode'].errors['required']
                        ">
                      {{ lang?.Please_enter_bank_number }}
                    </div>
                    <div *ngIf="
                          paymentMethodControls['bankCode'].errors &&
                          paymentMethodControls['bankCode'].errors['minlength']
                        ">
                      {{ lang?.Bank_number_must_be_equal_to_3_digits }}
                    </div>
                    <div *ngIf="
                          paymentMethodControls['bankCode'].errors &&
                          paymentMethodControls['bankCode'].errors['maxlength']
                        ">
                      {{ lang?.Bank_number_must_be_equal_to_3_digits }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label id="modal-labels">{{ lang?.Transit
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Transit Number" formControlName="branchCode" class="form-control"
                    (input)="paymentMethodFormValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="
                        paymentMethodControls['branchCode'].touched &&
                        paymentMethodControls['branchCode'].invalid
                      " class="help-block text-danger">
                    <div *ngIf="
                          paymentMethodControls['branchCode'].errors &&
                          paymentMethodControls['branchCode'].errors['required']
                        ">
                      {{ lang?.Please_enter_transit_number }}
                    </div>
                    <div *ngIf="
                          paymentMethodControls['branchCode'].errors &&
                          paymentMethodControls['branchCode'].errors['minlength']
                        ">
                      {{ lang?.Transit_number_must_be_equal_to_5_digits }}
                    </div>
                    <div *ngIf="
                          paymentMethodControls['branchCode'].errors &&
                          paymentMethodControls['branchCode'].errors['maxlength']
                        ">
                      {{ lang?.Transit_number_must_be_equal_to_5_digits }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label id="modal-labels">{{ lang?.Account
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Account Number" formControlName="accountNumber" class="form-control"
                    (input)="paymentMethodFormValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="
                        paymentMethodControls['accountNumber'].touched &&
                        paymentMethodControls['accountNumber'].invalid
                      " class="help-block text-danger">
                    <div *ngIf="
                          paymentMethodControls['accountNumber'].errors &&
                          paymentMethodControls['accountNumber'].errors[
                            'required'
                          ]
                        ">
                      {{ lang?.Please_enter_account_number }}
                    </div>
                    <div *ngIf="
                          paymentMethodControls['accountNumber'].errors &&
                          paymentMethodControls['accountNumber'].errors[
                            'minlength'
                          ]
                        ">
                      {{ lang?.Account_number_minimum_5_digits }}
                    </div>
                    <div *ngIf="
                          paymentMethodControls['accountNumber'].errors &&
                          paymentMethodControls['accountNumber'].errors[
                            'maxlength'
                          ]
                        ">
                      {{ lang?.Account_number_maximum_12_digits }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="bankDetails">
                <div class="col-md-12 form-group">
                  <label id="modal-labels">{{ lang?.Bank_Details }}</label>
                  <div id="bankInfo">
                    <div id="bankDetails">
                      <div>{{ bankInfo.name }}</div>
                      <div *ngFor="let bankAddress of bankAddress">
                        {{ bankAddress }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <button type="button" class="btn btn-sm btn-light" id="updateButton" *ngIf="resetButton"
                  (click)="resetPaymentForm()">
                  {{ lang?.Clear }}
                </button>
                <button type="button" class="btn btn-sm btn-light" id="updateButton"
                  *ngIf="paymentMethodForm.valid && !bankDetails" (click)="getBankInfo()">
                  {{ lang?.Verify }}
                </button>
              </div>
              <div class="form-group" *ngIf="uploadCheque">
                <label id="modal-labels">{{lang?.Upload_Void_Cheque}}<span style="color: red">*</span></label>
                <div class="row">
                  <div class="col-8 pt-1">
                    <input type="file" formControlName="files" (change)="onFileSelect($event)" />
                  </div>
                  <div class="col-4" *ngIf="previewbutton">
                    <button class="btn btn-sm btn-dark" data-bs-toggle="modal" data-bs-target="#previewAgreement"
                      (click)="changepad()">
                      {{lang?.Preview}}
                    </button>
                  </div>
                </div>
                <div *ngIf="
                      paymentMethodControls['files'].touched &&
                      paymentMethodControls['files'].invalid
                    " class="help-block text-danger">
                  <div *ngIf="
                        paymentMethodControls['files'].errors &&
                        paymentMethodControls['files'].errors['required']
                      ">
                    {{lang?.Please_upload_void_cheque}}
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <button class="btn btn-sm btn-success" data-bs-dismiss="modal" data-bs-toggle="modal"
                  data-bs-target="#padAgreement" *ngIf="uploadCheque"
                  [disabled]="paymentMethodForm.get('files')?.value === ''" (click)="generateCorporatePAD()">
                  {{lang?.Review_and_Sign_the_PAD_Agreement}}
                </button>
              </div>
            </form>
          </div>
          <div class="modal-footer py-2">
            <button #closePaymenttoPAD type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
              id="cancelButton" (click)="closeChangeToPad()">
              <b>{{ lang?.Cancel }}</b></button>&nbsp;
          </div>
        </div>
      </div>
    </div>

    <!--  create to CC Modal -->
    <div id="changeToCC" class="modal fade modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
        <div class="modal-content" id="modal-content1">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{
              lang?.Change_to_Credit_Card
              }}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closePaymentInfo()"></i>
          </div>
          <div class="modal-body">
            <form [formGroup]="paymentform" #paymentform1
              action="https://payments.subscriptionplatform.com/v2/payments/create" method="post">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" autofocus="autofocus" id="CustomerID" formcontrolname="cutomerId"
                    name="CustomerID" type="hidden" value="{{ customerID }}" />
                </div>
                <!-- <div class="form-group col-md-12">
              <input
                class="form-control"
                autofocus="autofocus"                                  id="Id"
                formcontrolname="Id"
                name="Id"
                type="hidden"
                value="{{ paymentMethodId }}"
              />
            </div> -->
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="PublicApiKey" formcontrolname="PublicApiKey" name="PublicApiKey"
                    type="hidden" value="{{ fuseBillKey }}" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="SuccessUri" formcontrolname="SuccessUri" name="SuccessUri"
                    type="hidden" value="{{ paymentsuccessuri }}" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="FailUri" formcontrolname="FailUri" name="FailUri" type="hidden"
                    value="{{ paymentUri }}" />
                </div>
              </div>

              <!-- <div class="form-row">
                          <div class="form-group col-md-3">
                              <input
                              class="form-control"
                              id="address1"
                              formcontrolname="streetaddress"
                              name="address1"
                              type="hidden"
                              value=""/>
                          </div>
                          <div class="form-group col-md-3">
                              <input
                              class="form-control"
                              id="address2"
                              formcontrolname="streetaddressline2"
                              name="address2"
                              type="hidden"
                              value=""/>
                          </div>
                          <div class="form-group col-md-3">
                              <input
                              class="form-control"
                              id="city"
                              formcontrolname="city"
                              name="city"
                              type="hidden"
                              value=""/>
                          </div>
                          <div class="form-group col-md-3">
                              <input
                              class="form-control"
                              id="stateId"
                              formcontrolname="province"
                              name="stateId"
                              type="hidden"
                              value=""/>
                          </div>
                          <div class="form-group col-md-3">
                              <input
                              class="form-control"
                              id="postalZip"
                              formcontrolname="postalcode"
                              name="postalZip"
                              type="hidden"
                              value=""/>
                          </div>
                          <div class="form-group col-md-3">
                              <input
                              class="form-control"
                              id="apt"
                              formcontrolname="aptcheck"
                              name="apt"
                              type="hidden"
                              value=""/>
                          </div>
                      </div> -->
              <div>
                <div class="row">
                  <div class="col-md-6 form-group mt-1">
                    <label id="modal-labels">{{ lang?.First_Name
                      }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="First Name" class="form-control" id="FirstName" name="FirstName"
                      formControlName="FirstName" (keypress)="
                          (($event.charCode >= 65 && $event.charCode < 91) ||
                            ($event.charCode >= 97 && $event.charCode < 123) ||
                            $event.charCode == 32)
                        " (input)="checkFirstCharacter($event, paymentform)" />
                    <div *ngIf="
                          paymentForm['FirstName'].touched &&
                          paymentForm['FirstName'].invalid
                        " class="help-block text-danger">
                      <div *ngIf="
                            paymentForm['FirstName'].errors &&
                            paymentForm['FirstName'].errors['required']
                          ">
                        {{ lang?.Please_enter_first_name }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 form-group mt-1">
                    <label id="modal-labels">{{ lang?.Last_Name
                      }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="Last Name" class="form-control" id="LastName" name="lastName"
                      formControlName="LastName" (keypress)="
                          (($event.charCode >= 65 && $event.charCode < 91) ||
                            ($event.charCode >= 97 && $event.charCode < 123) ||
                            $event.charCode == 32)
                        " (input)="checkFirstCharacter($event, paymentform)" />
                    <div *ngIf="
                          paymentForm['LastName'].touched &&
                          paymentForm['LastName'].invalid
                        " class="help-block text-danger">
                      <div *ngIf="
                            paymentForm['LastName'].errors &&
                            paymentForm['LastName'].errors['required']
                          ">
                        {{ lang?.Please_enter_last_name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 form-group mt-1">
                    <label id="modal-labels">{{ lang?.Credit_Card_Number
                      }}<span style="color: red">*</span></label>
                    <div class="input-group">
                      <input type="text" placeholder="Credit Card Number" class="form-control" id="CardNumber"
                        name="CardNumber" formControlName="CardNumber" (keypress)="
                            (($event.charCode >= 48 && $event.charCode < 58) ||
                              $event.charCode == 32)
                          " (input)="checkFirstCharacter($event, paymentform)" />
                      <span class="input-group-text text-muted">
                        <i class="fa fa-cc-visa mx-1"></i>
                        <i class="fa fa-cc-amex mx-1"></i>
                        <i class="fa fa-cc-mastercard mx-1"></i>
                      </span>
                    </div>
                    <div *ngIf="
                          paymentForm['CardNumber'].touched &&
                          paymentForm['CardNumber'].invalid
                        " class="help-block text-danger">
                      <div *ngIf="
                            paymentForm['CardNumber'].errors &&
                            paymentForm['CardNumber'].errors['required']
                          ">
                        {{ lang?.Please_enter_card_number }}
                      </div>
                      <div *ngIf="
                            paymentForm['CardNumber'].errors &&
                            paymentForm['CardNumber'].errors['minlength']
                          ">
                        {{ lang?.Card_number_must_be_equal_to_16_digits }}
                      </div>
                      <div *ngIf="
                            paymentForm['CardNumber'].errors &&
                            paymentForm['CardNumber'].errors['maxlength']
                          ">
                        {{ lang?.Card_number_must_be_equal_to_16_digits }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8 form-group mt-1">
                    <label id="modal-labels">{{ lang?.Expiration
                      }}<span style="color: red">*</span></label>
                    <div class="input-group">
                      <select class="form-select" id="ExpirationMonth" name="ExpirationMonth"
                        formControlName="ExpirationMonth" (change)="getMonth($event)">
                        <!-- <option value="" selected disabled>MM</option> -->
                        <!-- <option *ngFor="let item of [].constructor(private logger: LoggerService,12); let i = index" value={{i+1}}>{{i+1}}</option> -->
                        <option value="" disabled selected>
                          {{ lang?.Select }}
                        </option>
                        <option value="01">Jan</option>
                        <option value="02">Feb</option>
                        <option value="03">Mar</option>
                        <option value="04">April</option>
                        <option value="05">May</option>
                        <option value="06">June</option>
                        <option value="07">July</option>
                        <option value="08">Aug</option>
                        <option value="09">Sept</option>
                        <option value="10">Oct</option>
                        <option value="11">Nov</option>
                        <option value="12">Dec</option>
                      </select>
                      <select class="form-select" id="ExpirationYear" name="ExpirationYear"
                        formControlName="ExpirationYear" (change)="getYear($event)">
                        <option value="" disabled>YYYY</option>
                        <option *ngFor="let item of [].constructor(10); let i = index" value="{{ i + 25 }}">
                          {{ i + 2025 }}
                        </option>
                      </select>
                    </div>
                    <div *ngIf="paymentForm['ExpirationMonth'].touched" class="help-block text-danger">
                      <div *ngIf="
                            paymentForm['ExpirationMonth'].errors &&
                            paymentForm['ExpirationMonth'].errors['required']
                          ">
                        {{ lang?.Please_select_expiration_month }}
                      </div>
                    </div>
                    <div *ngIf="paymentForm['ExpirationYear'].touched" class="help-block text-danger">
                      <div *ngIf="
                            paymentForm['ExpirationYear'].errors &&
                            paymentForm['ExpirationYear'].errors['required']
                          ">
                        {{ lang?.Please_select_expiration_year }}
                      </div>
                      <div *ngIf="invalidExpiration">
                        {{lang?.Please_enter_valid_expiration}}
                      </div>
                    </div>
                  </div>
                  <div class="col-4 form-group mt-1">
                    <label id="modal-labels">{{lang?.CVV}}<span style="color: red">*</span>&nbsp;<span
                        (mouseover)="showImage = true" (mouseout)="showImage = false" style="cursor: pointer"><i
                          class="bi bi-question-circle-fill"></i></span></label>
                    <img *ngIf="showImage" src="/assets/img/cvv-number.jpg" width="140px" height="80px" />
                    <input type="text" placeholder="CVV" class="form-control" id="Cvv" name="Cvv" formControlName="Cvv"
                      (keypress)="
                          ($event.charCode >= 48 && $event.charCode < 58)
                        " />
                    <div *ngIf="
                          paymentForm['Cvv'].touched && paymentForm['Cvv'].invalid
                        " class="help-block text-danger">
                      <div *ngIf="
                            paymentForm['Cvv'].errors &&
                            paymentForm['Cvv'].errors['required']
                          ">
                        {{ lang?.Please_enter_CVV }}
                      </div>
                      <div *ngIf="
                            paymentForm['Cvv'].errors &&
                            paymentForm['Cvv'].errors['minlength']
                          ">
                        {{ lang?.CVV_number_minimum_3_digits }}
                      </div>
                      <div *ngIf="
                            paymentForm['Cvv'].errors &&
                            paymentForm['Cvv'].errors['maxlength']
                          ">
                        {{ lang?.CVV_number_maximum_4_digits }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <input class="form-control" id="MakeDefault" placeholder="Name on the card" value="true"
                      type="hidden" name="MakeDefault" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 form-group mt-1">
                    <label id="modal-labels">{{ lang?.Email
                      }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="Email" class="form-control" id="email" name="email"
                      formControlName="email" (input)="checkEmail(paymentform, 'email')" />
                    <div *ngIf="
                          paymentForm['email'].errors &&
                          paymentForm['email'].errors['required']
                        ">
                      {{lang?.Please_enter_email}}
                    </div>

                    <div *ngIf="paymentForm['email'].touched && checkEmailKey" class="help-block text-danger">
                      {{lang?.Please_enter_valid_email}}
                    </div>
                  </div>
                </div>

                <!-- <div class="row">
                              <div class="col-md-12">
                                  <div class="primaryInfoLabels"><b>Your Current Address is:</b></div>
                                  <div class="primaryInfoLabels"> {{customerData?.line1}},</div>
                                  <div class="primaryInfoLabels">{{customerData?.line2}}</div>
                                  <div class="primaryInfoLabels"> {{customerData?.city |titlecase}}, {{customerData?.country |titlecase}},</div>
                                  <div class="primaryInfoLabels"> {{customerData?.postalCode| uppercase}}</div>
                              </div>
                          </div> -->
                <!-- <div class="row">
                              <div class="col-md-12">
                                  <div></div>
                              </div>
                          </div> -->
                <div class="row captchavalidation mt-2">
                  <div class="col-12">
                    <re-captcha (resolved)="resolved($event)" formControlName="recaptchaReactive"
                      siteKey="6LfVtGwUAAAAALHn9Ycaig9801f6lrPmouzuKF11">
                    </re-captcha>
                    <input id="recaptcha_token" type="hidden" name="recaptcha_token" [value]="recaptchaResponse" />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closePaymentInfo()">
              <b>{{ lang?.Cancel }}</b></button>&nbsp;
            <button type="button" class="btn btn-sm btn-light" id="updateButton"
              (click)="saveCcPayment(paymentform.value, paymentform1)">
              {{lang?.Save}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- PAD Agreement -->
    <div id="padAgreement" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{lang?.PAD_Agreement}}</span>
            <i #closeAgreement class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
          </div>
          <div class="modal-body">
            <span *ngIf="showPadLoader">
              <img src="../../../assets/img/tenor.gif" width="100" style="
                    display: block;
                    margin-left: auto;
                    margin-right: auto;
                    width: 25%;
                  " />
            </span>
            <div>
              <pdf-viewer *ngIf="true" [src]="pad" style="height: 400px; zoom: 0.85" [original-size]="true"
                [autoresize]="true" view:fitH (after-load-complete)="padLoader($event)"></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
              data-bs-target="#signaturepad" id="updateButton" (click)="clearpadsignature()">
              <b>{{lang?.Sign_Agree}}</b>
            </button>
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton"
              (click)="closepadinfo()">
              <b>{{lang?.Reject}}</b>
            </button>
          </div>
          <!-- <div class="modal-footer py-2">
                  <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton" (click)="closepadinfo()"><b>{{lang?.Close}}</b></button>
              </div> -->
        </div>
      </div>
    </div>

    <!-- Signature Pad Modal -->
    <div id="signaturepad" class="modal fade modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <label>
              <span class="modal-title">{{lang?.Signature}}</span>
            </label>
            <!-- <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
                      (click)="closeSignaturePad()"></i> -->
          </div>
          <div class="modal-body">
            <div class="signature-container">
              <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
                (onEndEvent)="drawComplete()"></signature-pad>
            </div>
            <div class="buttons">
              <button class="btn btn-sm btn-light" id="cancelButton" (click)="clearSignature()">
                {{ lang?.Clear }}
              </button>
            </div>
            <!-- <div class="signature-image" *ngIf="signatureImg">
                      <img src='{{ signatureImg }}' />
                  </div> -->
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
              data-bs-target="#signedPad" id="updateButton" (click)="savePad()">
              {{lang?.Confirm}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Signed PAD Agreement -->
    <div id="signedPad" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{lang?.PAD_Agreement}}</span>
            <i #closeAgreement class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
          </div>
          <div class="modal-body">
            <div>
              <pdf-viewer *ngIf="true" [src]="signedPad" style="height: 400px; zoom: 0.85" view:fitH></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton"
              (click)="changeToPAD()">
              <b>{{lang?.Agree}}</b>
            </button>
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton"
              (click)="closepadinfo()">
              <b>{{lang?.Reject}}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Preview change PAD Agreement -->
    <div id="previewAgreement" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor" *ngIf="fubsillstatus?.toLowerCase() != 'draft'">
            <span class="modal-title">{{lang?.Preview}}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" data-bs-toggle="modal"
              data-bs-target="#updatePaymentMethodPAD"></i>
          </div>
          <div class="modal-body">
            <span *ngIf="showVoidCheque">
              <img src="../../../assets/img/tenor.gif" width="100" style="
                    display: block;
                    margin-left: auto;
                    margin-right: auto;
                    width: 25%;
                  " />
            </span>
            <div>
              <pdf-viewer *ngIf="true" [src]="voidCheque1" style="height: 400px; zoom: 0.85" view:fitH
                (after-load-complete)="showVoidCheque = false"></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button *ngIf="fubsillstatus?.toLowerCase() != 'draft'" type="button" class="btn btn-sm btn-light"
              data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#updatePaymentMethodPAD" id="cancelButton">
              <b>{{ lang?.Close }}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Preview update PAD Agreement -->
    <div id="updatepreviewAgreement" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{lang?.Preview}}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" data-bs-toggle="modal"
              data-bs-target="#updatePADinfo"></i>
          </div>
          <div class="modal-body">
            <div *ngIf="
                  voidCheckFileType == 'image/jpeg' ||
                  voidCheckFileType == 'image/png'
                ">
              <img [src]="voidCheckImage" />
            </div>
            <div *ngIf="voidCheckFileType == 'application/pdf'">
              <span *ngIf="showvoidCheque2">
                <img src="../../../assets/img/tenor.gif" width="100" style="
                      display: block;
                      margin-left: auto;
                      margin-right: auto;
                      width: 25%;
                    " />
              </span>
              <pdf-viewer [src]="voidCheque2" style="height: 400px; zoom: 0.85" view:fitH
                (after-load-complete)="showvoidCheque2 = false"></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button *ngIf="existVoid" type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
              data-bs-toggle="modal" data-bs-target="#updatePADinfo" id="updateButton" (click)="uploadNewVoid()">
              <b>{{lang?.Upload}}</b>
            </button>
            <button *ngIf="existVoid" type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
              data-bs-toggle="modal" data-bs-target="#padAgreement" id="updateButton" (click)="updateCorporatePAD()">
              <b>{{lang?.Continue}}</b>
            </button>
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
              data-bs-target="#updatePADinfo" id="cancelButton">
              <b>{{ lang?.Close }}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Get plan Details -->
  </div>

  <div id="myApplicationsModal" class="modal fade" data-bs-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <!-- <span class="modal-title">Upload File</span> -->
          <span class="modal-title text-center" style="color:#fff">Upload File</span>
          <i class="bi bi-x-circle" style="color:#fff" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          <div>
            <select class="form-select border border-dark w-50 mb-2" name="uploadFile" [(ngModel)]="fileUpload"
              (change)="handleFileUpload()">
              <option value="null" disabled selected>Select</option>
              <option value="roe">{{ lang?.Record_of_Enrollment }}</option>
              <!-- <option value="roa">{{lang?.Record_of_Amendment}}</option>
              <option value="pad">{{ lang?.Pre_Authorized_Debit_PAD }}</option> -->
            </select>
          </div>

          <input type="file" #myFileInput id="uploadRoe12" (change)="uploadRoe($event)" />

        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
            (click)="tabData()"><b>{{lang?.Close}}</b></button>
          <button type="button" [disabled]="applicationFile==''" style="padding-top: 7px;padding-bottom: 20px;"
            (click)="UploadApplications()" class="btn btn-sm btn-light" id="updateButton">{{lang?.Upload}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="myApplicationsDropdown" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title text-center" style="color:#fff">Upload Applications</span>
          <i class="bi bi-x-circle" style="color:#fff" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          <div class="modal-body">



            <div>


              <div [formGroup]="uploadApplication">
                <div class="row">
                  <div class="col-6 form-group">
                    <label for="memberType">Select Application Type<span class="text-danger">*</span></label>
                    <select class="form-select border border-dark" name="uploadhealthCard"
                      formControlName="uploadApplicationType" (change)="showProviders($event)">
                      <option value="null" selected>{{lang?.Select}}</option>
                      <option value="roe" selected>ROE</option>
                      <option value="pad" selected>PAD</option>
                      <option value="roa" selected>ROA</option>


                    </select>
                    <div class="help-block text-danger"
                      *ngIf="uploadApplication.get('uploadApplicationType').touched && uploadApplication.get('uploadApplicationType').invalid">
                      <div
                        *ngIf="uploadApplication.get('uploadApplicationType').errors && uploadApplication.get('uploadApplicationType').errors['required']">
                        {{lang?.Please_select_service}}</div>
                    </div>

                  </div>

                </div>


                <div class="row" *ngIf="!multiUpload && types.length<=0 ">
                  <div class="mt-2">
                    <input id="fileservice" type="file" formControlName="uploadhealthCardFile" #myFileInputService
                      (change)="uploadServiceType($event)">
                    <div class="help-block text-danger"
                      *ngIf="uploadService.get('uploadhealthCardFile').touched && uploadService.get('uploadhealthCardFile').invalid">
                      <div
                        *ngIf="uploadService.get('uploadhealthCardFile').errors && uploadService.get('uploadhealthCardFile').errors['required']">
                        {{lang?.Please_select_health_card}}</div>
                    </div>
                  </div>
                </div>
              </div>


            </div>

          </div>
          <div class="modal-footer">
            <div class="help-block text-danger" *ngIf="uploadError">{{lang?.Upload_atleast_one_Card}}</div>
            <div class="help-block text-danger" *ngIf="typesError">
              {{lang?.Please_upload_all_required_health_cards}}</div>

            <!-- <button type="button" *ngIf="noService" class="btn saveAndNext"
              (click)="UploadHealthCard()">Save</button> -->
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
              (click)="closeUploadHealthCard()">{{lang?.Close}}</button>
            <button type="button" *ngIf="noService" style="padding-top: 7px;padding-bottom: 20px;"
              (click)="UploadHealthCard()" class="btn btn-sm btn-light" id="updateButton">{{lang?.Save}}</button>

          </div>
        </div>
      </div>
    </div>

    <!--  ROE Modal -->
    <div id="roe1" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
        <div class="modal-content" id="modal-content1">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{ lang?.Record_of_Enrollment }}</span>
            <i #openRoe class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closeRoe()"></i>
          </div>
          <div class="modal-body">
            <div *ngIf="viewRoe">
              <pdf-viewer [src]="roe" style="zoom: 0.85" id="pdf-viewer" view:fitH></pdf-viewer>
            </div>
            <div *ngIf="!viewRoe">
              <span>{{ lang?.Currently_ROE_is_not_available }}</span>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closeRoe()">
              <b>{{ lang?.Close }}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--  HIC Details Modal -->
    <div id="hicDetails1" class="modal fade modal-lg modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
        <div class="modal-content" id="modal-content1">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{
              lang?.Health_Insurance_Cards_Details
              }}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closeHealthCard()"></i>
          </div>
          <div class="modal-body">
            <!-- <div class="table-responsive" *ngIf="!healthCard">
                        <table class=" table-striped" id="table">
                            <thead>
                                <tr>
                                    <th class="fw-normal text-nowrap">Full Name</th>
                                    <th class="fw-normal">Email</th>
                                    <th class="fw-normal text-nowrap">Date of Birth</th>
                                    <th class="fw-normal">Gender</th>
                                    <th class="fw-normal">Relation</th>
                                    <th class="fw-normal text-nowrap">Phone No.</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let hic of hicList">
                                    <td class="text-nowrap">{{hic.name | titlecase}}</td>
                                    <td>{{hic.email}}</td>
                                    <td>{{hic.dob | date : "MM-dd-YYYY"}}</td>
                                    <td>{{hic.gender}}</td>
                                    <td>{{hic.relation}}</td>
                                    <td class="text-nowrap">{{hic.phoneNum | phoneNoFormat}}</td>
                                    <td><img role="button" src="/assets/img/view.png" alt="" width="20px"
                                            height="20px" (click)="viewHealthCard(hic)"></td>
                                    <td><img role="button" src="/assets/img/download.png" alt="" id="img"
                                            (click)="downloadHic(hic)"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->
            <div *ngIf="card">
              <h6>{{ lang?.Please_check_back_later_or_contact_your_Advisor }}</h6>
            </div>
            <span *ngIf="showFifh">
              <img src="../../../assets/img/tenor.gif" width="100" style="
                      display: block;
                      margin-left: auto;
                      margin-right: auto;
                      width: 25%;
                    " />
            </span>
            <div *ngIf="healthCard">
              <pdf-viewer [src]="src" id="pdf-viewer" style="zoom: 0.85" view:fitH
                (after-load-complete)="showLoaderfith($event)"></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeHealthCard()"
                        *ngIf="healthCard"><b>Back</b></button>&nbsp;&nbsp; -->
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closeHealthCard()">
              <b>{{ lang?.Close }}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Download All HIC Modal-->
    <!-- <div class="modal modal-lg" tabindex="-1" role="dialog" [ngStyle]="{'display':displayStyle}">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" id="backgroundColor">
                    <h6 class="modal-title">Health Insurance Cards details</h6>
                    <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" (click)="closeHealthCard()"></i>
                </div>
                <div class="modal-body">
                    <div class="table-responsive" *ngIf="!healthCard">
                        <table class=" table-striped" id="table">
                            <thead>
                                <tr>
                                    <th><input type="checkbox" [checked]="isAllCheckBoxChecked()" (change)="checkAllCheckBox($event)"></th>
                                    <th class="fw-normal text-nowrap">Full Name</th>
                                    <th class="fw-normal">Email</th>
                                    <th class="fw-normal text-nowrap">Date of Birth</th>
                                    <th class="fw-normal">Gender</th>
                                    <th class="fw-normal">Relation</th>
                                    <th class="fw-normal text-nowrap">Phone No.</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let hic of hicList">
                                    <td><input type="checkbox" [checked]="hic.checked" (change)="hic.checked = !hic.checked"></td>
                                    <td class="text-nowrap">{{hic.name}}</td>
                                    <td>{{hic.email}}</td>
                                    <td>{{hic.dob | date : "MM-dd-YYYY"}}</td>
                                    <td>{{hic.gender}}</td>
                                    <td>{{hic.relation}}</td>
                                    <td class="text-nowrap">{{hic.phoneNum | phoneNoFormat}}</td>
                                    <td><img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" (click)="viewHealthCard(hic.healthCard)"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="healthCard">
                        <pdf-viewer [src]="src" style="width: 100%; height: 500px;"></pdf-viewer>
                    </div>
                </div>
                <div class="modal-footer py-2">
                    <button type="button" class="btn btn-sm btn-light" id="updateButton" [disabled]="disabledDownload()" (click)="downloadSelected()" *ngIf="!healthCard"><b>Download</b></button>&nbsp;&nbsp;
                    <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeDownloadHealthCard()" *ngIf="healthCard"><b>Back</b></button>&nbsp;&nbsp;
                    <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton" (click)="closeHealthCard()"><b>{{lang?.Cancel}}</b></button>
                </div>
            </div>
        </div>
    </div> -->

    <!--  Booklet Details Modal -->
    <div id="hpbooklet1" class="modal fade modal-lg modalposition" tabindex="-1" role="dialog"
      aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
        <div class="modal-content" id="modal-content1">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{ lang?.View_Plan_Booklets }}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closeBooklet()"></i>
          </div>
          <div class="modal-body">
            <!-- <div class="table-responsive" *ngIf="!hidebooklet">
                        <table class="table-striped" id="table">
                            <thead id="thead">
                                <tr>
                                    <th class="fw-normal">&nbsp;S.No</th>
                                    <th class="fw-normal">Name</th>
                                    <th class="fw-normal">Description</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let booklet of bookletList; let i=index">
                                    <td>&nbsp;{{i+1}}</td>
                                    <td>{{booklet.name}}</td>
                                    <td>{{booklet.description}}</td>
                                    <td id="booklet-td">
                                        <img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" class="m-1" (click)="viewBooklet(booklet.link)">
                                        <img role="button" src="/assets/img/download.png" alt="" id="img" (click)="downloadHpbooklet(booklet)">&nbsp;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->
            <!-- <div *ngIf="hidebooklet">
                        <pdf-viewer [src]="bookletLink" style="width: 100%; height: 400px;"></pdf-viewer>
                    </div> -->
            <span *ngIf="showViewPlansLoading">
              <img src="../../../assets/img/tenor.gif" width="100" style="
                      display: block;
                      margin-left: auto;
                      margin-right: auto;
                      width: 25%;
                    " />
            </span>
            <div>
              <pdf-viewer *ngIf="true" [src]="bookletLink" id="pdf-viewer"
                (after-load-complete)="viewPlansLoading($event)"></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeBooklet()" *ngIf="hidebooklet"><b>Back</b></button>&nbsp;&nbsp; -->
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closeBooklet()">
              <b>{{ lang?.Close }}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Download All Booklets -->
    <div class="modal modal-lg" tabindex="-1" role="dialog" [ngStyle]="{ display: displayBooklet }">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{
              lang?.Health_Plan_Booklets_Download
              }}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closeBooklet()"></i>
          </div>
          <div class="modal-body">
            <div class="table-responsive" *ngIf="!hidebooklet">
              <table class="table-striped" id="table">
                <thead id="thead">
                  <tr>
                    <th>
                      <input type="checkbox" [checked]="isAllBookletsChecked()" (change)="checkAllBooklets($event)" />
                    </th>
                    <!-- <th class="fw-normal">&nbsp;S.No</th> -->
                    <th class="fw-normal">{{ lang?.Name }}</th>
                    <th class="fw-normal">{{ lang?.Description }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let booklet of bookletList; let i = index">
                    <td>
                      <input type="checkbox" [checked]="booklet.checked"
                        (change)="booklet.checked = !booklet.checked" />
                    </td>
                    <!-- <td>&nbsp;{{i+1}}</td> -->
                    <td>{{ booklet.name }}</td>
                    <td>{{ booklet.description }}</td>
                    <td id="booklet-td">
                      <!-- <img role="button" src="/assets/img/download.png" alt="" (click)="downloadHpbooklet(booklet)"> -->
                      <img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" class="m-2"
                        (click)="viewBooklet(booklet.link)" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="hidebooklet">
              <span *ngIf="showLoadrForDownloadBookLets">
                <img src="../../../assets/img/tenor.gif" width="100" style="
                        display: block;
                        margin-left: auto;
                        margin-right: auto;
                        width: 25%;
                      " />
              </span>
              <pdf-viewer [src]="bookletLink" style="width: 100%; height: 400px; zoom: 0.85" view:fitH
                (after-load-complete)="LoadrForDownloadBookLets($event)"></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="downloadSelected()"
              *ngIf="!hidebooklet">
              <b>{{ lang?.Download }}</b></button>&nbsp;&nbsp;
            <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeDownloadBooklet()"
              *ngIf="hidebooklet">
              <b>{{ lang?.Back }}</b></button>&nbsp;&nbsp;
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closeBooklet()">
              <b>{{ lang?.Close }}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit CC Modal -->
    <div id="updatePaymentInfo" class="modal fade modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{ lang?.Update_Credit_Card_Info }}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closePaymentInfo()"></i>
          </div>
          <div class="modal-body">
            <form [formGroup]="ccform" #paymentform2 action="https://payments.subscriptionplatform.com/v2/payments/edit"
              method="post">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" autofocus="autofocus" id="CustomerID" formcontrolname="cutomerId"
                    name="CustomerID" type="hidden" value="{{ fusebillId }}" />
                </div>
                <div class="form-group col-md-12">
                  <!-- paymentMethodId -->
                  <input class="form-control" autofocus="autofocus" id="Id" formcontrolname="Id" name="Id" type="hidden"
                    value="{{ paymentMethodId }}" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="PublicApiKey" formcontrolname="PublicApiKey" name="PublicApiKey"
                    type="hidden" value="{{ fuseBillKey }}" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="SuccessUri" formcontrolname="SuccessUri" name="SuccessUri"
                    type="hidden" value="{{ paymentsuccessuri }}" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="FailUri" formcontrolname="FailUri" name="FailUri" type="hidden"
                    value="{{ paymentUri }}" />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 form-group mt-1">
                  <label id="modal-labels">{{ lang?.First_Name
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="First Name" class="form-control" id="FirstName" name="FirstName"
                    formControlName="FirstName" (keypress)="
                          (($event.charCode >= 65 && $event.charCode < 91) ||
                            ($event.charCode >= 97 && $event.charCode < 123) ||
                            $event.charCode == 32)
                        " (input)="checkFirstCharacter($event, ccform)" />
                  <div *ngIf="
                          ccForm['FirstName'].touched && ccForm['FirstName'].invalid
                        " class="help-block text-danger">
                    <div *ngIf="
                            ccForm['FirstName'].errors &&
                            ccForm['FirstName'].errors['required']
                          ">
                      {{ lang?.Please_enter_first_name }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 form-group mt-1">
                  <label id="modal-labels">{{ lang?.Last_Name
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Last Name" class="form-control" id="LastName" name="LastName"
                    formControlName="LastName" (keypress)="
                          (($event.charCode >= 65 && $event.charCode < 91) ||
                            ($event.charCode >= 97 && $event.charCode < 123) ||
                            $event.charCode == 32)
                        " (input)="checkFirstCharacter($event, ccform)" />
                  <div *ngIf="
                          ccForm['LastName'].touched && ccForm['LastName'].invalid
                        " class="help-block text-danger">
                    <div *ngIf="
                            ccForm['LastName'].errors &&
                            ccForm['LastName'].errors['required']
                          ">
                      {{ lang?.Please_enter_last_name }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 form-group mt-1">
                  <!-- <label id="modal-labels">{{lang1.email}}<span style="color: red">*</span></label> -->
                  <input type="text" placeholder="Last Name" class="form-control" id="email" type="hidden" name="email"
                    formControlName="email" value="test@aitetspro.com" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group mt-1">
                  <label id="modal-labels">{{ lang?.Credit_Card_Number }}<span style="color: red">*</span></label>
                  <div class="input-group">
                    <input type="text" placeholder="Credit Card Number" class="form-control" id="CardNumber"
                      name="CardNumber" formControlName="CardNumber" (keypress)="
                            ($event.charCode >= 48 && $event.charCode < 58)
                          " (input)="creditcardlblurmethod($event)" />
                    <span class="input-group-text text-muted">
                      <i class="fa fa-cc-visa mx-1"></i>
                      <i class="fa fa-cc-amex mx-1"></i>
                      <i class="fa fa-cc-mastercard mx-1"></i>
                    </span>
                  </div>
                  <!-- <div *ngIf="ccForm['CardNumber'].touched && ccForm['CardNumber'].invalid"
                  class="help-block text-danger">
                  <div
                    *ngIf="ccForm['CardNumber'].errors && ccForm['CardNumber'].errors['required']">
                    {{lang?.Please_enter_card_number}}</div>
                  <div
                    *ngIf="ccForm['CardNumber'].errors && ccForm['CardNumber'].errors['minlength']">
                    {{lang?.Card_number_must_be_equal_to_16_digits}}</div>
                  <div
                    *ngIf="ccForm['CardNumber'].errors && ccForm['CardNumber'].errors['maxlength']">
                    {{lang?.Card_number_must_be_equal_to_16_digits}}</div>
                </div> -->
                  <div class="help-block text-danger" *ngIf="
                          ccForm['CardNumber'].touched &&
                          ccForm['CardNumber'].errors &&
                          ccForm['CardNumber'].errors['required']
                        ">
                    {{ lang?.Please_enter_card_number }}
                  </div>
                  <div class="help-block text-danger" *ngIf="
                          (ccForm['CardNumber'].touched &&
                            ccForm['CardNumber'].hasError(
                              'invalidcreditcarddetails'
                            )) ||
                          invalidcreditcard
                        ">
                    {{lang?.Please_enter_valid_Card_number}}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-8 form-group mt-1">
                  <label id="modal-labels">{{ lang?.Expiration
                    }}<span style="color: red">*</span></label>
                  <div class="input-group">
                    <div id="yearselect">
                      <select class="form-select" id="ExpirationMonth" name="ExpirationMonth"
                        formControlName="ExpirationMonth" (change)="getMonth($event)">
                        <!-- <option value="" selected disabled>MM</option> -->
                        <option value="" disabled selected>
                          {{ lang?.Select }}
                        </option>
                        <option value="01">Jan</option>
                        <option value="02">Feb</option>
                        <option value="03">Mar</option>
                        <option value="04">April</option>
                        <option value="05">May</option>
                        <option value="06">June</option>
                        <option value="07">July</option>
                        <option value="08">Aug</option>
                        <option value="09">Sept</option>
                        <option value="10">Oct</option>
                        <option value="11">Nov</option>
                        <option value="12">Dec</option>
                      </select>
                    </div>
                    <select class="form-select" id="ExpirationYear" name="ExpirationYear"
                      formControlName="ExpirationYear" (change)="getYear($event)">
                      <option value="" disabled>YYYY</option>
                      <option *ngFor="let item of [].constructor(10); let i = index" value="{{ i + 25 }}">
                        {{ i + 2025 }}
                      </option>
                    </select>
                  </div>
                  <div *ngIf="ccForm['ExpirationMonth'].touched" class="help-block text-danger">
                    <div *ngIf="
                            ccForm['ExpirationMonth'].errors &&
                            ccForm['ExpirationMonth'].errors['required']
                          ">
                      {{ lang?.Please_select_expiration_month }}
                    </div>
                  </div>
                  <div *ngIf="ccForm['ExpirationYear'].touched" class="help-block text-danger">
                    <div *ngIf="
                            ccForm['ExpirationYear'].errors &&
                            ccForm['ExpirationYear'].errors['required']
                          ">
                      {{ lang?.Please_select_expiration_year }}
                    </div>
                    <div *ngIf="invalidExpiration">
                      {{lang?.Please_enter_valid_expiration}}
                    </div>
                  </div>
                </div>
                <div class="col-4 form-group mt-1">
                  <label id="modal-labels">{{lang?.CVV}}<span style="color: red">*</span>&nbsp;<span
                      (mouseover)="showImage = true" (mouseout)="showImage = false" style="cursor: pointer"><i
                        class="bi bi-question-circle-fill"></i></span></label>
                  <img *ngIf="showImage" src="/assets/img/cvv-number.jpg" width="140px" height="80px" />
                  <input type="text" placeholder="CVV" class="form-control" id="Cvv" name="Cvv" formControlName="Cvv"
                    (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="ccForm['Cvv'].touched && ccForm['Cvv'].invalid" class="help-block text-danger">
                    <div *ngIf="
                            ccForm['Cvv'].errors && ccForm['Cvv'].errors['required']
                          ">
                      {{ lang?.Please_enter_CVV }}
                    </div>
                    <div *ngIf="
                            ccForm['Cvv'].errors &&
                            ccForm['Cvv'].errors['minlength']
                          ">
                      {{ lang?.CVV_number_minimum_3_digits }}
                    </div>
                    <div *ngIf="
                            ccForm['Cvv'].errors &&
                            ccForm['Cvv'].errors['maxlength']
                          ">
                      {{ lang?.CVV_number_maximum_4_digits }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="MakeDefault" placeholder="Name on the card" value="true" type="hidden"
                    name="MakeDefault" />
                </div>
              </div>
              <div class="form-row captchavalidation mt-2">
                <re-captcha (resolved)="resolved($event)" formControlName="recaptchaReactive"
                  siteKey="6LfVtGwUAAAAALHn9Ycaig9801f6lrPmouzuKF11">
                </re-captcha>
                <input id="recaptcha_token" type="hidden" name="recaptcha_token" [value]="recaptchaResponse" />
              </div>
            </form>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closeCcInfo()">
              <b>{{ lang?.Cancel }}</b></button>&nbsp;
            <button type="submit" class="btn btn-sm btn-light" id="updateButton"
              (click)="updateCcInfo(ccform.value, paymentform2)">
              {{ lang?.Update }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- PAD Update Modal -->
    <div id="updatePADinfo" class="modal fade modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered" id="updatePadModal">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{ lang?.Update_PAD_Details }}</span>
            <i #closePaymentmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closepadinfo()"></i>
          </div>
          <div class="modal-body">
            <form [formGroup]="padform">
              <div class="row">
                <div class="col-md-4 form-group">
                  <label id="modal-labels">{{ lang?.Bank_Id
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Bank Number" formControlName="bankcode" class="form-control"
                    (input)="padformValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="
                          padForm['bankcode'].touched && padForm['bankcode'].invalid
                        " class="help-block text-danger">
                    <div *ngIf="
                            padForm['bankcode'].errors &&
                            padForm['bankcode'].errors['required']
                          ">
                      {{ lang?.Please_enter_bank_number }}
                    </div>
                    <div *ngIf="
                            padForm['bankcode'].errors &&
                            padForm['bankcode'].errors['minlength']
                          ">
                      {{ lang?.Bank_number_must_be_equal_to_3_digits }}
                    </div>
                    <div *ngIf="
                            padForm['bankcode'].errors &&
                            padForm['bankcode'].errors['maxlength']
                          ">
                      {{ lang?.Bank_number_must_be_equal_to_3_digits }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label id="modal-labels">{{ lang?.Transit
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Transit Number" formControlName="transitNumber" class="form-control"
                    (input)="padformValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="
                          padForm['transitNumber'].touched &&
                          padForm['transitNumber'].invalid
                        " class="help-block text-danger">
                    <div *ngIf="
                            padForm['transitNumber'].errors &&
                            padForm['transitNumber'].errors['required']
                          ">
                      {{ lang?.Please_enter_transit_number }}
                    </div>
                    <div *ngIf="
                            padForm['transitNumber'].errors &&
                            padForm['transitNumber'].errors['minlength']
                          ">
                      {{ lang?.Transit_number_must_be_equal_to_5_digits }}
                    </div>
                    <div *ngIf="
                            padForm['transitNumber'].errors &&
                            padForm['transitNumber'].errors['maxlength']
                          ">
                      {{ lang?.Transit_number_must_be_equal_to_5_digits }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label id="modal-labels">{{ lang?.Account
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Account Number" formControlName="accountNo" class="form-control"
                    (input)="padformValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="
                          padForm['accountNo'].touched &&
                          padForm['accountNo'].invalid
                        " class="help-block text-danger">
                    <div *ngIf="
                            padForm['accountNo'].errors &&
                            padForm['accountNo'].errors['required']
                          ">
                      {{ lang?.Please_enter_account_number }}
                    </div>
                    <div *ngIf="
                            padForm['accountNo'].errors &&
                            padForm['accountNo'].errors['minlength']
                          ">
                      {{ lang?.Account_number_minimum_5_digits }}
                    </div>
                    <div *ngIf="
                            padForm['accountNo'].errors &&
                            padForm['accountNo'].errors['maxlength']
                          ">
                      {{ lang?.Account_number_maximum_12_digits }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="bankinfo">
                <div class="col-md-12 form-group">
                  <label id="modal-labels">{{ lang?.Bank_Details }}</label>
                  <!-- <div id="bankInfo"> -->
                  <!-- <textarea id="bankDetails" formControlName="bankdetails">
                  <div>{{bank.name}}</div>
                  <div *ngFor="let bankAddress of bankAddress">{{bankAddress}}</div>
                </textarea> -->
                  <!-- </div> -->
                  <textarea class="form-control checking-field" id="bankname" placeholder="" name="bankname"
                    formControlName="bankdetails" style="color: rgba(85, 85, 85, 0.9)" [ngModel]="banknameres"
                    rows="6"></textarea>
                </div>
              </div>
              <div class="mt-2">
                <button type="button" class="btn btn-sm btn-light" id="updateButton" *ngIf="resetbutton"
                  (click)="resetPadForm()">
                  {{ lang?.Clear }}
                </button>
                <button type="button" class="btn btn-sm btn-light" id="updateButton" *ngIf="padform.valid && !bankinfo"
                  (click)="updateBankInfo()">
                  {{ lang?.Verify }}
                </button>
              </div>
              <div class="mt-2">
                <button type="button" class="btn btn-sm btn-light" id="updateButton" *ngIf="existVoid && bankinfo"
                  data-bs-toggle="modal" data-bs-target="#updatepreviewAgreement" (click)="existingVoidCheque()">
                  {{ lang?.Click_here_to_view_Void_Cheque }}
                </button>
              </div>
              <div class="form-group" *ngIf="cheque && !existVoid">
                <label id="modal-labels">{{lang?.Upload_Void_Cheque}}<span style="color: red">*</span></label>
                <div class="row">
                  <div class="col-8 pt-1">
                    <input type="file" formControlName="file" (change)="fileSelect($event)" />
                  </div>
                  <div class="col-4" *ngIf="updatepreviewbutton">
                    <button class="btn btn-sm btn-dark" data-bs-toggle="modal" data-bs-target="#updatepreviewAgreement"
                      (click)="updatePadpreview()">
                      {{lang?.Preview}}
                    </button>
                  </div>
                </div>
                <div *ngIf="padForm['file'].touched && padForm['file'].invalid" class="help-block text-danger">
                  <div *ngIf="
                          padForm['file'].errors &&
                          padForm['file'].errors['required']
                        ">
                    {{lang?.Please_upload_void_cheque}}
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <button class="btn btn-sm btn-success primaryInfoLabels" data-bs-dismiss="modal" data-bs-toggle="modal"
                  data-bs-target="#padAgreement" *ngIf="cheque && !existVoid" [disabled]="
                        padform.get('file')?.value == null ||
                        padform.get('file')?.value == ''
                      " (click)="updateCorporatePAD()">
                  {{lang?.Review_and_Sign_the_PAD_Agreement}}
                </button>
              </div>
            </form>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closepadinfo()">
              <b>{{ lang?.Cancel }}</b></button>&nbsp;
          </div>
        </div>
      </div>
    </div>

    <!--  Change to PAD Modal -->
    <div id="updatePaymentMethodPAD" class="modal fade modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{
              lang?.Update_Payment_Method
              }}</span>
            <i #closePaymentmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closeChangeToPad()"></i>
          </div>
          <div class="modal-body">
            <form [formGroup]="paymentMethodForm">
              <div class="row">
                <div class="col-md-12 form-group">
                  <label id="modal-labels"><b>{{
                      lang?.Do_you_want_to_change_payment_method_to_Pre_Authorized_Debit
                      }}<span style="color: red">*</span></b></label>
                </div>
              </div>
              <div class="row">
                <div class="col-3">
                  <input type="radio" value="yes" formControlName="paymentmethod" id="paymentmethod"
                    name="paymentmethod" (click)="openPaymentDetails('open')" />&nbsp;<label id="radio-labels"
                    class="align-text-top">{{
                    lang?.Yes
                    }}</label>
                </div>
                <div class="col-3">
                  <input type="radio" value="no" formControlName="paymentmethod" id="paymentmethod" name="paymentmethod"
                    (click)="openPaymentDetails('close')" />&nbsp;<label id="radio-labels" class="align-text-top">{{
                    lang?.No
                    }}</label>
                </div>
              </div>
              <div class="row" *ngIf="openUpdatePaymentForm === 'open'">
                <div class="col-md-4 form-group">
                  <label id="modal-labels">{{ lang?.Bank_Id
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Bank Number" formControlName="bankCode" class="form-control"
                    (input)="paymentMethodFormValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="
                          paymentMethodControls['bankCode'].touched &&
                          paymentMethodControls['bankCode'].invalid
                        " class="help-block text-danger">
                    <div *ngIf="
                            paymentMethodControls['bankCode'].errors &&
                            paymentMethodControls['bankCode'].errors['required']
                          ">
                      {{ lang?.Please_enter_bank_number }}
                    </div>
                    <div *ngIf="
                            paymentMethodControls['bankCode'].errors &&
                            paymentMethodControls['bankCode'].errors['minlength']
                          ">
                      {{ lang?.Bank_number_must_be_equal_to_3_digits }}
                    </div>
                    <div *ngIf="
                            paymentMethodControls['bankCode'].errors &&
                            paymentMethodControls['bankCode'].errors['maxlength']
                          ">
                      {{ lang?.Bank_number_must_be_equal_to_3_digits }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label id="modal-labels">{{ lang?.Transit
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Transit Number" formControlName="branchCode" class="form-control"
                    (input)="paymentMethodFormValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="
                          paymentMethodControls['branchCode'].touched &&
                          paymentMethodControls['branchCode'].invalid
                        " class="help-block text-danger">
                    <div *ngIf="
                            paymentMethodControls['branchCode'].errors &&
                            paymentMethodControls['branchCode'].errors['required']
                          ">
                      {{ lang?.Please_enter_transit_number }}
                    </div>
                    <div *ngIf="
                            paymentMethodControls['branchCode'].errors &&
                            paymentMethodControls['branchCode'].errors['minlength']
                          ">
                      {{ lang?.Transit_number_must_be_equal_to_5_digits }}
                    </div>
                    <div *ngIf="
                            paymentMethodControls['branchCode'].errors &&
                            paymentMethodControls['branchCode'].errors['maxlength']
                          ">
                      {{ lang?.Transit_number_must_be_equal_to_5_digits }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label id="modal-labels">{{ lang?.Account
                    }}<span style="color: red">*</span></label>
                  <input type="text" placeholder="Account Number" formControlName="accountNumber" class="form-control"
                    (input)="paymentMethodFormValid()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  <div *ngIf="
                          paymentMethodControls['accountNumber'].touched &&
                          paymentMethodControls['accountNumber'].invalid
                        " class="help-block text-danger">
                    <div *ngIf="
                            paymentMethodControls['accountNumber'].errors &&
                            paymentMethodControls['accountNumber'].errors[
                              'required'
                            ]
                          ">
                      {{ lang?.Please_enter_account_number }}
                    </div>
                    <div *ngIf="
                            paymentMethodControls['accountNumber'].errors &&
                            paymentMethodControls['accountNumber'].errors[
                              'minlength'
                            ]
                          ">
                      {{ lang?.Account_number_minimum_5_digits }}
                    </div>
                    <div *ngIf="
                            paymentMethodControls['accountNumber'].errors &&
                            paymentMethodControls['accountNumber'].errors[
                              'maxlength'
                            ]
                          ">
                      {{ lang?.Account_number_maximum_12_digits }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="bankDetails">
                <div class="col-md-12 form-group">
                  <label id="modal-labels">{{ lang?.Bank_Details }}</label>
                  <div id="bankInfo">
                    <div id="bankDetails">
                      <div>{{ bankInfo.name }}</div>
                      <div *ngFor="let bankAddress of bankAddress">
                        {{ bankAddress }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <button type="button" class="btn btn-sm btn-light" id="updateButton" *ngIf="resetButton"
                  (click)="resetPaymentForm()">
                  {{ lang?.Clear }}
                </button>
                <button type="button" class="btn btn-sm btn-light" id="updateButton"
                  *ngIf="paymentMethodForm.valid && !bankDetails" (click)="getBankInfo()">
                  {{ lang?.Verify }}
                </button>
              </div>
              <div class="form-group" *ngIf="uploadCheque">
                <label id="modal-labels">{{lang?.Upload_Void_Cheque}}<span style="color: red">*</span></label>
                <div class="row">
                  <div class="col-8 pt-1">
                    <input type="file" formControlName="files" (change)="onFileSelect($event)" />
                  </div>
                  <div class="col-4" *ngIf="previewbutton">
                    <button class="btn btn-sm btn-dark" data-bs-toggle="modal" data-bs-target="#previewAgreement"
                      (click)="changepad()">
                      {{lang?.Preview}}
                    </button>
                  </div>
                </div>
                <div *ngIf="
                        paymentMethodControls['files'].touched &&
                        paymentMethodControls['files'].invalid
                      " class="help-block text-danger">
                  <div *ngIf="
                          paymentMethodControls['files'].errors &&
                          paymentMethodControls['files'].errors['required']
                        ">
                    {{lang?.Please_upload_void_cheque}}
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <button class="btn btn-sm btn-success" data-bs-dismiss="modal" data-bs-toggle="modal"
                  data-bs-target="#padAgreement" *ngIf="uploadCheque"
                  [disabled]="paymentMethodForm.get('files')?.value === ''" (click)="generateCorporatePAD()">
                  {{lang?.Review_and_Sign_the_PAD_Agreement}}
                </button>
              </div>
            </form>
          </div>
          <div class="modal-footer py-2">
            <button #closePaymenttoPAD type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
              id="cancelButton" (click)="closeChangeToPad()">
              <b>{{ lang?.Cancel }}</b></button>&nbsp;
          </div>
        </div>
      </div>
    </div>

    <!--  create to CC Modal -->
    <div id="changeToCC" class="modal fade modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
        <div class="modal-content" id="modal-content1">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{
              lang?.Change_to_Credit_Card
              }}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
              (click)="closePaymentInfo()"></i>
          </div>
          <div class="modal-body">
            <form [formGroup]="paymentform" #paymentform1
              action="https://payments.subscriptionplatform.com/v2/payments/create" method="post">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" autofocus="autofocus" id="CustomerID" formcontrolname="cutomerId"
                    name="CustomerID" type="hidden" value="{{ customerID }}" />
                </div>
                <!-- <div class="form-group col-md-12">
                <input
                  class="form-control"
                  autofocus="autofocus"                                  id="Id"
                  formcontrolname="Id"
                  name="Id"
                  type="hidden"
                  value="{{ paymentMethodId }}"
                />
              </div> -->
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="PublicApiKey" formcontrolname="PublicApiKey" name="PublicApiKey"
                    type="hidden" value="{{ fuseBillKey }}" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="SuccessUri" formcontrolname="SuccessUri" name="SuccessUri"
                    type="hidden" value="{{ paymentsuccessuri }}" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <input class="form-control" id="FailUri" formcontrolname="FailUri" name="FailUri" type="hidden"
                    value="{{ paymentUri }}" />
                </div>
              </div>

              <!-- <div class="form-row">
                            <div class="form-group col-md-3">
                                <input
                                class="form-control"
                                id="address1"
                                formcontrolname="streetaddress"
                                name="address1"
                                type="hidden"
                                value=""/>
                            </div>
                            <div class="form-group col-md-3">
                                <input
                                class="form-control"
                                id="address2"
                                formcontrolname="streetaddressline2"
                                name="address2"
                                type="hidden"
                                value=""/>
                            </div>
                            <div class="form-group col-md-3">
                                <input
                                class="form-control"
                                id="city"
                                formcontrolname="city"
                                name="city"
                                type="hidden"
                                value=""/>
                            </div>
                            <div class="form-group col-md-3">
                                <input
                                class="form-control"
                                id="stateId"
                                formcontrolname="province"
                                name="stateId"
                                type="hidden"
                                value=""/>
                            </div>
                            <div class="form-group col-md-3">
                                <input
                                class="form-control"
                                id="postalZip"
                                formcontrolname="postalcode"
                                name="postalZip"
                                type="hidden"
                                value=""/>
                            </div>
                            <div class="form-group col-md-3">
                                <input
                                class="form-control"
                                id="apt"
                                formcontrolname="aptcheck"
                                name="apt"
                                type="hidden"
                                value=""/>
                            </div>
                        </div> -->
              <div>
                <div class="row">
                  <div class="col-md-6 form-group mt-1">
                    <label id="modal-labels">{{ lang?.First_Name
                      }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="First Name" class="form-control" id="FirstName" name="FirstName"
                      formControlName="FirstName" (keypress)="
                            (($event.charCode >= 65 && $event.charCode < 91) ||
                              ($event.charCode >= 97 && $event.charCode < 123) ||
                              $event.charCode == 32)
                          " (input)="checkFirstCharacter($event, paymentform)" />
                    <div *ngIf="
                            paymentForm['FirstName'].touched &&
                            paymentForm['FirstName'].invalid
                          " class="help-block text-danger">
                      <div *ngIf="
                              paymentForm['FirstName'].errors &&
                              paymentForm['FirstName'].errors['required']
                            ">
                        {{ lang?.Please_enter_first_name }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 form-group mt-1">
                    <label id="modal-labels">{{ lang?.Last_Name
                      }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="Last Name" class="form-control" id="LastName" name="lastName"
                      formControlName="LastName" (keypress)="
                            (($event.charCode >= 65 && $event.charCode < 91) ||
                              ($event.charCode >= 97 && $event.charCode < 123) ||
                              $event.charCode == 32)
                          " (input)="checkFirstCharacter($event, paymentform)" />
                    <div *ngIf="
                            paymentForm['LastName'].touched &&
                            paymentForm['LastName'].invalid
                          " class="help-block text-danger">
                      <div *ngIf="
                              paymentForm['LastName'].errors &&
                              paymentForm['LastName'].errors['required']
                            ">
                        {{ lang?.Please_enter_last_name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 form-group mt-1">
                    <label id="modal-labels">{{ lang?.Credit_Card_Number
                      }}<span style="color: red">*</span></label>
                    <div class="input-group">
                      <input type="text" placeholder="Credit Card Number" class="form-control" id="CardNumber"
                        name="CardNumber" formControlName="CardNumber" (keypress)="
                              (($event.charCode >= 48 && $event.charCode < 58) ||
                                $event.charCode == 32)
                            " (input)="checkFirstCharacter($event, paymentform)" />
                      <span class="input-group-text text-muted">
                        <i class="fa fa-cc-visa mx-1"></i>
                        <i class="fa fa-cc-amex mx-1"></i>
                        <i class="fa fa-cc-mastercard mx-1"></i>
                      </span>
                    </div>
                    <div *ngIf="
                            paymentForm['CardNumber'].touched &&
                            paymentForm['CardNumber'].invalid
                          " class="help-block text-danger">
                      <div *ngIf="
                              paymentForm['CardNumber'].errors &&
                              paymentForm['CardNumber'].errors['required']
                            ">
                        {{ lang?.Please_enter_card_number }}
                      </div>
                      <div *ngIf="
                              paymentForm['CardNumber'].errors &&
                              paymentForm['CardNumber'].errors['minlength']
                            ">
                        {{ lang?.Card_number_must_be_equal_to_16_digits }}
                      </div>
                      <div *ngIf="
                              paymentForm['CardNumber'].errors &&
                              paymentForm['CardNumber'].errors['maxlength']
                            ">
                        {{ lang?.Card_number_must_be_equal_to_16_digits }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8 form-group mt-1">
                    <label id="modal-labels">{{ lang?.Expiration
                      }}<span style="color: red">*</span></label>
                    <div class="input-group">
                      <select class="form-select" id="ExpirationMonth" name="ExpirationMonth"
                        formControlName="ExpirationMonth" (change)="getMonth($event)">
                        <!-- <option value="" selected disabled>MM</option> -->
                        <!-- <option *ngFor="let item of [].constructor(private logger: LoggerService,12); let i = index" value={{i+1}}>{{i+1}}</option> -->
                        <option value="" disabled selected>
                          {{ lang?.Select }}
                        </option>
                        <option value="01">Jan</option>
                        <option value="02">Feb</option>
                        <option value="03">Mar</option>
                        <option value="04">April</option>
                        <option value="05">May</option>
                        <option value="06">June</option>
                        <option value="07">July</option>
                        <option value="08">Aug</option>
                        <option value="09">Sept</option>
                        <option value="10">Oct</option>
                        <option value="11">Nov</option>
                        <option value="12">Dec</option>
                      </select>
                      <select class="form-select" id="ExpirationYear" name="ExpirationYear"
                        formControlName="ExpirationYear" (change)="getYear($event)">
                        <option value="" disabled>YYYY</option>
                        <option *ngFor="let item of [].constructor(10); let i = index" value="{{ i + 25 }}">
                          {{ i + 2025 }}
                        </option>
                      </select>
                    </div>
                    <div *ngIf="paymentForm['ExpirationMonth'].touched" class="help-block text-danger">
                      <div *ngIf="
                              paymentForm['ExpirationMonth'].errors &&
                              paymentForm['ExpirationMonth'].errors['required']
                            ">
                        {{ lang?.Please_select_expiration_month }}
                      </div>
                    </div>
                    <div *ngIf="paymentForm['ExpirationYear'].touched" class="help-block text-danger">
                      <div *ngIf="
                              paymentForm['ExpirationYear'].errors &&
                              paymentForm['ExpirationYear'].errors['required']
                            ">
                        {{ lang?.Please_select_expiration_year }}
                      </div>
                      <div *ngIf="invalidExpiration">
                        {{lang?.Please_enter_valid_expiration}}
                      </div>
                    </div>
                  </div>
                  <div class="col-4 form-group mt-1">
                    <label id="modal-labels">{{lang?.CVV}}<span style="color: red">*</span>&nbsp;<span
                        (mouseover)="showImage = true" (mouseout)="showImage = false" style="cursor: pointer"><i
                          class="bi bi-question-circle-fill"></i></span></label>
                    <img *ngIf="showImage" src="/assets/img/cvv-number.jpg" width="140px" height="80px" />
                    <input type="text" placeholder="CVV" class="form-control" id="Cvv" name="Cvv" formControlName="Cvv"
                      (keypress)="
                            ($event.charCode >= 48 && $event.charCode < 58)
                          " />
                    <div *ngIf="
                            paymentForm['Cvv'].touched && paymentForm['Cvv'].invalid
                          " class="help-block text-danger">
                      <div *ngIf="
                              paymentForm['Cvv'].errors &&
                              paymentForm['Cvv'].errors['required']
                            ">
                        {{ lang?.Please_enter_CVV }}
                      </div>
                      <div *ngIf="
                              paymentForm['Cvv'].errors &&
                              paymentForm['Cvv'].errors['minlength']
                            ">
                        {{ lang?.CVV_number_minimum_3_digits }}
                      </div>
                      <div *ngIf="
                              paymentForm['Cvv'].errors &&
                              paymentForm['Cvv'].errors['maxlength']
                            ">
                        {{ lang?.CVV_number_maximum_4_digits }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <input class="form-control" id="MakeDefault" placeholder="Name on the card" value="true"
                      type="hidden" name="MakeDefault" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 form-group mt-1">
                    <label id="modal-labels">{{ lang?.Email
                      }}<span style="color: red">*</span></label>
                    <input type="text" placeholder="Email" class="form-control" id="email" name="email"
                      formControlName="email" (input)="checkEmail(paymentform, 'email')" />
                    <div *ngIf="
                            paymentForm['email'].errors &&
                            paymentForm['email'].errors['required']
                          ">
                      {{lang?.Please_enter_email}}
                    </div>

                    <div *ngIf="paymentForm['email'].touched && checkEmailKey" class="help-block text-danger">
                      {{lang?.Please_enter_valid_email}}
                    </div>
                  </div>
                </div>

                <!-- <div class="row">
                                <div class="col-md-12">
                                    <div class="primaryInfoLabels"><b>Your Current Address is:</b></div>
                                    <div class="primaryInfoLabels"> {{customerData?.line1}},</div>
                                    <div class="primaryInfoLabels">{{customerData?.line2}}</div>
                                    <div class="primaryInfoLabels"> {{customerData?.city |titlecase}}, {{customerData?.country |titlecase}},</div>
                                    <div class="primaryInfoLabels"> {{customerData?.postalCode| uppercase}}</div>
                                </div>
                            </div> -->
                <!-- <div class="row">
                                <div class="col-md-12">
                                    <div></div>
                                </div>
                            </div> -->
                <div class="row captchavalidation mt-2">
                  <div class="col-12">
                    <re-captcha (resolved)="resolved($event)" formControlName="recaptchaReactive"
                      siteKey="6LfVtGwUAAAAALHn9Ycaig9801f6lrPmouzuKF11">
                    </re-captcha>
                    <input id="recaptcha_token" type="hidden" name="recaptcha_token" [value]="recaptchaResponse" />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
              (click)="closePaymentInfo()">
              <b>{{ lang?.Cancel }}</b></button>&nbsp;
            <button type="button" class="btn btn-sm btn-light" id="updateButton"
              (click)="saveCcPayment(paymentform.value, paymentform1)">
              {{lang?.Save}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- PAD Agreement -->
    <div id="padAgreement" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{lang?.PAD_Agreement}}</span>
            <i #closeAgreement class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
          </div>
          <div class="modal-body">
            <span *ngIf="showPadLoader">
              <img src="../../../assets/img/tenor.gif" width="100" style="
                      display: block;
                      margin-left: auto;
                      margin-right: auto;
                      width: 25%;
                    " />
            </span>
            <div>
              <pdf-viewer *ngIf="true" [src]="pad" style="height: 400px; zoom: 0.85" [original-size]="true"
                [autoresize]="true" view:fitH (after-load-complete)="padLoader($event)"></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
              data-bs-target="#signaturepad" id="updateButton" (click)="clearpadsignature()">
              <b>{{lang?.Sign_Agree}}</b>
            </button>
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton"
              (click)="closepadinfo()">
              <b>{{lang?.Reject}}</b>
            </button>
          </div>
          <!-- <div class="modal-footer py-2">
                    <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton" (click)="closepadinfo()"><b>{{lang?.Close}}</b></button>
                </div> -->
        </div>
      </div>
    </div>

    <!-- Signature Pad Modal -->
    <div id="signaturepad" class="modal fade modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <label>
              <span class="modal-title">{{lang?.Signature}}</span>
            </label>
            <!-- <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
                        (click)="closeSignaturePad()"></i> -->
          </div>
          <div class="modal-body">
            <div class="signature-container">
              <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
                (onEndEvent)="drawComplete()"></signature-pad>
            </div>
            <div class="buttons">
              <button class="btn btn-sm btn-light" id="cancelButton" (click)="clearSignature()">
                {{ lang?.Clear }}
              </button>
            </div>
            <!-- <div class="signature-image" *ngIf="signatureImg">
                        <img src='{{ signatureImg }}' />
                    </div> -->
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
              data-bs-target="#signedPad" id="updateButton" (click)="savePad()">
              {{lang?.Confirm}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Signed PAD Agreement -->
    <div id="signedPad" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{lang?.PAD_Agreement}}</span>
            <i #closeAgreement class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
          </div>
          <div class="modal-body">
            <div>
              <pdf-viewer *ngIf="true" [src]="signedPad" style="height: 400px; zoom: 0.85" view:fitH></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton"
              (click)="changeToPAD()">
              <b>{{lang?.Agree}}</b>
            </button>
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton"
              (click)="closepadinfo()">
              <b>{{lang?.Reject}}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Preview change PAD Agreement -->
    <div id="previewAgreement" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor" *ngIf="fubsillstatus?.toLowerCase() != 'draft'">
            <span class="modal-title">{{lang?.Preview}}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" data-bs-toggle="modal"
              data-bs-target="#updatePaymentMethodPAD"></i>
          </div>
          <div class="modal-body">
            <span *ngIf="showVoidCheque">
              <img src="../../../assets/img/tenor.gif" width="100" style="
                      display: block;
                      margin-left: auto;
                      margin-right: auto;
                      width: 25%;
                    " />
            </span>
            <div>
              <pdf-viewer *ngIf="true" [src]="voidCheque1" style="height: 400px; zoom: 0.85" view:fitH
                (after-load-complete)="showVoidCheque = false"></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button *ngIf="fubsillstatus?.toLowerCase() != 'draft'" type="button" class="btn btn-sm btn-light"
              data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#updatePaymentMethodPAD" id="cancelButton">
              <b>{{ lang?.Close }}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Preview update PAD Agreement -->
    <div id="updatepreviewAgreement" class="modal fade modalposition modal-lg" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header" id="backgroundColor">
            <span class="modal-title">{{lang?.Preview}}</span>
            <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" data-bs-toggle="modal"
              data-bs-target="#updatePADinfo"></i>
          </div>
          <div class="modal-body">
            <div *ngIf="
                    voidCheckFileType == 'image/jpeg' ||
                    voidCheckFileType == 'image/png'
                  ">
              <img [src]="voidCheckImage" />
            </div>
            <div *ngIf="voidCheckFileType == 'application/pdf'">
              <span *ngIf="showvoidCheque2">
                <img src="../../../assets/img/tenor.gif" width="100" style="
                        display: block;
                        margin-left: auto;
                        margin-right: auto;
                        width: 25%;
                      " />
              </span>
              <pdf-viewer [src]="voidCheque2" style="height: 400px; zoom: 0.85" view:fitH
                (after-load-complete)="showvoidCheque2 = false"></pdf-viewer>
            </div>
          </div>
          <div class="modal-footer py-2">
            <button *ngIf="existVoid" type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
              data-bs-toggle="modal" data-bs-target="#updatePADinfo" id="updateButton" (click)="uploadNewVoid()">
              <b>{{lang?.Upload}}</b>
            </button>
            <button *ngIf="existVoid" type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
              data-bs-toggle="modal" data-bs-target="#padAgreement" id="updateButton" (click)="updateCorporatePAD()">
              <b>{{lang?.Continue}}</b>
            </button>
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" data-bs-toggle="modal"
              data-bs-target="#updatePADinfo" id="cancelButton">
              <b>{{ lang?.Close }}</b>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Get plan Details -->
  </div>
  <!-- Valisign Modal -->
  <!-- <div id="valesign" class="modal fade modalposition" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <img src="/assets/img/valisign.png" class="align-items-center" id="valisign">
                  <i #closeAddressmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" (click)="closeValisign()"></i>
              </div>
              <div class="modal-body">
                  <form [formGroup]="valisignform">
                      <div>
                          <b>Please validate your transcation using Valisign code</b>
                      </div>
                      <div class="row">
                          <div class="col-md-12 form-group">
                              <label id="modal-labels">Please enter your Valisign code for release<span style="color: red">*</span></label>
                              <input type="text" formControlName="code" class="form-control" placeholder="Code">
                              <span id="valiSign" *ngIf="showTimer">(The Passcode valid for one minutes only){{displayTimer}}</span>
                              <span *ngIf="!showTimer"><a role="button" (click)="valisignModal()"><u>Regenerate Passcode</u></a></span>
                              <div *ngIf="valisignControls['code'].touched && valisignControls['code'].invalid" class="help-block text-danger">
                                  <div *ngIf="valisignControls['code'].errors && valisignControls['code'].errors['required']">Please enter valisign code</div>
                                  <div *ngIf="valisignControls['code'].errors && valisignControls['code'].errors['minlength']">Code minimum 6 characters</div>
                              </div>
                          </div>
                      </div>
                  </form>
              </div>
              <div class="modal-footer py-2">
                  <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="updateAddress()">{{lang?.Update}}</button>
                  <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton" (click)="closeValisign()"><b>{{lang?.Cancel}}</b></button>&nbsp;
              </div>
          </div>
      </div>
  </div> -->

  <div id="addPlanFormModal" class="modal modal-md fade" data-bs-backdrop="static" data-bs-keyboard="false"
    tabindex="-1" aria-hidden="true" style="max-width: 100%">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{lang?.Add_Plan}}</span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          <form [formGroup]="addPlanForm">
            <div class="row">
              <div class="col-6 form-group">
                <label id="modal-labels">{{lang?.Please_choose_Plan_Enrollment_Date}}<span
                    style="color: red">*</span></label>

                <select class="form-select border border-dark text-black" placeholder="Select"
                  formControlName="planEnrollmentDate">
                  <option value="null" label="" selected disabled>
                    {{lang?.Select}}
                  </option>
                  <option *ngFor="let name of planEnrollmentDates" [value]="name" [label]="name">
                    {{ name }}
                  </option>
                </select>
                <div class="help-block text-danger" *ngIf="addPlanForm.get('planEnrollmentDate')?.touched">
                  <div *ngIf="
                        addPlanForm
                          .get('planEnrollmentDate')
                          ?.hasError('required') ||
                        addPlanForm
                          .get('planEnrollmentDate')
                          ?.hasError('required')
                      ">
                    {{lang?.Please_Select_Date}}
                  </div>

                  <!-- <input type="text" formControlName="planEnrollmentDate" [minDate]="minAddPlanDate"
                bsDatepicker #dp *ngIf="true" value="{{planEnrollmentDate | date:'MM-dd-yyyy'}}"
                [(ngModel)]="planEnrollmentDate" placeholder="MM-DD-YYYY" [(bsValue)]="myDateValue"
                class="form-control">
              <div class="help-block text-danger"
                *ngIf="addPlanForm.get('planEnrollmentDate')?.touched ">
                <div *ngIf="addPlanForm.get('planEnrollmentDate')?.hasError('required') ||
                  (addPlanForm.get('planEnrollmentDate')?.hasError('required'))"> Please Select Date</div> -->
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
            <b>{{ lang?.Close }}</b></button>&nbsp;
          <button type="button" class="saveAndNext" (click)="getplansData()">
            {{lang?.Confirm}}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal modal-lg fade" id="planDetails" tabindex="-1" role="dialog" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-11 text-white text-center">{{lang?.Plans}}</div>
          <i (click)="closePlans()" class="bi bi-x-circle text-light" style="cursor: pointer" role="button"
            aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>

        <div class="modal-body">
          <div class="plansscreen">
            <div *ngFor="let package of specialpackages">
              <div class="d-flex gap-1" *ngIf="isGroupsNotEmpty(package.groups)">
                <span style="color: black">{{ package.name }}
                  <!-- <span title="Restricted"
                      *ngIf="package.restrictedAccess" class="ps-1">(R)</span>-->
                </span>
                <div *ngIf="role === 'ADMINISTRATOR'" title="{{
                      getTextForTooltip1(
                        package.published,
                        package.restrictedAccess
                      )
                    }}" [ngStyle]="{
                      'border-color': getColorForPlans1(
                        package.published,
                        package.restrictedAccess
                      )
                    }" class="outer my-auto col-2" data-bs-toggle="">
                  <span class="inner" [ngStyle]="{
                        background: getColorForPlans1(
                          package.published,
                          package.restrictedAccess
                        )
                      }"></span>
                </div>
              </div>

              <div *ngIf="displayPackage" [ngClass]="{ wraptext: displayPackage }" class="m-1 p-3">
                <div *ngFor="let groups of package.groups | keyvalue" class="d-flex gap-3 overflow-hidden">
                  <div *ngFor="let group of package.groups[groups.key]">
                    <div *ngFor="let plan of group.plans; let i = index" class="d-flex flex-wrap gap-3">
                      <div class="package-groups col-md-4 mt-2" *ngFor="
                            let product of plan.productAddonssNames;
                            let j = index
                          " title="">
                        <div (mouseover)="hoverStates[product] = true" (mouseout)="hoverStates[product] = false"
                          class="plantitle d-flex gap-3" [style.background-color]="
                              plan.isBundle == false
                                ? plan.productAddonss[product][0]?.planlevel
                                    ?.backgroundColor || '#5E172E'
                                : group.backgroundColor || '#5E172E'
                            ">
                          <span *ngIf="role === 'ADMINISTRATOR'" title="{{
                                getTextForTooltip(
                                  plan.published?.data[0],
                                  plan.restricted
                                )
                              }}" [ngStyle]="{
                                'border-color': getColorForPlans(
                                  plan.published?.data[0],
                                  plan.restricted,
                                  plan.name,
                                  plan
                                )
                              }" class="outer1 my-auto" data-bs-toggle="">
                            <span class="inner" [ngStyle]="{
                                  background: getColorForPlans(
                                    plan.published?.data[0],
                                    plan.restricted,
                                    plan.name,
                                    plan
                                  )
                                }"></span>
                          </span>
                          <span class="productname" [title]="product.length > 20 ? product : ''" [class.marquee]="
                                product.length > 20 && hoverStates[product]
                              ">{{
                            product.length > 20
                            ? hoverStates[product]
                            ? product
                            : (product | slice : 0 : 20) + "..."
                            : product
                            }}
                            <!-- <span title="Restricted" *ngIf="plan.restricted"
                                class="text-white pe-1">(R)</span> -->
                          </span>
                        </div>

                        <!-- <div *ngIf=" plan.isBundle==true;else planfeature">
                            <div class="planbody" *ngIf="group.planLevelFeatures">

                              <li class="featuutrebody"
                                *ngFor="let features of group.planLevelFeatures">
                                <strong>{{ features.feature.name }}</strong> <br />
                                <p [innerHTML]="features.description"></p>
                              </li>
                            </div>
                          </div> -->

                        <!-- <ng-template #planfeature>
                            <div class="planbody"
                              *ngIf="plan.productAddonss[product][0].planlevel.planLevelFeatures">

                              <li class="featuutrebody"
                                *ngFor="let features of plan.productAddonss[product][0].planlevel.planLevelFeatures">
                                <strong>{{ features.feature.name }}</strong> <br />
                                <p [innerHTML]="features.description"></p>
                              </li>
                            </div>

                          </ng-template> -->

                        <div class="plancoverage">
                          <li class="plansCoverageDetails" *ngFor="
                                let coverage of plan.productAddonss[product];
                                let k = index
                              ">
                            <div *ngIf="plan.insuranceType!='LIFE'" class="d-flex justify-content-between"
                              [style.color]="
                                  plan.isBundle == false
                                    ? plan.productAddonss[product][0]?.planlevel
                                        ?.backgroundColor || '#5E172E'
                                    : group.backgroundColor || '#5E172E'
                                " title="{{ coverage.planCoverageUI }}">
                              <div class="d-flex my-auto gap-1">
                                <div class="my-auto">
                                  <!-- id="plancheck{{
                                      plan.productAddonss[product][k].id
                                    }}" -->
                                  <!-- [checked]="coverage.selected" -->
                                  <!-- [disabled]="package.selectedPlansCount > 1" -->
                                  <input type="checkbox"
                                    id="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][k].planlevel.id }}"
                                    class="plancheckbox{{ package.id }} plancv  coverage{{coverage.planCoverageUI | uppercase}}"
                                    attr.data="{{ package?.name }}##{{
                                        group?.name
                                      }}##{{ plan?.planCoverage }}##{{
                                        plan?.productAddonss[product][k]
                                          ?.calculatedTax?.price
                                      }}##0##0##0##{{ plan?.id }}##{{
                                        plan?.fusebillId
                                      }}##{{ plan?.frqMonthly }}##{{
                                        package?.optIn
                                      }}##{{ group?.disallowedPlanLevels }}##{{
                                        group?.parentId
                                      }}##{{ group?.id }}##{{ plan?.name }}##{{
                                        plan?.planLevel
                                      }}##{{ plan?.packageId }}##0##{{
                                        plan?.planOptions
                                      }}##{{
                                        plan?.productAddonss[product][k]?.id
                                      }}" (change)="
                                        onCheckboxChange(
                                          $event,
                                          package?.allowMultiple,
                                          group?.disallowedPlanLevels,
                                          planlevel?.planOptions,
                                          group?.parentId,
                                          package?.name,
                                          group?.name,
                                          plan?.planCoverage,
                                          0,
                                          0,
                                          0,
                                          0,
                                          $event,
                                          i,
                                          j,
                                          k,
                                          plan,
                                          plan?.productAddonss[product][k],
                                          package,
                                          group
                                        )
                                      " />
                                </div>

                                <div style="margin-top: -1px">
                                  {{ coverage.planCoverageUI }}
                                  <span *ngIf="coverage?.status" style="font-size: 10px"
                                    title="{{ coverage.status }}">({{ coverage.status[0] }})</span>
                                </div>
                              </div>
                              <div class="" [style.color]="
                                    plan.isBundle == false
                                      ? plan.productAddonss[product][0]?.planlevel
                                          ?.backgroundColor || '#5E172E'
                                      : group.backgroundColor || '#5E172E'
                                  ">
                                {{ currencySymbol
                                }}{{ coverage.price | number : "1.2-2"
                                }}<small>*</small>
                              </div>
                            </div>
                            <div *ngIf="plan.insuranceType=='LIFE'">
                              <!-- Member -->
                              <div class="flex flex-col gap-2 text-xs mx-2 my-3">
                                <div style="display: flex;justify-content: space-between;color:black">
                                  <div class="font-semibold text-lg md:text-xl">
                                    {{lang.Total}}
                                  </div>
                                  <div class="text-end text-lg md:text-xl">
                                    <p class="text-end w-full outline-none">
                                      ${{
                                      allFormData[plan.planCoverage]?.total || 0
                                      | number : "1.2-2"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div style="display: flex;justify-content: space-between;color:black">

                                  <div class="col-span-3 flex gap-2 items-center">
                                    <input id="member" type="checkbox"
                                      attr.data="{{ package.name }}##{{ group.name }}##{{
                                                      plan.planCoverage
                                                    }}##{{
                                                      plan.productAddonss[product][k]?.calculatedTax.price
                                                    }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                      plan.frqMonthly
                                                    }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                      group.parentId
                                                    }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                      plan.packageId
                                                    }}##0##{{ plan.planOptions }}##{{
                                                      plan.productAddonss[product][k]?.id
                                                    }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}"
                                      name="{{ plan.planCoverage }}-member"
                                      id="planCheckLife{{ plan.planCoverage }}-MEMBER"
                                      class="w-6 h-6 my-auto flex-shrink-0 rounded cursor-pointer" (change)="
                                                                      onCheckboxChangeP(
                                                                        $event,
                                                                        plan.planCoverage,
                                                                        'member',
                                                                        'coverage',
                                                                        plan.productAddonss[product][k]
                                                                      )" />
                                    <label htmlFor="member"
                                      class="capitalize text-black w-full h-full label-text text-[12px]">
                                      {{lang.MEMBER}}
                                    </label>
                                  </div>
                                  <div class="col-span-1 text-black text-right font-semibold">
                                    <p class="bg-transparent text-end w-full h-full my-auto text-lg outline-none">
                                      ${{
                                      allFormData[ plan.planCoverage]?.member?.premium ||
                                      0 | number : "1.2-2"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="grid grid-cols-1 gap-2">
                                  <div class="col-span-1 text-base md:text-xl mt-3 text-[12px] text-black">
                                    <p>
                                      {{lang.In_the_last_12_months_have_you_used_in_any_form_whatsoever_tobacco_nicotine_or_cannabis_mixed_with_tobacco}}
                                    </p>

                                    <div class="grid grid-cols-3 mt-2">
                                      <div class="flex justify-center items-center gap-2">
                                        <input id="yes" type="radio" class="member-{{ plan.planCoverage }}-yes"
                                          name="member-{{ plan.planCoverage }}"
                                          attr.data="{{ package.name }}##{{ group.name }}##{{
                                                          plan.planCoverage
                                                        }}##{{
                                                          plan.productAddonss[product][k].calculatedTax.price
                                                        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                          plan.frqMonthly
                                                        }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                          group.parentId
                                                        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                          plan.packageId
                                                        }}##0##{{ plan.planOptions }}##{{
                                                          plan.productAddonss[product][k].id
                                                        }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}" [disabled]="
                                                                          isDataAvailable(plan.planCoverage, 'member')
                                                                        "
                                          class="w-6 h-6 my-auto outline-none cursor-pointer" [checked]="
                                                                          allFormData[plan.planCoverage] &&
                                                                          allFormData[plan.planCoverage]['member'] &&
                                                                          allFormData[plan.planCoverage]['member'][
                                                                            'isSmoker'
                                                                          ] === 'yes'
                                                                        " value="yes" (change)="
                                                                          handleRadioChange(
                                                                            $event,
                                                                            plan.planCoverage,
                                                                            'member',plan.planOptions,plan,
                                                                            plan.productAddonss[product][k],package,group,plan.productAddonss[product][k].member
                                                                          )
                                                                        " />
                                        <label htmlFor="yes" class="w-full mr-2 text-black text-[12px]">
                                          {{lang.Yes}}
                                        </label>
                                      </div>
                                      <div class="flex justify-center items-center gap-2">
                                        <input id="no" type="radio" value="no" name="member-{{ plan.planCoverage }}"
                                          class="member-{{ plan.planCoverage }}-no" attr.data="{{ package.name }}##{{ group.name }}##{{
                                  plan.planCoverage
                                }}##{{
                                  plan.productAddonss[product][k].calculatedTax.price
                                }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                  plan.frqMonthly
                                }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                  group.parentId
                                }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                  plan.packageId
                                }}##0##{{ plan.planOptions }}##{{
                                  plan.productAddonss[product][k].id
                                }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}" [disabled]="
                                                                          isDataAvailable(plan.planCoverage, 'member')
                                                                        "
                                          class="w-6 h-6 my-auto outline-none cursor-pointer" [checked]="
                                                                          allFormData[plan.planCoverage] &&
                                                                          allFormData[plan.planCoverage]['member'] &&
                                                                          allFormData[plan.planCoverage]['member'][
                                                                            'isSmoker'
                                                                          ] === 'no'
                                                                        " (change)="
                                                                        handleRadioChange(
                                                                            $event,
                                                                            plan.planCoverage,
                                                                            'member',plan.planOptions,plan,
                                                                            plan.productAddonss[product][k],package,group,plan.productAddonss[product][k].member
                                                                          )
                                                                        " />
                                        <label htmlFor="no" class="w-full mr-2 text-black text-[12px]">
                                          {{lang.No}}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="">
                                    <div className="my-5 ">
                                      <p htmlFor="rangeSlider"
                                        class="block my-3 text-center font-semibold mb-2 text-[12px]"
                                        style="color:white">
                                        <!-- ${{ plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence | number }} -->
                                        ${{ plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence/1000 |
                                        number }}k


                                      </p>
                                      <div className="relative">
                                        <div *ngIf="
                                                                          plan.productAddonss[product][k].member.maximumCoverageWithEvidence &&
                                                                          plan.productAddonss[product][k].member.minimumCoverage
                                                                        "
                                          class="range-ticks flex justify-between mt-2">

                                        </div>
                                        <div class="range-slider-container">
                                          <div class="range-slider-wrapper">
                                            <input type="range"
                                              attr.data="{{ package.name }}##{{ group.name }}##{{
                                                          plan.planCoverage
                                                        }}##{{
                                                          plan.productAddonss[product][k].calculatedTax.price
                                                        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                          plan.frqMonthly
                                                        }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                          group.parentId
                                                        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                          plan.packageId
                                                        }}##0##{{ plan.planOptions }}##{{
                                                          plan.productAddonss[product][k].id
                                                        }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}"
                                              [disabled]="
                                                                          isDataAvailable(plan.planCoverage, 'member','isSmoker')
                                                                        "
                                              id="{{ plan.planCoverage }}-member-rangeSlider" name="{{
                                                                          plan.planCoverage
                                                                        }}-member-rangeSlider"
                                              [(ngModel)]="plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence"
                                              [ngModelOptions]="{standalone: true}" (change)="
                                                                          handleRangeChange(
                                                                            $event,
                                                                            plan.planCoverage,
                                                                            'member',plan.planOptions,plan,
                                                                            plan.productAddonss[product][k],package,group,$event,plan.productAddonss[product][k].member
                                                                          )
                                                                        " [min]="0"
                                              [max]="plan.productAddonss[product][k].member.maximumCoverageWithEvidence"
                                              [step]="plan.productAddonss[product][k].member.minimumCoverage"
                                              style="width:100%" [ngStyle]="{
                                                  'background': getSliderBackground(
                                                    plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence,
                                                    plan.productAddonss[product][k].member.maximumCoverageWithEvidence,
                                                    plan.productAddonss[product][k].member.minimumCoverage,
                                                    plan.productAddonss[product][k].member.defaultRange
                                                  )
                                                }"
                                              class="my-2 border appearance-none w-full h-4 rounded-md focus:outline-none" />
                                            <p class="name-label leading-4 text-[10px]"
                                              [ngStyle]="{'width.%': greenValue}">{{lang.Guaranteed_Approval}}</p>


                                            <p *ngIf="showyellowbar" class="name-label leading-4  text-[10px]"
                                              [ngStyle]="{'right.%': 0}" style="top:-10px">
                                              {{lang.Pending_Approval}}</p>


                                            <div class="range-ticks1">
                                              <span *ngFor="let val of rangeValues" class="tick1"></span>
                                            </div>

                                          </div>
                                          <div class="range-labels">
                                            <span *ngFor="let val of rangeValues" class="range-label">${{ val/1000
                                              }}k</span>
                                          </div>

                                        </div>




                                      </div>

                                    </div>



                                    <br>
                                    <!-- } -->


                                  </div>
                                </div>
                              </div>


                              <!-- Spouse -->


                              <div class="flex flex-col gap-2 text-xs mx-2 my-3"
                                *ngIf="customerData.dependents?.spouseInfo">
                                <div class="grid grid-cols-4 gap-2 lg:gap-4 items-center justify-between">
                                  <div class="col-span-3 flex gap-2 items-center">
                                    <input id="spouse" type="checkbox"
                                      attr.data="{{ package.name }}##{{ group.name }}##{{
                                                      plan.planCoverage
                                                    }}##{{
                                                      plan.productAddonss[product][k].calculatedTax.price
                                                    }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                      plan.frqMonthly
                                                    }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                      group.parentId
                                                    }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                      plan.packageId
                                                    }}##0##{{ plan.planOptions }}##{{
                                                      plan.productAddonss[product][k].id
                                                    }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}"
                                      id="planCheckLife{{ plan.planCoverage }}-SPOUSE"
                                      name="{{ plan.planCoverage }}-spouse"
                                      class="w-6 h-6 my-auto flex-shrink-0 rounded cursor-pointer"
                                      [disabled]="
                                                                          isDataAvailableSpouse(plan.planCoverage, 'member')" (change)="
                                                                      onCheckboxChangeP(
                                                                        $event,
                                                                        plan.planCoverage,
                                                                        'spouse',
                                                                        'coverage',
                                                                        plan.productAddonss[product][k]
                                                                      )
                                                                    " />
                                    <label htmlFor="spouse"
                                      class="mr-2 lg:mr-2 font-bold capitalize text-black w-full h-full label-text text-[12px] mt-3">
                                      {{lang?.SPOUSE}}
                                    </label>
                                  </div>



                                  <div class="col-span-1 text-black text-right font-semibold">
                                    <p class="bg-transparent text-end w-full h-full my-auto text-lg outline-none">
                                      ${{
                                      allFormData[plan.planCoverage]?.spouse?.premium ||
                                      0 | number : "1.2-2"
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="grid grid-cols-1 gap-2">
                                  <div class="col-span-1 text-base md:text-xl mt-3 text-[12px] text-black">
                                    <p>
                                      {{lang.In_the_last_12_months_have_you_used_in_any_form_whatsoever_tobacco_nicotine_or_cannabis_mixed_with_tobacco}}

                                    </p>

                                    <div class="grid grid-cols-3 mt-2">
                                      <div class="flex justify-center items-center gap-2">
                                        <input id="yes" type="radio" class="spouse-{{ plan.planCoverage }}-yes"
                                          attr.data="{{ package.name }}##{{ group.name }}##{{
                                                          plan.planCoverage
                                                        }}##{{
                                                          plan.productAddonss[product][k].calculatedTax.price
                                                        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                          plan.frqMonthly
                                                        }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                          group.parentId
                                                        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                          plan.packageId
                                                        }}##0##{{ plan.planOptions }}##{{
                                                          plan.productAddonss[product][k].id
                                                        }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}"
                                          [disabled]="
                                                                          isDataAvailableSpouseDataa(plan.planCoverage, 'spouse')
                                                                        " value="yes"
                                          name="spouse-{{ plan.planCoverage}}"
                                          class="w-6 h-6 my-auto outline-none cursor-pointer" [checked]="
                                                                          allFormData[plan.planCoverage] &&
                                                                          allFormData[plan.planCoverage]['spouse'] &&
                                                                          allFormData[plan.planCoverage]['spouse'][
                                                                            'isSmoker'
                                                                          ] === 'yes'
                                                                        " (change)="
                                                                        handleRadioChange(
                                                                            $event,
                                                                            plan.planCoverage,
                                                                            'spouse',plan.planOptions,plan,
                                                                            plan.productAddonss[product][k],package,group,plan.productAddonss[product][k].spouse
                                                                          )
                                                                        " />
                                        <label htmlFor="yes" class="w-full mr-2 text-black text-[12px]">
                                          {{lang.Yes}}
                                        </label>
                                      </div>
                                      <div class="flex justify-center items-center gap-2">

                                        <input id="no" type="radio" value="no" class="spouse-{{ plan.planCoverage }}-no"
                                          attr.data="{{ package.name }}##{{ group.name }}##{{
                                                          plan.planCoverage
                                                        }}##{{
                                                          plan.productAddonss[product][k].calculatedTax.price
                                                        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                          plan.frqMonthly
                                                        }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                          group.parentId
                                                        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                          plan.packageId
                                                        }}##0##{{ plan.planOptions }}##{{
                                                          plan.productAddonss[product][k].id
                                                        }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}"
                                          [disabled]="
                                                                          isDataAvailableSpouseDataa(plan.planCoverage, 'spouse')
                                                                        " name="spouse-{{ plan.planCoverage }}"
                                          class="w-6 h-6 my-auto outline-none cursor-pointer" [checked]="
                                                                          allFormData[plan.planCoverage] &&
                                                                          allFormData[plan.planCoverage]['spouse'] &&
                                                                          allFormData[plan.planCoverage]['spouse'][
                                                                            'isSmoker'
                                                                          ] === 'no'
                                                                        " (change)="
                                                                        handleRadioChange(
                                                                            $event,
                                                                            plan.planCoverage,
                                                                            'spouse',plan.planOptions,plan,
                                                                            plan.productAddonss[product][k],package,group,plan.productAddonss[product][k].spouse
                                                                          )
                                                                        " />
                                        <label htmlFor="no" class="w-full mr-2 text-black text-[12px]">
                                          {{lang.No}}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="">
                                    <div className="my-5">
                                      <p class="block my-3 text-center mb-2 font-semibold text-[12px]"
                                        style="color:white">
                                        ${{ plan.productAddonss[product][k].spouse.maximumCoverageWithoutEvidence/1000 |
                                        number }}k
                                      </p>
                                      <div className="relative">
                                        <div *ngIf="
                                                                          plan.productAddonss[product][k].spouse.maximumCoverageWithEvidence &&
                                                                          plan.productAddonss[product][k].spouse.minimumCoverage
                                                                        "
                                          class="range-ticks flex justify-between mt-2">

                                        </div>
                                        <div class="range-slider-container">
                                          <div class="range-slider-wrapper">
                                            <input type="range" class="spouse-{{ plan.planCoverage }}-no"
                                              attr.data="{{ package.name }}##{{ group.name }}##{{
                                                          plan.planCoverage
                                                        }}##{{
                                                          plan.productAddonss[product][k].calculatedTax.price
                                                        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                                          plan.frqMonthly
                                                        }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{
                                                          group.parentId
                                                        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                                                          plan.packageId
                                                        }}##0##{{ plan.planOptions }}##{{
                                                          plan.productAddonss[product][k].id
                                                        }}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}" [disabled]="
                                                                          isDataAvailable(plan.planCoverage, 'spouse','isSmoker')
                                                                        "
                                              id="{{ plan.planCoverage }}-spouse-rangeSlider" name="{{
                                                                          plan.planCoverage
                                                                        }}-spouse-rangeSlider"
                                              [(ngModel)]="plan.productAddonss[product][k].spouse.maximumCoverageWithoutEvidence"
                                              (change)="
                                                                        handleRangeChange(
                                                                            $event,
                                                                            plan.planCoverage,
                                                                            'spouse',plan.planOptions,plan,
                                                                            plan.productAddonss[product][k],package,group,$event,plan.productAddonss[product][k].spouse
                                                                          )
                                                                        " [min]="0"
                                              [max]="plan.productAddonss[product][k].spouse.maximumCoverageWithEvidence"
                                              [step]="plan.productAddonss[product][k].spouse.minimumCoverage"
                                              style="width:100%" [ngStyle]="{
                                                                          background: getSliderBackground(
                                                                            plan.productAddonss[product][k].spouse.maximumCoverageWithoutEvidence,
                                                                            plan.productAddonss[product][k].spouse.maximumCoverageWithEvidence,
                                                                            plan.productAddonss[product][k].spouse.minimumCoverage,plan.productAddonss[product][k].member.defaultRange
                                                                          )
                                                                        }"
                                              class="my-2 border appearance-none w-full h-4 rounded-md focus:outline-none"
                                              style="background: #78aaef" />
                                            <p class="name-label leading-4 text-[10px]"
                                              [ngStyle]="{'width.%': greenValue}">{{lang.Guaranteed_Approval}}</p>


                                            <p *ngIf="showyellowbar" class="name-label leading-4  text-[10px]"
                                              [ngStyle]="{'right.%': 0}" style="top:-10px">
                                              {{lang.Pending_Approval}}</p>

                                            <div class="range-ticks1">
                                              <span *ngFor="let val of rangeValues" class="tick1"></span>
                                            </div>

                                          </div>
                                          <div class="range-labels">
                                            <span *ngFor="let val of rangeValues" class="range-label">${{ val/1000
                                              }}k</span>
                                          </div>

                                        </div>
                                      </div>
                                    </div>


                                  </div>

                                </div>
                              </div>








                            </div>
                            <!-- <span class="overflow-ellipsis2" style="float: right; color: white">
                  {{ currencySymbol}}{{ coverage.price | number:
                  "1.2-2"}}<small>*</small></span>
                <span class="overflow-ellipsis" style="float: left; color: white"
                  title={{coverage.planCoverageUI}}>
                  <span> <input type="checkbox" [disabled]="package.selected"
                      [checked]="coverage.selected"
                      id="plancheck{{ plan.productAddonss[product][k].id }}"
                      class="plancheckbox{{ package.id }} plancv"
                      attr.data="{{ package.name }}##{{ group.name }}##{{
                      plan.planCoverage
                      }}##{{plan.productAddonss[product][k].calculatedTax?.price}}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                      plan.frqMonthly
                      }}##{{ package.optIn }}##{{
                      group.disallowedPlanLevels
                      }}##{{ group.parentId }}##{{ group.id }}##{{
                      plan.name
                      }}##{{ plan.planLevel }}##{{ plan.packageId }}##0##{{plan.planOptions}}##{{plan.productAddonss[product][k].id}}" (change)="
                      onCheckboxChange(
                        $event,
                        package.allowMultiple,
                        group.disallowedPlanLevels,
                        plan.planOptions,
                        group.parentId,
                        package.name,
                        group.name,
                        plan.planCoverage,
                        0,
                        0,
                        0,
                        0,
                        $event,
                        i,
                        j,
                        k,
                        plan,
                        plan.productAddonss[product][k],package,group
                      )
                    "></span>


                  <span>{{coverage.planCoverageUI}}</span>
                </span><span class="clearfix"></span> -->
                          </li>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="text-danger" style="font-size: 12px" *ngIf="plansError">
            {{lang?.Kindly_ensure_that_you_have_added_a_plan}}
          </div>
          <button type="button" class="btn btn-secondary cancel-button" data-bs-dismiss="modal" (click)="closePlans()">
            {{lang?.Close}}
          </button>
          <button type="button" class="btn confirm" (click)="addPlansConfig()">
            {{lang?.Confirm}}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="showAddPlanDetails" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" id="modal-dialog" style="font-family: sans-serif">
      <div class="modal-content" id="modal-content">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{lang?.Add_Plan_Details}}</span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="model-body" style="font-family: sans-serif" style="font-size: 12px">
          <form class="onbordingform" [formGroup]="addplanFormDetails">
            <div>
              <div class="row p-2">
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Customer_Type}}: {{ customerType }}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.IGBMS_Id}}: {{ fusebillId }} </label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Plan_Enrollment_Date}}:
                    {{
                    addPlansConfigData?.enrollmentDate | date : "MM-dd-yyyy"
                    }}</label>
                </div>
                <!-- <div class="col-md-6 pt-2">
          <label>Termination Date: {{cancelPlanDetails?.terminationDate |date:"MM-
            dd-yyyy"}}</label>
        </div>
        <div class="col-md-6 pt-2">
          <label>Service Type:
            {{cancelPlanDetails?.serviceType=='NA'?"N/A":cancelPlanDetails?.serviceType
            |
            titlecase}}</label>
        </div> -->
              </div>

              <!-- plans -->
              <div class="table-responsive p-2" *ngIf="
                    addPlansConfigData && addPlansConfigData.newPlans.length > 0
                  ">
                <div class="fw-bold text-decoration-underline mb-2">
                  {{lang?.Plan_Details}}
                </div>

                <table class="table text-nowrap">
                  <thead>
                    <tr>
                      <!-- <th style="background: #5d7c9b !important;color:white">Package Name
                        </th> -->
                      <th style="background: #5d7c9b !important; color: white">
                        {{lang?.Plan}}
                      </th>
                      <th style="background: #5d7c9b !important; color: white">
                        {{lang?.Price}}
                      </th>
                      <!-- <th style="background: #5d7c9b !important;color:white">Coverage</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let plan of addPlansConfigData?.newPlans">
                      <!-- <td>{{plan.packagename}}</td> -->
                      <td>{{ plan.planproductname }}</td>
                      <td>${{ plan.planPrice | number : "1.2-2" }}</td>
                      <!-- <td>{{planCoverage}}</td> -->
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- tax -->
              <div class="table-responsive p-2" *ngIf="
                    addPlansConfigData &&
                    addPlansConfigData?.taxPlanDetails?.newTaxes.length > 0
                  ">
                <div class="fw-bold text-decoration-underline mb-2">
                  {{lang?.New_Taxes}}
                </div>

                <table class="table text-nowrap">
                  <thead>
                    <tr>
                      <th style="background: #5d7c9b !important; color: white">
                        {{lang?.Name}}
                      </th>

                      <th style="background: #5d7c9b !important; color: white">
                        {{lang?.Price}}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="
                          let tax of addPlansConfigData?.taxPlanDetails.newTaxes
                        ">
                      <td>{{ tax.name }}</td>
                      <td>${{ tax.price | number : "1.2-2" }}</td>
                      <!-- <td>{{planCoverage}}</td> -->
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="table-responsive p-2" *ngIf="
                    addPlansConfigData &&
                    addPlansConfigData?.coverageChangeSkipPlans.length > 0
                  ">
                <div class="fw-bold text-decoration-underline mb-2">Info</div>

                <table class="table text-wrap">
                  <thead>
                    <tr>
                      <th style="background: #5d7c9b !important; color: white">
                        {{lang?.Current_Plan}}
                      </th>
                      <th style="background: #5d7c9b !important; color: white">
                        {{lang?.New_Plan}}
                      </th>
                      <th style="background: #5d7c9b !important; color: white">
                        {{lang?.Warning}}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="
                          let planChange of addPlansConfigData?.coverageChangeSkipPlans;
                          let i = index
                        ">
                      <td>
                        {{ planChange.oldPlan.name }}
                        {{ planChange.oldPlan.planCoverage }}
                      </td>
                      <td>
                        {{ planChange.newPlan.name }}
                        {{ planChange.newPlan.planCoverage }}
                      </td>
                      <td [innerHtml]="warningsData[i]"></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="form-group col-12 col-md-12 p-3" id="box" *ngIf="addPlansConfigData?.terminateGreenshiled">
                <div class="col-12">
                  <label for="">
                    {{lang?.Proceed_With_Greenshield_Termination}}
                    <span class="text-danger">*</span></label>
                </div>

                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio"
                    name="proceedWithGreenshieldTermination" id="proceedWithGreenshieldTerminationYes" [value]="true"
                    formControlName="proceedWithGreenshieldTermination" />
                  <label class="form-check-label" for="proceedWithGreenshieldTerminationYes">
                    {{lang?.Yes}}</label>
                </div>
                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" [value]="false"
                    name="proceedWithGreenshieldTermination" id="proceedWithGreenshieldTerminationNo"
                    formControlName="proceedWithGreenshieldTermination" />
                  <label class="form-check-label" for="proceedWithGreenshieldTerminationNo">{{lang?.No}}</label>
                </div>
              </div>
              <div class="form-group col-12 col-md-12 p-3" id="box" *ngIf="addPlansConfigData?.greenshieldNewCustomer">
                <div class="col-12">
                  <label for="">
                    {{lang?.Proceed_With_Greenshield_Registraiton}}
                    <span class="text-danger">*</span></label>
                </div>

                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio"
                    name="proceedWithGreenshieldRegistration" id="proceedWithGreenshieldRegistrationYes" [value]="true"
                    formControlName="proceedWithGreenshieldRegistration" />
                  <label class="form-check-label" for="proceedWithGreenshieldRegistrationYes">
                    {{lang?.Yes}}</label>
                </div>
                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" [value]="false"
                    name="proceedWithGreenshieldRegistration" id="proceedWithGreenshieldRegistrationNo"
                    formControlName="proceedWithGreenshieldRegistration" />
                  <label class="form-check-label" for="proceedWithGreenshieldRegistrationNo">{{lang?.No}}</label>
                </div>
              </div>

              <div class="form-group col-12 col-md-12 p-3" id="box" *ngIf="addPlansConfigData?.terminateEquitable">
                <div class="col-12">
                  <label for="">
                    {{lang?.Proceed_With_Equitable_Termination}}<span class="text-danger">*</span></label>
                </div>

                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" name="proceedWithEquitableTermination"
                    id="proceedWithEquitableTerminationYes" [value]="true"
                    formControlName="proceedWithEquitableTermination" />
                  <label class="form-check-label" for="proceedWithEquitableTerminationYes">
                    {{lang?.Yes}}</label>
                </div>
                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" [value]="false"
                    name="proceedWithEquitableTermination" id="proceedWithEquitableTerminationNo"
                    formControlName="proceedWithEquitableTermination" />
                  <label class="form-check-label" for="proceedWithEquitableTerminationNo">{{lang?.No}}</label>
                </div>
              </div>
              <div class="form-group col-12 col-md-12 p-3" id="box" *ngIf="addPlansConfigData?.equitableNewCustomer">
                <div class="col-12">
                  <label for="">
                    {{lang?.Proceed_With_Equitable_Registraion}}<span class="text-danger">*</span></label>
                </div>

                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio"
                    name="proceedWithEquitableRegistration" id="proceedWithEquitableTerminationYes" [value]="true"
                    formControlName="proceedWithEquitableRegistration" />
                  <label class="form-check-label" for="proceedWithEquitableTerminationYes">
                    {{lang?.Yes}}</label>
                </div>
                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" [value]="false"
                    name="proceedWithEquitableRegistration" id="proceedWithEquitableTerminationNo"
                    formControlName="proceedWithEquitableRegistration" />
                  <label class="form-check-label" for="proceedWithEquitableTerminationNo">{{lang?.No}}</label>
                </div>
              </div>

              <!-- <div class="table-responsive  p-2"
            *ngIf="cancelPlanDetails?.serviceType!='NA'  && cancelPlanDetails?.terminationsProvisioning.length>0">

            <table class="table text-nowrap">
              <tr>
                <th class="my-auto text-light"
                  style="background: #5d7c9b !important;color:white; ">Service</th>
                <th style="background: #5d7c9b !important;color:white; ">Name</th>
                <th style="background: #5d7c9b !important;color:white; ">Policy</th>
                <th style="background: #5d7c9b !important;color:white;">Effective
                  Termination
                  Date
                </th>
                <th style=" background: #5d7c9b !important;color:white;">Membership
                  Id</th>
                <th style="background: #5d7c9b !important;color:white;">Action</th>
              </tr>
              <tbody>

                <tr class=" my-auto"
                  *ngFor="let item of cancelPlanDetails?.terminationsProvisioning">
                  <td>{{item?.serviceType}}</td>
                  <td>{{item?.service}}</td>
                  <td>{{item?.policy}}</td>
                  <td>{{item?.date}}<br><small>{{item.description}}</small></td>
                  <td>{{item?.membershipId}}</td>
                  <td>

                    <div class="form-group col-12 col-md-12" id="box"
                      *ngIf="item?.showEquitable">
                      <div class="col-12">
                        <label for=""> Proceed With Equitable<span
                            class="text-danger">*</span></label>
                      </div>

                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio"
                          name="proceedWithEquitable" id="proceedWithEquitableYes"
                          [value]=true formControlName="proceedWithEquitable" />
                        <label class="form-check-label" for="proceedWithEquitableYes">
                          Yes</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio"
                          [value]=false name="proceedWithEquitable"
                          id="proceedWithEquitableNo"
                          formControlName="proceedWithEquitable" />
                        <label class="form-check-label"
                          for="proceedWithEquitableNo">No</label>
                      </div>

                    </div>

                    <div class="form-group col-12 col-md-12" id="box"
                      *ngIf="item?.showSmartchoice">
                      <div class="col-12">
                        <label for=""> Proceed With Smartchoice<span
                            class="text-danger">*</span></label>
                      </div>

                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio"
                          name="proceedWithSmartchoice" id="proceedWithSmartchoiceYes"
                          [value]=true formControlName="proceedWithSmartchoice" />
                        <label class="form-check-label" for="proceedWithSmartchoiceYes">
                          Yes</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio"
                          [value]=false name="proceedWithSmartchoice"
                          id="proceedWithSmartchoiceNo"
                          formControlName="proceedWithSmartchoice" />
                        <label class="form-check-label"
                          for="proceedWithSmartchoiceNo">No</label>
                      </div>

                    </div>
                    <div class="form-group col-12 col-md-12" id="box"
                      *ngIf="item?.showGreenshield">
                      <div class="col-12">
                        <label for=""> Proceed With Greenshield<span
                            class="text-danger">*</span></label>
                      </div>

                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio"
                          name="proceedWithGreenshield" id="proceedWithGreenshieldYes"
                          [value]=true formControlName="proceedWithGreenshield" />
                        <label class="form-check-label" for="proceedWithGreenshieldYes">
                          Yes</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio"
                          [value]=false name="proceedWithGreenshield"
                          id="proceedWithGreenshieldNo"
                          formControlName="proceedWithGreenshield" />
                        <label class="form-check-label"
                          for="proceedWithGreenshieldNo">No</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div> -->
            </div>
          </form>
        </div>
        <div class="modal-footer py-2">
          <div class="text-danger" *ngIf="addPlansConfigData?.newPlans?.length <= 0">
            {{lang?.No_new_plans_added_Please_add_a_plan}}
          </div>
          <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
            {{lang?.Cancel}}
          </button>
          <button class="text-end" type="submit" class="saveAndNext"
            [disabled]="addPlansConfigData?.newPlans?.length <= 0" (click)="submitAddPlans()">
            {{lang?.Add_Plan}}&nbsp;&nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>

  <div id="cancelPlanFormModal" class="modal modal-md fade" data-bs-backdrop="static" data-bs-keyboard="false"
    tabindex="-1" aria-hidden="true" style="max-width: 100%">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{lang?.Cancel_Plan}} </span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          <form [formGroup]="cancelPlanForm">
            <div class="row">
              <div class="col-6 form-group">
                <label id="modal-labels">{{lang?.Please_choose_Plan_Termination_Date}}<span
                    style="color: red">*</span></label>

                <select class="form-select border border-dark text-black" placeholder="Select"
                  formControlName="terminationDate">
                  <option value="null" label="" selected disabled>
                    {{lang?.Select}}
                  </option>
                  <option *ngFor="let name of cancelPlanEnrollmentDates" [value]="name" [label]="name">
                    {{ name }}
                  </option>
                </select>
                <div class="help-block text-danger" *ngIf="cancelPlanForm.get('terminationDate')?.touched">
                  <div *ngIf="
                        cancelPlanForm
                          .get('terminationDate')
                          ?.hasError('required') ||
                        cancelPlanForm
                          .get('terminationDate')
                          ?.hasError('required')
                      ">
                    {{lang?.Please_Select_Date}}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
            <b>{{ lang?.Close }}</b></button>&nbsp;
          <button type="button" class="saveAndNext" (click)="deletePlan()">
            {{lang?.Confirm}}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="showCancelPlanDetails" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" id="modal-dialog" style="font-family: sans-serif">
      <div class="modal-content" id="modal-content">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{lang?.Cancel_Plan_Details}}</span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="model-body" style="font-family: sans-serif" style="font-size: 12px">
          <form class="onbordingform" [formGroup]="cancelplanFormDetails">
            <div>
              <div class="row p-2">
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Customer_Type}}: {{ cancelPlanDetails?.customerType }}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.IGBMS_Id}}: {{ fusebillId }} </label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Plan_Enrollment_Date}}:
                    {{
                    cancelPlanDetails?.enrollmentDate
                    | date : "MM-dd-yyyy"
                    }}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Termination_Date}}:
                    {{
                    cancelPlanDetails?.terminationDate
                    | date
                    : "MM-dd-yyyy"
                    }}</label>
                </div>
                <div class="col-md-6 pt-2" *ngIf="cancelPlanDetails?.serviceType">
                  <label>{{lang?.Service_Type}}:
                    {{
                    cancelPlanDetails?.serviceType == "NA"
                    ? "N/A"
                    : (cancelPlanDetails?.serviceType | titlecase)
                    }}</label>
                </div>

                <div class="col-md-6 pt-2">
                  <!-- <label>Monthly Premium:
                      {{cancelPlanDetails?.monthlyRecurringAmount==0?"$0":"$"+cancelPlanDetails?.monthlyRecurringAmount}}</label> -->
                </div>
              </div>
              <div class="row p-2" *ngIf="cancelPlanDetails?.taxPlanChangesInstaxAndDB">
                <div class="fw-bold text-decoration-underline mb-2">
                  {{lang?.Tax_Details}}
                </div>

                <div class="col-md-6 pt-2" *ngIf="cancelPlanDetails?.taxSubscriptionId">
                  <label>{{lang?.Subscription_ID}}: {{ cancelPlanDetails?.taxSubscriptionId }}
                  </label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Name}}: {{ taxEntries && taxEntries[0]?.plan }} </label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Price}}: ${{
                    taxEntries && taxEntries[0]?.price | number : "1.2-2"
                    }}
                  </label>
                </div>
              </div>

              <div class="table-responsive p-2" *ngIf="cancelPlanDetails?.plan">
                <div class="fw-bold text-decoration-underline mb-2">
                  {{lang?.Plan_Details}}
                </div>

                <table class="table text-nowrap">
                  <thead>
                    <tr>
                      <th style="background: #5d7c9b !important; color: white">
                        {{lang?.Subscription_ID}}
                      </th>
                      <th style="background: #5d7c9b !important; color: white">
                        {{lang?.Plan}}
                      </th>
                      <th style="background: #5d7c9b !important; color: white">
                        {{lang?.Coverage}}
                      </th>
                      <th style="background: #5d7c9b !important; color: white">
                        {{lang?.Price}}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ planSubscriptionId }}</td>
                      <td>{{ planName }}</td>
                      <td>{{ planCoverage }}</td>
                      <td>${{ planprice | number : "1.2-2" }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- <div class="table-responsive  p-2" *ngIf="cancelPlanDetails?.taxPlanChangesInstaxAndDB">
            <div class="fw-bold text-decoration-underline mb-2">Tax Details</div>
            <table class="table text-nowrap">
              <thead>
                <tr>
                  <th style="background: #5d7c9b !important;color:white">Subscription Id
                  </th>
                  <th style="background: #5d7c9b !important;color:white;">Tax Name</th>
                  <th style="background: #5d7c9b !important;color:white;">Price</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor=" let tax of getTaxEntries(cancelPlanDetails.taxDataChanges)">
                  <td>{{cancelPlanDetails?.taxSubscriptionId}}</td>
                  <td>{{tax.plan}}</td>
                  <td>${{tax.price}}</td>
                </tr>
              </tbody>
            </table>
          </div> -->

              <div class="table-responsive p-2" *ngIf="
                    cancelPlanDetails?.serviceType != 'NA' &&
                    cancelPlanDetails?.terminationsProvisioning?.length > 0
                  ">
                <table class="table text-nowrap">
                  <tr>
                    <th class="my-auto text-light" style="background: #5d7c9b !important; color: white">
                      {{lang?.Service}}
                    </th>
                    <th style="background: #5d7c9b !important; color: white">
                      {{lang?.Name}}
                    </th>
                    <th style="background: #5d7c9b !important; color: white">
                      {{lang?.Policy}}
                    </th>
                    <th style="background: #5d7c9b !important; color: white">
                      {{lang?.Effective_Termination_Date}}
                    </th>
                    <th style="background: #5d7c9b !important; color: white">
                      {{lang?.Membership_Id}}
                    </th>
                    <th style="background: #5d7c9b !important; color: white">
                      {{lang?.Action}}
                    </th>
                  </tr>
                  <tbody>
                    <tr class="my-auto" *ngFor="
                          let item of cancelPlanDetails?.terminationsProvisioning
                        ">
                      <td>{{ item?.serviceType }}</td>
                      <td>{{ item?.service }}</td>
                      <td>{{ item?.policy }}</td>
                      <td>
                        {{ item?.date }}<br /><small>{{
                          item.description
                          }}</small>
                      </td>
                      <td>{{ item?.membershipId }}</td>
                      <td>
                        <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showEquitable">
                          <div class="col-12">
                            <label for="">
                              {{lang?.Proceed_With_Equitable}}<span class="text-danger">*</span></label>
                          </div>

                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio" name="proceedWithEquitable"
                              id="proceedWithEquitableYes" [value]="true" formControlName="proceedWithEquitable" />
                            <label class="form-check-label" for="proceedWithEquitableYes">
                              {{lang?.Yes}}</label>
                          </div>
                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio" [value]="false"
                              name="proceedWithEquitable" id="proceedWithEquitableNo"
                              formControlName="proceedWithEquitable" />
                            <label class="form-check-label" for="proceedWithEquitableNo">{{lang?.No}}</label>
                          </div>
                        </div>

                        <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showSmartchoice">
                          <div class="col-12">
                            <label for="">
                              {{lang?.Proceed_With_Smartchoice}}<span class="text-danger">*</span></label>
                          </div>

                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio"
                              name="proceedWithSmartchoice" id="proceedWithSmartchoiceYes" [value]="true"
                              formControlName="proceedWithSmartchoice" />
                            <label class="form-check-label" for="proceedWithSmartchoiceYes">
                              {{lang?.Yes}}</label>
                          </div>
                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio" [value]="false"
                              name="proceedWithSmartchoice" id="proceedWithSmartchoiceNo"
                              formControlName="proceedWithSmartchoice" />
                            <label class="form-check-label" for="proceedWithSmartchoiceNo">{{lang?.No}}</label>
                          </div>
                        </div>
                        <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showGreenshield">
                          <div class="col-12">
                            <label for="">
                              {{lang?.Proceed_With_Greenshield}}<span class="text-danger">*</span></label>
                          </div>

                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio"
                              name="proceedWithGreenshield" id="proceedWithGreenshieldYes" [value]="true"
                              formControlName="proceedWithGreenshield" />
                            <label class="form-check-label" for="proceedWithGreenshieldYes">
                              {{lang?.Yes}}</label>
                          </div>
                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio" [value]="false"
                              name="proceedWithGreenshield" id="proceedWithGreenshieldNo"
                              formControlName="proceedWithGreenshield" />
                            <label class="form-check-label" for="proceedWithGreenshieldNo">{{lang?.No}}</label>
                          </div>
                        </div>
                        <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showPHR">
                          <div class="col-12">
                            <label for="">{{lang?.Proceed_With_PHR}}<span class="text-danger">*</span></label>
                          </div>

                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio" name="proceedWithPHR"
                              id="proceedWithPHRYes" [value]="true" formControlName="proceedWithPHR" />
                            <label class="form-check-label" for="proceedWithPHRYes">
                              {{lang?.Yes}}</label>
                          </div>
                          <div class="form-check form-check-inline col-3">
                            <input class="form-check-input border border-dark" type="radio" [value]="false"
                              name="proceedWithPHR" id="proceedWithPHRNo" formControlName="proceedWithPHR" />
                            <label class="form-check-label" for="proceedWithPHRNo">{{lang?.No}}</label>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- <div class="row pt-2">
            <div class="col-md-12">
              <label>Refund Details
              </label>
            </div>
            <div class="col-md-6 pt-2 ">
              <label>Refund Applicable:
                {{staxbillDetails?.refundApplicable==false?'No':'Yes'}}</label>
            </div>
            <div class="col-md-6 pt-2">
              <label>Payment Method:
                {{cancelPlanDetails?.paymentMethod}}</label>
            </div>
            <div class="col-md-6 pt-2 ">
              <label>Refund Actual Amount:
                {{staxbillDetails?.refundAmount=='NA'?"N/A":'$ '
                +staxbillDetails?.refundAmount}}</label>
            </div>
            <div class="col-md-6 pt-2 ">
              <label>Refund Based on Payments:
                $ {{cancelPlanDetails?.refundAmountbasedOnPayments}}</label>
            </div>

          </div> -->
            </div>

            <!-- <div class="row  px-2 mt-2" *ngIf="cancelPlanDetails?.invoiceAndRefunds.length>0">

            <table align="left">
              <tr>
                <th class="my-auto" style="background: #5d7c9b !important; ">Invoice Id</th>
                <th style="background: #5d7c9b !important; ">Invoice Number</th>
                <th class="text-center" style="background: #5d7c9b !important; ">Amount</th>
                <th style="background: #5d7c9b !important; ">Date</th>
                <th style="background: #5d7c9b !important; ">Payment Status</th>
                <th style="background: #5d7c9b !important; ">Refund Applicable</th>
              </tr>
              <tbody>
                <tr *ngFor="let invoice of cancelPlanDetails.invoiceAndRefunds">
                  <td>{{invoice.id}}</td>
                  <td>{{invoice.invoiceNumber}}</td>
                  <td class="text-center">$ {{invoice.invoiceAmount | number : "1.2-2"}}</td>
                  <td>{{invoice.postedTimestamp|date: 'MMM-DD-YYYY'}}</td>
                  <td>{{invoice?.paymentStatus}}</td>
                  <td>{{invoice?.refundApplicable ===false?'No':'Yes'}}</td>
                </tr>
              </tbody>
            </table>

          </div> -->

            <!-- table -->

            <!-- <div class="row" *ngIf="terminateReasonsApplicable">
            <div class="col-12 col-md-6 pb-2">
              <div class="form-group mt-2">
                <label for="Corporation">Reason</label>

                <select class="form-control select2" id="parentidrole" placeholder="Select"
                  formControlName="reason" data-live-search="true">
                  <option value="" label="" disabled>Select</option>
                  <option value="" *ngFor="let reson of terminateReasonsWithKeys"
                    [value]="reson.key">
                    {{reson.display}}</option>
                </select>

              </div>
            </div>
          </div> -->
          </form>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
            {{lang?.Cancel}}
          </button>
          <button class="text-end" type="submit" class="saveAndNext" (click)="submitDeletePlan()">
            {{lang?.Cancel_Plan}}&nbsp;&nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade modal-lg modalposition" data-bs-backdrop="static" id="videoform">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{ videoTitle }}</span>
          <i class="bi bi-x-circle closevideo" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body" id="video-modal-body">
          <video controls (canplay)="pauseVideo(videoplayer)" #videoPlayer>
            <source src="{{ videoLink }}" type="video/mp4" />

            {{lang?.Your_browser_does_not_support_the_video_tag}}
          </video>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
            <b class="closevideo">{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--  -->
  <div class="modal fade modal-lg modalposition" data-bs-backdrop="static" id="iframeform">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{ iframeTitle }}</span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          <!-- <iframe src="{{iframeLink | }}"></iframe> -->
          <!-- <iframe width="100%" [src]="iframeLink" id="pdf-viewer"></iframe> -->
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
            <b>{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--  -->
  <div class="modal fade modal-lg modalposition" data-bs-backdrop="static" id="equitable">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{ headerName }}</span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          <!-- <iframe src="{{iframeLink | }}"></iframe> -->
          <!-- <pdf-viewer [src]="booklet_link" id="pdf-viewer"></pdf-viewer> -->
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
            <b>{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--  -->
  <div class="modal fade modal-lg modalposition" data-bs-backdrop="static" id="support">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <h6 class="modal-title">{{ lang?.Student_VIP }}</h6>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body">
          <!-- <iframe [src]="support_link"  width="100%" id="pdf-viewer"></iframe> -->
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
            <b>{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div id="viewinvoice" class="modal fade modal-lg modalposition" tabindex="-1" role="dialog"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{lang?.View_Invoice}}</span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="closeBooklet()"></i>
        </div>
        <div class="modal-body">
          <!-- <div class="table-responsive" *ngIf="!hidebooklet">
                        <table class="table-striped" id="table">
                            <thead id="thead">
                                <tr>
                                    <th class="fw-normal">&nbsp;S.No</th>
                                    <th class="fw-normal">Name</th>
                                    <th class="fw-normal">Description</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let booklet of bookletList; let i=index">
                                    <td>&nbsp;{{i+1}}</td>
                                    <td>{{booklet.name}}</td>
                                    <td>{{booklet.description}}</td>
                                    <td id="booklet-td">
                                        <img role="button" src="/assets/img/view.png" alt="" width="20px" height="20px" class="m-1" (click)="viewBooklet(booklet.link)">
                                        <img role="button" src="/assets/img/download.png" alt="" id="img" (click)="downloadHpbooklet(booklet)">&nbsp;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->
          <!-- <div *ngIf="hidebooklet">
                        <pdf-viewer [src]="bookletLink" style="width: 100%; height: 400px;"></pdf-viewer>
                    </div> -->
          <!-- <span *ngIf="showViewPlansLoading">
            <img src="../../../assets/img/tenor.gif" width="100" style="
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                  width: 25%;
                " />
          </span> -->
          <div>
            <pdf-viewer *ngIf="true" [src]="invoiceslink" id="pdf-viewer"
              (after-load-complete)="viewPlansLoading($event)"></pdf-viewer>
          </div>
        </div>
        <div class="modal-footer py-2">
          <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeBooklet()" *ngIf="hidebooklet"><b>Back</b></button>&nbsp;&nbsp; -->
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
            (click)="closeInvoice()">
            <b>{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div id="viewinvoiceDraft" class="modal fade modal-xl modalposition" tabindex="-1" role="dialog"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{lang?.View_Draft_Invoice}}</span>

          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="closeBooklet()"></i>
        </div>
        <div class="modal-body">
          <div [innerHTML]="getCustomerDraftDetails"></div>
        </div>
        <div class="modal-footer py-2">
          <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeBooklet()" *ngIf="hidebooklet"><b>Back</b></button>&nbsp;&nbsp; -->
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
            (click)="closeInvoice()">
            <b>{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div id="viewinvoiceDraftIGBMS" class="modal fade modal-xl modalposition" tabindex="-1" role="dialog"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{lang?.View_Draft_Invoice}}</span>

          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="closeBooklet()"></i>
        </div>
        <div class="modal-body">
          <!-- <div [innerHTML]="getCustomerDraftDetails"></div> -->
          <div>
            <pdf-viewer *ngIf="true" [src]="invoiceslink" id="pdf-viewer"
              (after-load-complete)="viewPlansLoading($event)"></pdf-viewer>
          </div>
        </div>
        <div class="modal-footer py-2">
          <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" (click)="closeBooklet()" *ngIf="hidebooklet"><b>Back</b></button>&nbsp;&nbsp; -->
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton"
            (click)="closeInvoice()">
            <b>{{ lang?.Close }}</b>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade modal-lg modalposition" data-bs-backdrop="static" id="showplanoptions-modal"
    *ngIf="showoptions">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content1">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{lang?.Choose_Options}}</span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="model-body" style="
              max-width: 800px;

              overflow-y: scroll;
            ">
          <!--  -->
          <input type="hidden" id="plandetailsobj" value="{{ plandetailsobjvalue }}" />
          <input type="hidden" id="optionumber" value="{{ optionstitle.length }}" />

          <div *ngFor="let option of optionstitle; let i = index" style="max-height: 350px; overflow-y: scroll">
            <span></span>
            <span><b>{{ option.name }}</b><span style="color: red">*</span></span>

            <div *ngFor="
                  let optionvalue of option.planOptionsValues;
                  let j = index
                ">
              <div class="row">
                <div class="col-md-12" style="
                      border: 1px solid black;
                      padding: 5px 15px;
                      border-bottom: 1px !important;
                    ">
                  <input type="radio" value="{{ optionvalue.json }}"
                    id="planselectionvalue-{{ optionvalue.id }}-{{ option.id }}"
                    class="optionselectionmethod-{{ option.id }}" (click)="
                        planoptionselection(
                          $event,
                          optionvalue,
                          option.id,
                          optionvalue.id
                        )
                      " />&nbsp;{{ optionvalue.name }}
                </div>
              </div>
            </div>
            <br />
          </div>

          <!-- <p id="planoptionmessage">{{optionmessage}}</p> -->
        </div>

        <div class="modal-footer">
          <p id="planoptionmessage">
            <b>{{ optionmessage }}</b>
          </p>
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" (click)="closeoptionsselection()"
            id="cancelButton">
            <b>{{ lang?.Close }}</b>
          </button>

          <button type="button" class="btn btn-sm btn-light" (click)="confirmoptionsselection()">
            <b>{{lang?.Confirm}}</b>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- <div
      class="modal fade modal-md modalposition"
      id="showmemberlist"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        id="modal-dialog"
        style="font-family: sans-serif"
      > -->

  <div class="modal fade bd-example-modal-md" id="showmemberlist" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">{{lang?.Terminate}}&nbsp;&nbsp;<b>{{ emplomentFirstName }}&nbsp;{{ emplomentLastName
              }}</b></span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="model-body px-4 py-2">
          <form class="onbordingform" [formGroup]="terminationform">
            <div class="row">
              <div class="col-12 col-md-7">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">{{lang?.Please_choose_Termination_Date}}</label>
                  <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field"
                    formControlName="terminationDate" [minDate]="minDate" bsDatepicker
                    value="{{ terminationDateValue | date : 'MM-dd-YYYY' }}"
                    [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"
                    [(bsValue)]="terminationDateValue" [(ngModel)]="terminationDateValue" />
                  <div class="help-block text-danger" *ngIf="terminationform.get('terminationDate')?.touched">
                    <div *ngIf="
                          terminationform
                            .get('terminationDate')
                            ?.hasError('required') ||
                          terminationform
                            .get('terminationDate')
                            ?.hasError('required')
                        ">
                      {{lang?.Please_Select_Date}}
                    </div>
                  </div>
                </div>

                <p *ngIf="role === 'ADMINISTRATOR'" style="font-size: 10px">
                  {{lang?.Plan_enrollment_date_is}}-{{ enroll | date : "MM-dd-YYYY"
                  }}<br />{{ note }}
                </p>

                <!-- data-toggle="tooltip "
                  title="Note: Administrators can select a termination date up to 3 months in the past. However, if the plan's enrollment
                  date is in the past, the termination date can only be set up to the enrollment date. If the enrollment date is in the
                  future,today's date will be the earliest possible selection." -->
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
            (click)="closeTerminatePopup('showmemberlist')">
            {{lang?.Close}}
          </button>
          <button class="text-end" type="submit" class="btn btn-sm btn-light"  id="updateButton"
            (click)="submittermination()">
            {{lang?.Submit}}&nbsp;&nbsp;
          </button>
          
          <!-- <button type="button" class="btn btn-secondary btn-light" id="updateButton" (click)="submittermination()" ><b>Submit</b></button>&nbsp;&nbsp; -->
        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="showTerminateMemberDetails" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" id="modal-dialog" style="font-family: sans-serif">
      <div class="modal-content" id="modal-content">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title py-2">{{lang?.Terminate}}&nbsp;&nbsp;<b>{{ emplomentFirstName }}&nbsp;{{
              emplomentLastName }}</b></span>
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <div class="model-body px-4 py-2" style="font-family: sans-serif">
          <form class="onbordingform" [formGroup]="terminationformDetails">
            <div>
              <div class="row">
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Customer_Type}}:
                    {{ terminateMemberDetails?.customerType }}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.IGBMS_Id}}:
                    {{ terminateMemberDetails?.staxbillDetails?.id }}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Plan_Enrollment_Date}}:
                    {{ terminateMemberDetails?.enrollmentDate }}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Termination_Date}}:
                    {{ terminateMemberDetails?.terminationDate }}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Service_Type}}:
                    {{
                    terminateMemberDetails?.servicesType.length <= 0 ? "N/A" :
                      (terminateMemberDetails?.servicesType?.join(", ")
                            | titlecase)
                      }}</label
                    >
                  </div>
                  <div class=" col-md-6 pt-2">
                      <label>{{lang?.Monthly_Premium}}:
                        {{
                        terminateMemberDetails?.monthlyRecurringAmount == 0
                        ? "$0"
                        : "$" + terminateMemberDetails?.monthlyRecurringAmount
                        }}</label>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col-md-12">
                  <label>{{lang?.Refund_Details}}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Refund_Applicable}}:
                    {{
                    staxbillDetails?.refundApplicable == false ? " No" : "Yes"
                    }}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Payment_Method}}:
                    {{ terminateMemberDetails?.paymentMethod }}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Refund_Actual_Amount}}:
                    {{
                    staxbillDetails?.refundAmount == "NA"
                    ? "N/A"
                    : "$ " + staxbillDetails?.refundAmount
                    }}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang?.Refund_Based_on_Payments}}: $
                    {{
                    terminateMemberDetails?.refundAmountbasedOnPayments
                    }}</label>
                </div>
              </div>
            </div>

            <div class="row px-2 mt-2" *ngIf="terminateMemberDetails?.invoiceAndRefunds.length > 0">
              <table align="left">
                <tr>
                  <th class="my-auto" style="background: #5d7c9b !important">
                    {{lang?.Invoice_Id}}
                  </th>
                  <th style="background: #5d7c9b !important">{{lang?.Invoice_Number}}</th>
                  <th class="text-center" style="background: #5d7c9b !important">
                    {{lang?.Amount}}
                  </th>
                  <th style="background: #5d7c9b !important">{{lang?.Date}}</th>
                  <th style="background: #5d7c9b !important">{{lang?.Payment_Status}}</th>
                  <th style="background: #5d7c9b !important">
                    {{lang?.Refund_Applicable}}
                  </th>
                </tr>
                <tbody>
                  <tr style="background: white" *ngFor="
                        let invoice of terminateMemberDetails.invoiceAndRefunds
                      ">
                    <td>{{ invoice.id }}</td>
                    <td>{{ invoice.invoiceNumber }}</td>
                    <td class="text-center">
                      $ {{ invoice.invoiceAmount | number : "1.2-2" }}
                    </td>
                    <td>{{ invoice.postedTimestamp | date : "MM-dd-YYYY" }}</td>
                    <td>{{ invoice?.paymentStatus }}</td>
                    <td>
                      {{ invoice?.refundApplicable === false ? "No" : "Yes" }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Refund table -->
            <!-- <div class="row">
                <table align="left">
                  <tr>
                    <th>Refund Applicable</th>
                    <th>Refund Amount</th>
                    <th>Note</th>
                  </tr>
                  <tbody>
                    <tr>
                      <td>{{staxbillDetails?.refundApplicable==false?'None':staxbillDetails?.refundApplicable}}</td>
                      <td>{{staxbillDetails?.refundAmount=='NA'?"N/A":staxbillDetails?.refundAmount}}</td>
                      <td>{{staxbillDetails?.cancelCustomerNotes}}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">


                  <div class="form-group col-12 col-md-6" id="box">
                    <div class="col-12">
                      <label for=""> Proceed With Cancel Customer<span class="text-danger">*</span></label>
                    </div>

                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="proceedWithCancelCustomer"
                        id="proceedWithCancelCustomerYes" [value]=true formControlName="proceedWithCancelCustomer" />
                      <label class="form-check-label" for="proceedWithCancelCustomerYes">
                        Yes</label>
                    </div>
                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" [value]=false
                        name="proceedWithCancelCustomer" id="proceedWithCancelCustomerNo"
                        formControlName="proceedWithCancelCustomer" />
                      <label class="form-check-label" for="proceedWithCancelCustomerNo">No</label>
                    </div>

                  </div>
                </div>
                <div class="row" *ngIf="staxbillDetails?.refundApplicable">
                  <div class="form-group col-12 col-md-6" id="box">
                    <div class="col-12">
                      <label for=""> Proceed With Subscription Expiry<span class="text-danger">*</span></label>
                    </div>

                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="proceedWithSubscriptionExpiry"
                        id="proceedWithSubscriptionExpiryYes" [value]=true
                        formControlName="proceedWithSubscriptionExpiry" />
                      <label class="form-check-label" for="proceedWithSubscriptionExpiryYes">
                        Yes</label>
                    </div>
                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" [value]=false
                        name="proceedWithSubscriptionExpiry" id="proceedWithSubscriptionExpiryNo"
                        formControlName="proceedWithSubscriptionExpiry" />
                      <label class="form-check-label" for="proceedWithSubscriptionExpiryNo">No</label>
                    </div>

                  </div>


                </div>
                <div class="row" *ngIf="staxbillDetails?.refundApplicable">
                  <div class="form-group col-12 col-md-6" id="box">
                    <div class="col-12">
                      <label for=""> Proceed With Refund<span class="text-danger">*</span></label>
                    </div>

                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" name="proceedWithRefund"
                        id="proceedWithRefundYes" [value]=true formControlName="proceedWithRefund" />
                      <label class="form-check-label" for="proceedWithRefundYes">
                        Yes</label>
                    </div>
                    <div class="form-check form-check-inline col-3">
                      <input class="form-check-input border border-dark" type="radio" [value]=false name="proceedWithRefund"
                        id="proceedWithRefundNo" formControlName="proceedWithRefund" />
                      <label class="form-check-label" for="proceedWithRefundNo">No</label>
                    </div>

                  </div>
                </div>
              </div> -->

            <!-- table -->
            <div class="row px-2 mt-2" *ngIf="
                  terminateMemberDetails?.servicesType?.length > 0 &&
                  terminateMemberDetails?.terminationsProvisioning.length > 0
                ">
              <table align="left" style="background: #5d7c9b !important">
                <tr>
                  <th class="my-auto" style="background: #5d7c9b !important; color: white">
                    {{lang?.Service}}
                  </th>
                  <th style="background: #5d7c9b !important; color: white">
                    {{lang?.Name}}
                  </th>
                  <th style="background: #5d7c9b !important; color: white">
                    {{lang?.Policy}}
                  </th>
                  <th style="
                        width: 175px;
                        background: #5d7c9b !important;
                        color: white;
                      ">
                    {{lang?.Effective_Termination_Date}}
                  </th>
                  <th style="
                        width: 100px;
                        background: #5d7c9b !important;
                        color: white;
                      ">
                    {{lang?.Membership_Id}}
                  </th>
                  <th style="
                        width: 200px;
                        background: #5d7c9b !important;
                        color: white;
                      ">
                    {{lang?.Action}}
                  </th>
                </tr>
                <tbody>
                  <tr class="my-auto" style="background: white" *ngFor="
                        let item of terminationsProvisioning;
                        let index = index
                      ">
                    <td>{{ item?.serviceType }}</td>
                    <td>{{ item?.service }}</td>
                    <td>{{ item?.policy }}</td>
                    <td>
                      {{ item?.date }}<br /><small>{{
                        item.description
                        }}</small>
                    </td>
                    <td>{{ item?.membershipId }}</td>
                    <td>
                      <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showEquitable">
                        <div class="col-12">
                          <label for="">
                            {{lang?.Proceed_With_Equitable}}<span class="text-danger">*</span></label>
                        </div>

                        <div class="form-check form-check-inline col-3">
                          <input class="form-check-input border border-dark" type="radio" name="proceedWithEquitable"
                            id="proceedWithEquitableYes" [value]="true" formControlName="proceedWithEquitable" />
                          <label class="form-check-label" for="proceedWithEquitableYes">
                            {{lang?.Yes}}</label>
                        </div>
                        <div class="form-check form-check-inline col-3">
                          <input class="form-check-input border border-dark" type="radio" [value]="false"
                            name="proceedWithEquitable" id="proceedWithEquitableNo"
                            formControlName="proceedWithEquitable" />
                          <label class="form-check-label" for="proceedWithEquitableNo">{{lang?.No}}</label>
                        </div>
                      </div>

                      <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showSmartchoice">
                        <div class="col-12">
                          <label for="">
                            {{lang?.Proceed_With_Smartchoice}}<span class="text-danger">*</span></label>
                        </div>

                        <div class="form-check form-check-inline col-3">
                          <input class="form-check-input border border-dark" type="radio" name="proceedWithSmartchoice"
                            id="proceedWithSmartchoiceYes" [value]="true" formControlName="proceedWithSmartchoice" />
                          <label class="form-check-label" for="proceedWithSmartchoiceYes">
                            {{lang?.Yes}}</label>
                        </div>
                        <div class="form-check form-check-inline col-3">
                          <input class="form-check-input border border-dark" type="radio" [value]="false"
                            name="proceedWithSmartchoice" id="proceedWithSmartchoiceNo"
                            formControlName="proceedWithSmartchoice" />
                          <label class="form-check-label" for="proceedWithSmartchoiceNo">{{lang?.No}}</label>
                        </div>
                      </div>
                      <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showGreenshield">
                        <div class="col-12">
                          <label for="">
                            {{lang?.Proceed_With_Greenshield}}<span class="text-danger">*</span></label>
                        </div>

                        <div class="form-check form-check-inline col-3">
                          <input class="form-check-input border border-dark" type="radio" name="proceedWithGreenshield"
                            id="proceedWithGreenshieldYes" [value]="true" [disabled]="!item?.membershipId"
                            formControlName="proceedWithGreenshield" />
                          <label class="form-check-label" for="proceedWithGreenshieldYes">
                            {{lang?.Yes}}</label>
                        </div>
                        <div class="form-check form-check-inline col-3">
                          <input class="form-check-input border border-dark" type="radio" [value]="false"
                            name="proceedWithGreenshield" [disabled]="!item?.membershipId" id="proceedWithGreenshieldNo"
                            formControlName="proceedWithGreenshield" />
                          <label class="form-check-label" for="proceedWithGreenshieldNo">{{lang?.No}}</label>
                        </div>
                      </div>
                      <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showPHR">
                        <div class="col-12">
                          <label for="">
                            {{lang?.Proceed_With_PHR}}<span class="text-danger">*</span></label>
                        </div>
                        <div class="form-check form-check-inline col-3">
                          <input class="form-check-input border border-dark" type="radio" name="proceedWithPHR"
                            id="proceedWithPHRYes" [value]="true" [disabled]="!item?.membershipId"
                            formControlName="proceedWithPHR" />
                          <label class="form-check-label" for="proceedWithPHRYes">
                            {{lang?.Yes}}</label>
                        </div>
                        <div class="form-check form-check-inline col-3">
                          <input class="form-check-input border border-dark" type="radio" [value]="false"
                            name="proceedWithPHR" [disabled]="!item?.membershipId" id="proceedWithPHRNo"
                            formControlName="proceedWithPHR" />
                          <label class="form-check-label" for="proceedWithPHRNo">{{lang?.No}}</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row" *ngIf="terminateReasonsApplicable">
              <div class="col-12 col-md-6 pb-2">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">{{lang?.Reason}}</label>

                  <select class="form-control select2" id="parentidrole" placeholder="Select" formControlName="reason"
                    data-live-search="true">
                    <option value="" label="" disabled>{{lang?.Select}}</option>
                    <option value="" *ngFor="let reson of terminateReasonsWithKeys" [value]="reson.key">
                      {{ reson.display }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer py-2">
          <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
            (click)="closeModelPopup('showTerminateMemberDetails')">
            {{lang?.Cancel}}
          </button>
          
          <button class="text-end" type="submit" class="btn btn-sm btn-light"  id="updateButton"
          (click)="submitterminationEnd()">
          {{lang?.Terminate}}&nbsp;&nbsp;
        </button>
        
        </div>
      </div>
    </div>
  </div>


  <!-- Change Advisor Name -->
  <div id="changeAdvisor" class="modal modal-md fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true" style="max-width: 100%">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" id="backgroundColor">
          <span class="modal-title">Change Advisor</span>
          <i #closeExecutivesmodal class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
        <form class="onbordingform form-container linescrollbar" [formGroup]="brokerregform">

          <div class="modal-body">
            <div class="input-wrapper row">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">Brokers<span style="color: red">*</span></label>
                  <select class="form-control select2" id="parentidrole" placeholder="Select"
                    formControlName="brokerName" data-live-search="true" [(ngModel)]="ParentBrokerId"
                    (change)="getBrokerProfiles($event.target.value)">
                    <option value="" label="" disabled>Select</option>
                    <option *ngFor="let broker of allbrokerslist" [value]="broker.id">
                      {{ broker.name }}-{{ broker.brokerType }}-{{
                      broker.salesTrackingCode
                      }}
                    </option>
                  </select>

                  <div *ngIf="client['brokerName'].touched && client['brokerName'].invalid"
                    class="help-block text-danger">
                    <div *ngIf="client['brokerName'].errors && client['brokerName'].errors['required']">Please select
                      broker name</div>
                  </div>
                </div>

              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="Corporation">Select Profile<span style="color: red">*</span></label>
                  <!-- [(ngModel)]="profileid" -->
                  <select class="form-control select2" id="parentidrole" placeholder="Select" formControlName="profile"
                    data-live-search="true">
                    <option value="" disabled selected>Select</option>
                    <option *ngFor="let profile of brokerProfileslistSearch" [value]="profile?.originalBrokerId"
                      selected>

                      {{profile.name}}({{profile.additionalData.statement}})
                    </option>
                  </select>
                  <div *ngIf="
                  client['profile'].touched &&
                  client['profile'].invalid
                " class="help-block text-danger">
                    <div *ngIf="
                    client['profile'].errors &&
                    client['profile'].errors['required']
                  ">
                      <!-- {{lang.Please_select_profile}} -->
                      Please Select Profile
                    </div>
                  </div>


                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="Corporation">Effective Date<span style="color: red">*</span></label>
                  <!-- [(ngModel)]="profileid" -->
                  <input type="text" class="form-control border border-dark" id="childInfoDOB" placeholder="MM-DD-YYYY"
                    formControlName="effectiveDate" #dp
                    [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" placeholder="MM-DD-YYYY"
                    bsDatepicker (keypress)="numbersOnly($event)" (blur)="checkDateOfBirth($event)">
                  <div *ngIf="
                  client['effectiveDate'].touched &&
                  client['effectiveDate'].invalid
                " class="help-block text-danger">
                    <div *ngIf="
                    client['effectiveDate'].errors &&
                    client['effectiveDate'].errors['required']
                  ">
                      <!-- {{lang.Please_select_profile}} -->
                      Please Select Effective Date
                    </div>
                  </div>


                </div>
              </div>
            </div>



          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
              <b>{{ lang?.Close }}</b></button>&nbsp;
            <button type="button" class="btn btn-sm btn-light" id="updateButton" [disabled]="brokerregform.invalid"
              (click)="changeAdvisorData()">
              {{ lang?.Update }}
            </button>
            <!-- <button type="button" class="btn btn-sm btn-light" id="updateButton" data-bs-toggle="modal" data-bs-target="#valesign" data-bs-dismiss="modal" [disabled]="addressform.invalid" (click)="valisignModal()">{{lang?.Update}}</button> -->
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- <app-confirmation-dialog [message]="message">
          </app-confirmation-dialog> -->
  <app-header (userName)="(userName)"></app-header>
  <app-header></app-header>

  <app-invoice-module
  [finalinvoiceres]="selectedInvoice"
  [invoiceLink]="selectedInvoiceLink"
  [actionButtons]="actionButtonsList"
  [showModal]="showInvoiceModal"
></app-invoice-module>


  <!-- <app-welcome-bar *ngIf="false" [fusebillId]="fusebillId"></app-welcome-bar> -->
</main>
